var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g, _path75, _path76, _path77, _path78, _path79, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftSuper(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 102,
    viewBox: "0 0 103 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12_16505)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.7545 91.8555L88.7052 71.9141L89.227 28.0464L60.8937 42.8942L60.7545 91.8555Z",
    fill: "#F1C526"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M61.0504 55.1084V55.1604L61.0852 55.0911L61.0504 55.1084Z",
    fill: "url(#paint0_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M63.2072 53.7571L61.0504 58.1577V59.665L64.2855 53.0987L63.2072 53.7571Z",
    fill: "url(#paint1_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M66.4075 51.7647L61.0504 62.6623V64.1523L67.4859 51.089L66.4075 51.7647Z",
    fill: "url(#paint2_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M69.6078 49.7549L61.0504 67.1495V68.6568L70.6688 49.0966L69.6078 49.7549Z",
    fill: "url(#paint3_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M72.8081 47.7625L61.0504 71.6541V73.1441L73.8691 47.0869L72.8081 47.7625Z",
    fill: "url(#paint4_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M76.0085 45.7528L61.0504 76.1414V77.6487L77.0694 45.0945L76.0085 45.7528Z",
    fill: "url(#paint5_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M79.2088 43.7605L61.0504 80.6461V82.136L80.2698 43.0848L79.2088 43.7605Z",
    fill: "url(#paint6_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M82.4091 41.7508L61.0504 85.1334V86.6407L83.4701 41.0924L82.4091 41.7508Z",
    fill: "url(#paint7_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M85.6094 39.7583L61.0504 89.6379V90.8507L61.2417 90.7121L86.6704 39.0826L85.6094 39.7583Z",
    fill: "url(#paint8_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M64.6159 88.3904L88.6531 39.5677V38.0604L63.4854 89.1527L64.6159 88.3904Z",
    fill: "url(#paint9_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M67.9729 86.0514L88.6533 44.0548V42.5648L66.8423 86.831L67.9729 86.0514Z",
    fill: "url(#paint10_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M71.3296 83.7299L88.6531 48.5595V47.0522L70.2164 84.4923L71.3296 83.7299Z",
    fill: "url(#paint11_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M74.6866 81.3909L88.6532 53.0467V51.5567L73.5734 82.1705L74.6866 81.3909Z",
    fill: "url(#paint12_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M78.0435 79.0694L88.6533 57.5514V56.0441L76.9304 79.8491L78.0435 79.0694Z",
    fill: "url(#paint13_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M81.4179 76.7304L88.6535 62.0385V60.5485L80.2874 77.51L81.4179 76.7304Z",
    fill: "url(#paint14_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M84.7745 74.4089L88.6531 66.5432V65.0359L83.6439 75.1885L84.7745 74.4089Z",
    fill: "url(#paint15_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M88.1316 72.0699L88.6534 71.0304V69.5404L87.0184 72.8495L88.1316 72.0699Z",
    fill: "url(#paint16_linear_12_16505)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7321 36.6569L13.7757 83.1407L60.7544 91.8554L60.8936 42.894L12.7321 36.6569Z",
    fill: "#F1C526"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4415 54.4501L59.3283 54.2595L60.4415 55.3857V54.4501Z",
    fill: "url(#paint17_linear_12_16505)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4413 57.2395L57.0845 53.8957L55.9713 53.7225L60.4413 58.1751V57.2395Z",
    fill: "url(#paint18_linear_12_16505)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4417 60.0461L53.7279 53.3585L52.6148 53.1852L60.4417 60.9816V60.0461Z",
    fill: "url(#paint19_linear_12_16505)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4416 62.8529L50.371 52.8215L49.2578 52.6309L60.4416 63.7711V62.8529Z",
    fill: "url(#paint20_linear_12_16505)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4414 65.6423L47.014 52.2845L45.9008 52.0939L60.4414 66.5778V65.6423Z",
    fill: "url(#paint21_linear_12_16505)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4413 68.4491L43.657 51.7301L42.5438 51.5569L60.4413 69.3846V68.4491Z",
    fill: "url(#paint22_linear_12_16505)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4416 71.2383L40.3178 51.1929L39.1873 51.0023L60.4416 72.1739V71.2383Z",
    fill: "url(#paint23_linear_12_16505)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4415 74.045L36.9609 50.6385L35.8303 50.4653L60.4415 74.9806V74.045Z",
    fill: "url(#paint24_linear_12_16505)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4414 76.8345L33.6039 50.1015L32.4733 49.9283L60.4414 77.7701V76.8345Z",
    fill: "url(#paint25_linear_12_16505)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4413 79.641L30.2469 49.5642L29.1163 49.3737L60.4413 80.5765V79.641Z",
    fill: "url(#paint26_linear_12_16505)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4413 82.4478L26.89 49.0272L25.7769 48.8367L60.4413 83.366V82.4478Z",
    fill: "url(#paint27_linear_12_16505)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4417 85.2372L23.5335 48.4729L22.4204 48.2997L60.4417 86.1728V85.2372Z",
    fill: "url(#paint28_linear_12_16505)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4415 88.0437L20.1765 47.9356L19.0634 47.7451L60.4415 88.9793V88.0437Z",
    fill: "url(#paint29_linear_12_16505)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4414 91.5089V90.8332L16.8195 47.3813L15.7064 47.2081L60.1109 91.4396L60.4414 91.5089Z",
    fill: "url(#paint30_linear_12_16505)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6191 47.9357L56.7017 90.8505L57.8323 91.0411L13.6191 47.0002V47.9357Z",
    fill: "url(#paint31_linear_12_16505)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6193 50.7426L53.2756 90.2443L54.4235 90.4349L13.6193 49.807V50.7426Z",
    fill: "url(#paint32_linear_12_16505)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6193 53.5318L49.8665 89.6378L50.9971 89.8457L13.6193 52.6136V53.5318Z",
    fill: "url(#paint33_linear_12_16505)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6193 56.3386L46.4575 89.0315L47.588 89.2394L13.6193 55.4031V56.3386Z",
    fill: "url(#paint34_linear_12_16505)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6193 59.1452L43.031 88.425L44.179 88.6329L13.6193 58.2097V59.1452Z",
    fill: "url(#paint35_linear_12_16505)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6193 61.9347L39.622 87.8187L40.7525 88.0266L13.6193 60.9991V61.9347Z",
    fill: "url(#paint36_linear_12_16505)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6193 64.7412L36.1955 87.2295L37.3435 87.4201L13.6193 63.8057V64.7412Z",
    fill: "url(#paint37_linear_12_16505)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9171 86.8138L13.6193 66.5952V67.2708L13.6367 67.5307L32.7865 86.6232L33.9171 86.8138Z",
    fill: "url(#paint38_linear_12_16505)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5079 86.2246L13.654 69.4191V70.372L29.3773 86.0167L30.5079 86.2246Z",
    fill: "url(#paint39_linear_12_16505)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.099 85.6183L13.6715 72.2605L13.6889 73.1961L25.951 85.4104L27.099 85.6183Z",
    fill: "url(#paint40_linear_12_16505)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6724 85.0118L13.7061 75.0844L13.7235 76.02L22.5418 84.8039L23.6724 85.0118Z",
    fill: "url(#paint41_linear_12_16505)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2637 84.4056L13.7413 77.9086V78.8615L19.1157 84.215L20.2637 84.4056Z",
    fill: "url(#paint42_linear_12_16505)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8371 83.7992L13.7759 80.7327V81.6856L15.7065 83.6087L16.8371 83.7992Z",
    fill: "url(#paint43_linear_12_16505)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M49.7448 81.2177C49.1534 78.0472 46.9271 75.3791 44.9965 72.8149C42.9962 70.1468 37.2217 63.7018 35.552 62.2811C27.5512 55.455 13.1497 52.0592 13.1497 52.0592C13.1497 52.0592 13.7063 78.9481 13.7933 83.1581C17.8806 83.9205 21.9854 84.7347 26.0902 85.4278C29.7253 86.0515 33.3257 86.8831 36.9782 87.4721C38.8219 87.7667 40.6482 88.0439 42.4571 88.4597C43.7963 88.7715 45.64 89.1527 47.0488 88.8928C49.8839 88.3731 49.9709 84.7521 49.9013 82.5171C49.9013 82.084 49.8317 81.6508 49.7622 81.2177H49.7448Z",
    fill: "url(#paint44_linear_12_16505)"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.9634 50.396C58.6849 50.8292 53.7627 51.6608 48.8404 52.4231C51.9886 53.1334 55.1193 53.8784 58.2501 54.6234C59.1197 54.8313 60.3546 55.0912 60.7721 56.0614C61.0852 56.8064 60.8243 57.7766 60.8243 58.5736C60.8243 60.2715 60.8764 61.9867 60.8243 63.6845C60.8417 63.0262 61.0504 62.3158 61.2243 61.6921C61.7287 59.8903 62.1287 58.0192 62.8766 56.304C64.1637 53.3587 66.9118 51.5395 69.5034 49.807C74.2517 46.6191 86.8791 38.4762 89.175 37.0209L89.1402 33.885C86.1312 35.8081 63.4158 49.9456 60.9634 50.4134V50.396Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8936 42.8941L89.2269 28.0463L45.1354 23.1432L12.7321 36.657L60.8936 42.8941Z",
    fill: "#EBBF24"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M60.824 42.6342L89.5052 27.2147L47.1183 21.5667L12.0886 36.5011L60.824 42.6342Z",
    fill: "#F1C526"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M60.824 42.6342L89.5052 27.2147L47.1183 21.5667L12.0886 36.5011L60.824 42.6342Z",
    fill: "#F1C526"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M60.824 42.6342L89.5052 27.2147L47.1183 21.5667L12.0886 36.5011L60.824 42.6342Z",
    fill: "#F1C526"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M60.824 42.6342L89.5052 27.2147L47.1183 21.5667L12.0886 36.5011L60.824 42.6342Z",
    fill: "#F1C526"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0887 36.501L12.3496 46.7056L60.7893 54.1555L60.8241 42.6342L12.0887 36.501Z",
    fill: "#EBB503"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7892 54.1555L89.3486 36.4491L89.5052 27.2147L60.824 42.6342L60.7892 54.1555Z",
    fill: "#EBB503"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M60.7892 54.1555L89.3487 36.4491L89.5052 27.2147L61.5371 42.253C61.5371 42.253 60.8762 42.7035 60.824 43.3619C60.7718 44.0202 60.7892 54.1728 60.7892 54.1728V54.1555Z",
    fill: "url(#paint45_linear_12_16505)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M60.824 42.6342L89.5052 27.2147L47.1183 21.5667L12.0886 36.5011L60.824 42.6342Z",
    fill: "url(#paint46_linear_12_16505)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7892 54.1555L89.3487 36.4491L89.5052 27.2147L61.5371 42.253C61.5371 42.253 60.8762 42.7035 60.824 43.3619C60.7718 44.0202 60.7892 54.1728 60.7892 54.1728V54.1555Z",
    fill: "#F6BA00"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3724 24.1307C65.9724 24.3732 65.5724 24.6158 65.1897 24.841C61.8154 26.9027 58.4586 28.9471 55.0321 30.8875C49.5707 33.9888 43.9528 36.7955 38.4391 39.7928L59.45 42.4262C59.45 42.4262 60.8067 42.2529 60.8067 44.1934C60.8067 46.7922 60.8067 54.1381 60.8067 54.1381L89.3661 36.4316L89.5226 27.1972L66.3898 24.1133L66.3724 24.1307Z",
    fill: "url(#paint47_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M60.8068 44.7306C60.772 45.4929 60.772 46.2379 60.772 47.0002C62.5635 45.8048 84.8266 33.9716 89.4358 31.5807L89.5054 27.2147L88.2531 27.0414C82.7916 29.2071 62.0243 39.3251 57.0151 42.0452C58.9805 42.1318 60.8937 42.2877 60.8242 44.7306H60.8068Z",
    fill: "url(#paint48_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M18.5415 33.7811L12.0886 36.5011L12.3495 40.0875L60.7893 46.879C60.7893 45.7702 60.6501 44.9905 60.7893 43.5352C60.8762 42.4264 61.7459 42.0972 62.6677 41.6121C63.6591 41.075 64.6331 40.5206 65.6245 39.9835C65.9028 39.8276 66.7725 39.1173 67.1203 39.1692L18.5415 33.7811Z",
    fill: "url(#paint49_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M61.4329 44.5574C61.7808 43.0154 62.633 41.768 64.3027 41.1096C63.207 41.5428 62.1634 42.2184 60.9981 42.4263C59.8153 42.6516 58.5109 42.3744 57.3107 42.4263C58.3021 42.5649 59.3979 42.4956 59.9719 43.5178C60.3893 44.2628 60.9111 54.0516 60.9111 54.0516C60.9111 54.0516 61.2242 45.6142 61.4677 44.54L61.4329 44.5574Z",
    fill: "url(#paint50_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M76.3562 34.5952C74.6517 35.2882 68.425 38.6147 66.9987 39.5329C71.2948 38.2508 75.0517 35.652 76.391 34.6818C76.4432 34.6472 76.391 34.5779 76.3388 34.5952H76.3562Z",
    fill: "url(#paint51_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M89.1924 27.8385C87.4879 28.5315 81.2611 31.858 79.8349 32.7762C84.131 31.4941 87.8879 28.8953 89.2272 27.9251C89.2793 27.8905 89.2272 27.8212 89.175 27.8385H89.1924Z",
    fill: "url(#paint52_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M30.2472 38.4936C28.4557 38.0778 21.4463 37.2115 19.7418 37.1422C23.9857 38.5629 28.5601 38.6149 30.2298 38.5802C30.2994 38.5802 30.2994 38.4936 30.2298 38.4763L30.2472 38.4936Z",
    fill: "url(#paint53_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M62.1982 53.3412C62.5982 53.0294 62.9983 52.7175 63.4331 52.4576V41.6813L61.3459 42.7728L58.4587 42.3916V53.7917C59.8501 53.9476 60.9981 54.2595 62.1982 53.3412Z",
    fill: "url(#paint54_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8487 21.4974L45.8481 22.5542C44.7871 22.97 43.7261 23.3685 42.6478 23.7497L53.3097 21.8785C52.8227 21.7746 52.3357 21.636 51.8487 21.4974Z",
    fill: "url(#paint55_linear_12_16505)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4496 22.7276C57.1887 22.6583 56.9278 22.6063 56.6843 22.5543L35.9517 26.21C35.6213 26.3312 35.2908 26.4698 34.9429 26.6084C34.5951 26.8163 34.2472 27.0069 33.8994 27.2148L58.2497 22.9182C57.9888 22.8489 57.7105 22.7969 57.4496 22.7276Z",
    fill: "url(#paint56_linear_12_16505)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4844 23.611L30.3334 29.1031C29.655 29.4497 28.9593 29.7788 28.2636 30.108L63.2063 23.9575C62.6323 23.8536 62.0583 23.7323 61.4844 23.6283V23.611Z",
    fill: "url(#paint57_linear_12_16505)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8072 24.7893C68.181 24.72 67.5723 24.6334 66.9461 24.5468L23.3243 32.2219C22.3503 32.6203 21.3589 33.0015 20.3675 33.3827L69.0159 24.8066C69.0159 24.8066 68.8594 24.8066 68.7898 24.772L68.8072 24.7893Z",
    fill: "url(#paint58_linear_12_16505)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3293 25.3436L14.3841 35.7214C14.1058 35.8774 13.8275 36.0506 13.5667 36.2239C13.9319 36.2412 14.3146 36.2758 14.6798 36.3105L75.3817 25.6208C74.7033 25.5168 74.0076 25.4302 73.3293 25.3436Z",
    fill: "url(#paint59_linear_12_16505)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3212 26.4352C79.9385 26.3659 79.5559 26.2793 79.1732 26.21L19.6889 36.6918C20.5063 36.7611 21.3064 36.8304 22.1239 36.8997L80.8777 26.5565C80.6864 26.5218 80.5125 26.4872 80.3212 26.4352Z",
    fill: "url(#paint60_linear_12_16505)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2001 27.2321L26.8029 37.35C27.5508 37.4193 28.2987 37.506 29.0466 37.5926L85.835 27.5959C85.2958 27.4746 84.7392 27.3707 84.2001 27.2494V27.2321Z",
    fill: "url(#paint61_linear_12_16505)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3653 28.9299L33.3252 38.095C34.0035 38.1816 34.6818 38.2856 35.3602 38.3722L83.8695 29.8308C84.3739 29.5363 84.8609 29.2245 85.3653 28.9299Z",
    fill: "url(#paint62_linear_12_16505)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8604 31.6328L39.2561 38.9614C39.8823 39.0654 40.491 39.1693 41.0998 39.2733L79.3298 32.5337C79.8342 32.2392 80.356 31.9273 80.8604 31.6328Z",
    fill: "url(#paint63_linear_12_16505)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2862 34.3528L44.6656 39.9315C45.2569 40.0528 45.8483 40.1568 46.4049 40.2607L74.7208 35.271C75.2426 34.9592 75.7644 34.6646 76.2688 34.3528H76.2862Z",
    fill: "url(#paint64_linear_12_16505)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6075 37.0729L50.1096 40.8498C50.8401 40.9538 51.588 41.0404 52.3185 41.0924L69.9899 37.9738C70.5291 37.662 71.0509 37.3675 71.5901 37.0556L71.6075 37.0729Z",
    fill: "url(#paint65_linear_12_16505)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8068 39.8276L58.1277 41.3522C58.7886 41.4215 59.467 41.5081 60.1105 41.6467L65.1545 40.7631C65.7111 40.4513 66.2503 40.1568 66.8068 39.8449V39.8276Z",
    fill: "url(#paint66_linear_12_16505)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7022 44.5226L59.0672 42.894L57.9888 42.7554L60.7022 45.4581V44.5226Z",
    fill: "url(#paint67_linear_12_16505)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7196 47.3293L55.8322 42.4783L54.7538 42.3397L60.7196 48.2822V47.3293Z",
    fill: "url(#paint68_linear_12_16505)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7373 50.1534L52.6147 42.0625L51.5363 41.9239L60.7373 51.1063V50.1534Z",
    fill: "url(#paint69_linear_12_16505)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7543 52.9775L49.3792 41.6467L48.3008 41.5081L60.7717 53.913L60.7543 52.9775Z",
    fill: "url(#paint70_linear_12_16505)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0658 41.0922L57.8149 53.7743L58.9281 53.9475L46.1442 41.2308L45.0658 41.0922Z",
    fill: "url(#paint71_linear_12_16505)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8483 40.6591L54.4931 53.2546L55.5889 53.4278L42.9267 40.7977L41.8483 40.6591Z",
    fill: "url(#paint72_linear_12_16505)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6133 40.2433L51.1537 52.7522L52.2669 52.9254L39.6917 40.3819L38.6133 40.2433Z",
    fill: "url(#paint73_linear_12_16505)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3778 39.8276L47.8312 52.2325L48.9444 52.4058L36.4561 39.9662L35.3778 39.8276Z",
    fill: "url(#paint74_linear_12_16505)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1603 39.4116L44.5094 51.7125L45.6226 51.8858L33.2387 39.5502L32.1603 39.4116Z",
    fill: "url(#paint75_linear_12_16505)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9253 38.9958L41.17 51.1929L42.2831 51.3661L30.0036 39.1345L28.9253 38.9958Z",
    fill: "url(#paint76_linear_12_16505)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6902 38.5801L37.848 50.6905L38.9612 50.8637L26.7686 38.7187L25.6902 38.5801Z",
    fill: "url(#paint77_linear_12_16505)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4723 38.1643L34.5257 50.1707L35.6215 50.344L23.5507 38.3029L22.4723 38.1643Z",
    fill: "url(#paint78_linear_12_16505)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2373 37.7484L31.1863 49.6508L32.2995 49.8241L20.3156 37.887L19.2373 37.7484Z",
    fill: "url(#paint79_linear_12_16505)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0022 37.3326L27.8643 49.1311L28.9775 49.3044L17.0806 37.4712L16.0022 37.3326Z",
    fill: "url(#paint80_linear_12_16505)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7843 36.9168L24.542 48.6114L25.6378 48.7846L13.8627 37.0554L12.7843 36.9168Z",
    fill: "url(#paint81_linear_12_16505)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2104 39.1345L21.2026 48.109L22.3158 48.2823L12.193 38.1816L12.2104 39.1345Z",
    fill: "url(#paint82_linear_12_16505)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M12.245 41.9757L17.8804 47.5891L18.9935 47.7624L12.2276 41.0402L12.245 41.9757Z",
    fill: "url(#paint83_linear_12_16505)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2972 44.8345L14.5583 47.0695L15.6541 47.2428L12.2798 43.8817L12.2972 44.8345Z",
    fill: "url(#paint84_linear_12_16505)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M58.0064 53.9822V91.3529L60.7545 91.8554L62.9808 90.2614C62.9808 90.2614 62.9808 54.2248 62.9808 52.96C61.3807 53.5144 61.5894 54.45 58.0064 53.9822Z",
    fill: "url(#paint85_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M62.8936 42.5649L61.4847 45.4062V46.8962L63.8502 42.0971C63.5371 42.253 63.2067 42.409 62.8936 42.5476V42.5649Z",
    fill: "url(#paint86_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M65.8156 41.1095L61.4847 49.8935V51.3834L66.807 40.5724C66.4766 40.7457 66.1461 40.919 65.8156 41.0922V41.1095Z",
    fill: "url(#paint87_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M62.9283 52.9602L69.7638 39.1C69.4334 39.2559 69.1029 39.4292 68.7898 39.5851L61.8326 53.7052C62.1978 53.4453 62.5631 53.2028 62.9457 52.9602H62.9283Z",
    fill: "url(#paint88_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M66.1637 50.8811L72.6687 37.6619C72.3382 37.8179 72.0252 37.9911 71.6947 38.147L65.1027 51.5568C65.4506 51.3316 65.8158 51.1064 66.1637 50.8811Z",
    fill: "url(#paint89_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M69.329 48.958L75.6427 36.1373C75.3122 36.3278 74.9817 36.5011 74.6339 36.6744L68.268 49.5817C68.6159 49.3738 68.9637 49.1486 69.3116 48.9407L69.329 48.958Z",
    fill: "url(#paint90_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M72.4773 47.0696L78.7562 34.3354C78.4084 34.5434 78.0605 34.7513 77.7126 34.9592L71.4337 47.7106C71.7816 47.5027 72.1295 47.2948 72.4773 47.0869V47.0696Z",
    fill: "url(#paint91_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M75.6429 45.1118L81.8696 32.4816C81.5218 32.6895 81.1739 32.8801 80.8261 33.088L74.5819 45.7875C74.9298 45.5622 75.2951 45.3543 75.6429 45.1291V45.1118Z",
    fill: "url(#paint92_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M78.9298 42.9288L84.9304 30.7491C84.7043 30.8704 84.4782 30.9916 84.2521 31.1129C84.1477 31.1822 84.026 31.2342 83.9216 31.3035L77.834 43.6738C78.1993 43.4312 78.5819 43.1713 78.9472 42.9115L78.9298 42.9288Z",
    fill: "url(#paint93_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M81.5217 41.0923C81.7999 40.8844 82.0782 40.6765 82.3565 40.4686L88.0962 28.8087C87.731 29.0685 87.3657 29.3111 87.0005 29.5536L81.2086 41.3175C81.3129 41.2482 81.4173 41.1789 81.5217 41.0923Z",
    fill: "url(#paint94_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M85.6786 38.2338L89.0876 31.3036V29.8137L84.6002 38.9094C84.9481 38.6842 85.3133 38.4417 85.6786 38.2338Z",
    fill: "url(#paint95_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M88.6699 36.6397L89.0874 35.7907V34.2834L87.7133 37.0728C88.0264 36.9169 88.3569 36.761 88.6699 36.6224V36.6397Z",
    fill: "url(#paint96_linear_12_16505)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M57.6412 22.866L29.7775 38.4588C29.5166 38.6147 29.2905 38.9439 29.2209 39.2558L29.2731 85.9128C29.2731 85.9128 38.5958 87.8186 39.0828 87.8706C39.7437 73.4559 39.4828 64.1176 39.5176 52.9081C39.5176 52.4403 40.0916 51.3835 40.909 51.4355C43.3093 51.5741 46.2661 51.8166 46.2661 51.8166C46.2661 51.8166 39.5002 50.8811 39.5002 50.5172C39.535 45.1464 39.535 40.6245 39.535 40.6245C39.6046 40.2953 39.6915 39.9141 39.9524 39.7582C39.9524 39.7582 50.51 33.729 65.7985 23.8882C65.2767 23.8016 57.6412 22.8834 57.6412 22.8834V22.866Z",
    fill: "#242468"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3466 36.3451C69.3466 36.3451 69.5032 36.2238 69.6075 36.1719C72.0078 34.9244 74.3211 33.5038 76.6517 32.1351L34.6127 26.7642L25.2204 30.7664L69.2249 36.3971C69.2249 36.3971 69.3119 36.3624 69.364 36.3451H69.3466Z",
    fill: "url(#paint97_linear_12_16505)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M79.9218 32.3949C78.7738 32.0484 35.0302 26.7296 35.0302 26.7296L26.2293 30.4891L70.9469 36.1025C71.6948 36.4491 72.1818 37.1074 72.147 38.3548C72.147 38.7533 72.0949 52.0072 72.0775 64.1176C72.0775 65.2264 72.0775 66.3179 72.0775 67.3921C72.0775 67.4787 72.0775 67.5826 72.0775 67.6693C72.0775 68.2237 72.0775 68.7781 72.0775 69.3325C72.0775 69.6444 72.0775 69.9735 72.0775 70.2854C72.0775 70.5279 72.0775 70.7705 72.0775 70.9957V71.7061C72.0775 75.1018 72.0775 78.0991 72.0601 80.2821V80.542C72.0601 81.6854 72.0601 82.569 72.0601 83.1408C72.0601 83.4353 72.0601 83.6432 72.0601 83.7645V83.8858L81.0697 77.4234C81.0697 70.8571 81.261 53.8956 81.2784 43.2406C81.2784 43.0673 81.5219 42.357 81.7828 42.1318C82.722 41.2482 84.6875 39.4983 84.6875 39.4983C84.6875 39.4983 81.1393 41.8026 81.1567 41.6466C81.1567 38.5281 81.1567 36.1025 81.1567 34.9071C81.1567 34.37 81.1219 32.7761 79.9913 32.4296L79.9218 32.3949Z",
    fill: "#242468"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M79.643 32.5161L34.7689 26.8507L25.4462 30.8182L70.3203 36.5356C71.0682 36.8821 71.5552 37.5404 71.5204 38.7878C71.4857 39.5328 71.3987 84.3188 71.3987 84.3188L80.7214 77.6658C80.7214 67.8251 80.8257 35.4267 80.8431 34.7857C80.8779 33.521 80.3909 32.8799 79.643 32.5334V32.5161Z",
    fill: "url(#paint98_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M71.5205 38.7878C71.5205 38.9437 71.5206 41.144 71.4858 44.4705C71.6597 43.0152 71.8684 40.0872 72.1119 39.706C72.4946 39.9832 72.3554 40.7455 72.6511 41.0747C72.7902 40.2258 72.7033 39.3768 72.7903 38.5452C72.8424 38.1467 72.999 37.4537 73.5034 37.7829C73.9556 38.0948 73.8686 39.013 74.1817 39.4288C74.2513 39.013 73.886 36.4142 74.9122 37.0033C75.2253 37.1939 75.3296 37.7656 75.5036 38.0601C75.5036 37.575 75.1905 36.8474 75.4166 36.3969C75.8514 35.548 76.408 36.9167 76.6689 37.2285C76.7559 36.3276 76.3732 35.6346 76.0949 34.803C76.3558 34.8896 76.5645 35.1841 76.8254 35.3227C76.3558 34.2486 75.5384 33.7461 74.46 33.4343C74.86 33.7115 75.3644 33.9713 75.4688 34.4911C75.0861 34.5604 74.5296 34.1619 72.1293 33.7115C73.1207 34.1619 74.4774 34.2832 74.86 34.8896C75.0513 35.2014 74.9644 35.2188 74.6165 35.2014C73.9556 35.2014 72.6685 34.5431 72.0945 34.2312C72.5467 34.4738 73.2251 34.8203 73.399 35.34C72.8772 35.4093 70.7205 35.0455 70.5291 34.7683C70.79 35.1321 72.6337 35.7905 72.1641 36.2929C71.7988 36.6914 68.268 36.0677 67.5201 36.137L70.3204 36.5008C71.0683 36.8473 71.5553 37.5057 71.5205 38.7531V38.7878Z",
    fill: "url(#paint99_linear_12_16505)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.4683 52.544C71.4335 65.9538 71.3987 84.3186 71.3987 84.3186L80.7214 77.6657C80.7214 67.8249 80.8257 35.4266 80.8431 34.7855C80.8431 34.5603 80.8431 34.3697 80.8083 34.1791C76.9645 39.9485 73.712 46.047 71.4683 52.544Z",
    fill: "url(#paint100_linear_12_16505)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M80.8083 39.5673C80.7387 38.0081 80.8083 36.3622 80.8431 34.7856C80.8779 33.5208 80.3909 32.8798 79.643 32.5333C78.8777 32.1694 77.6254 32.308 76.7731 32.1694C76.9992 32.4813 78.582 33.0184 78.1646 33.4342C77.8689 33.746 76.6514 33.209 76.2861 33.1223C76.7557 33.209 77.3993 33.7287 77.6775 34.1099C78.0776 34.647 77.9732 35.3746 78.2863 35.8944C78.4081 35.5479 78.2341 33.4688 78.7907 34.4564C79.1734 35.1494 79.0168 36.1716 79.2603 36.9166C79.5908 36.4315 79.3125 35.4093 79.6604 34.9415C79.9908 35.6345 80.5474 38.8397 80.7735 39.5673C80.7735 39.602 80.7735 39.602 80.7735 39.5673H80.8083Z",
    fill: "url(#paint101_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M80.7565 67.9809C80.7565 62.4888 80.7913 53.0985 80.8087 47.8489C80.8087 48.8538 80.2869 56.4076 79.8347 56.9101C79.1389 57.6551 78.3388 55.1775 76.7735 53.1158C78.965 56.2517 80.7739 67.5478 80.7739 67.9809H80.7565Z",
    fill: "url(#paint102_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8,
    d: "M71.4857 60.8256C71.4857 66.3177 71.4683 75.708 71.4509 80.9576C71.4509 79.9527 71.8335 72.3989 72.164 71.8964C72.6858 71.1515 73.2597 73.629 74.4251 75.6907C72.8075 72.5548 71.4683 61.2587 71.4683 60.8256H71.4857Z",
    fill: "url(#paint103_linear_12_16505)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8864 32.2908L34.8559 26.816L25.4984 30.8009L68.5289 36.293C71.9379 35.652 74.9469 34.0927 77.8864 32.2735V32.2908Z",
    fill: "url(#paint104_linear_12_16505)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6499 22.5369L28.7861 38.1297C28.5252 38.2856 28.2991 38.6148 28.2296 38.9267L28.2817 85.809L38.648 87.7667V40.3473C38.735 40.0355 38.9437 39.689 39.222 39.5331L65.5551 23.819L56.6672 22.5369H56.6499Z",
    fill: "url(#paint105_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M39.1178 39.0478C38.6655 39.273 38.4394 39.325 38.3525 39.2557C38.0568 39.0651 39.1351 37.8004 39.1178 37.246C38.0742 37.8004 37.3958 38.7706 36.4914 39.4809C36.3696 38.8226 37.0132 38.3894 37.0828 37.783C37.0828 37.783 36.0218 38.6666 35.9348 38.7533C35.6391 39.0998 35.3435 39.5329 34.9956 39.8101C34.5434 39.325 35.3956 38.1469 35.4304 37.5578C35.1173 38.0256 34.7347 38.5107 34.4216 39.0131C34.1259 39.4809 33.8998 40.4165 33.3433 40.5724C33.1693 40.122 33.4998 39.5849 33.4998 39.0998C32.8215 39.273 31.8474 41.1615 31.9692 41.8891C32.2301 41.4214 32.5606 40.763 33.0476 40.5378C33.0824 41.0402 32.9258 41.5426 32.9606 42.0624C33.1693 41.7679 33.6563 40.5378 34.0216 40.4858C34.6303 40.3992 34.1607 42.253 34.1433 42.5475C34.1259 43.1192 34.1433 43.7603 34.2651 44.3147C34.2129 43.5004 34.4564 42.5129 34.7695 41.7852C34.9086 41.4387 35.1173 41.1268 35.3956 40.8669C35.4304 40.8323 36.1957 40.3299 36.1957 40.4858C36.1957 41.404 35.6913 42.3742 35.6565 43.3445C35.6044 44.2974 35.5348 45.5621 35.8131 46.463C35.8826 45.3889 36.0218 44.332 36.2479 43.2752C36.387 42.6168 36.5436 41.1961 37.2045 40.8843C37.448 41.6639 36.961 42.6515 37.2741 43.4484C37.5698 42.946 37.2393 42.0277 37.7089 41.5773C38.0046 42.0277 37.8828 42.894 37.9698 43.4311C38.0568 43.9855 38.109 44.5572 38.1785 45.1117C38.3525 46.619 38.6829 48.1782 38.6829 49.6855C38.6829 46.3071 38.6829 46.515 38.6829 40.3472C38.7525 40.0353 38.9612 39.6888 39.2221 39.5329L45.3445 35.8773C43.2573 36.8821 41.2223 38.0256 39.1351 39.0305L39.1178 39.0478Z",
    fill: "url(#paint106_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M28.5774 44.1589C28.7165 42.9807 28.6121 41.5774 29.2209 40.5032C29.2905 41.023 29.3079 41.5254 29.3079 42.0798C29.6731 41.3522 29.7949 39.2731 30.6645 38.9959C30.6819 39.7409 30.1079 40.4859 30.3341 41.2482C30.6819 40.7111 30.908 40.174 31.4124 39.7409C31.3429 40.6418 31.1689 41.5427 31.2211 42.4437C31.5516 41.5427 31.7777 40.6592 32.2821 39.8275C32.6473 39.2558 33.0474 38.6841 33.3605 38.095C32.8734 38.5281 32.1951 39.2212 31.5342 39.3078C31.969 38.4069 32.8039 37.6965 33.5518 37.0555C32.8561 37.2807 31.9168 38.095 31.1689 37.9911C31.0994 37.35 32.1777 37.0382 32.5952 36.8129C33.0996 36.5184 33.604 36.1719 34.1084 35.8427C36.2129 34.5087 38.3349 33.2093 40.4394 31.8925C41.6917 31.1129 43.0484 30.4026 44.2137 29.519L28.7861 38.147C28.5252 38.3029 28.2991 38.6321 28.2295 38.944V49.6683C28.3512 47.8318 28.3512 45.9954 28.5774 44.1589Z",
    fill: "url(#paint107_linear_12_16505)"
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0308 31.702C47.1356 30.5758 49.7271 30.6798 53.9711 30.6971L65.5375 23.8189L56.6496 22.5369L36.8911 33.5904C38.926 32.9494 40.961 32.2737 43.0308 31.7193V31.702Z",
    fill: "url(#paint108_linear_12_16505)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2295 53.9304L28.2643 85.8263L38.6306 87.7841V43.5526C35.1693 47.0176 31.7081 50.4654 28.2295 53.9304Z",
    fill: "url(#paint109_linear_12_16505)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4908 86.5885L41.6222 88.2864C41.6222 88.2864 41.7265 88.2864 41.7787 88.2864L32.3169 86.5366C32.3169 86.5366 32.4212 86.5885 32.4734 86.5885H32.4908Z",
    fill: "#FFCC00"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M28.4206 67.4959C28.7337 65.3303 28.3859 63.0953 28.5946 60.9296C28.9946 56.4424 29.6903 51.1062 32.6124 45.0077C31.4992 46.3417 29.499 52.9253 28.612 51.2794C28.2467 50.5864 28.4902 49.3737 28.4902 48.6287C28.4902 47.0001 28.438 45.3715 28.2989 43.7603C28.2467 48.7499 28.2467 65.6248 28.3337 67.5133C28.3337 67.5652 28.4206 67.5652 28.438 67.5133L28.4206 67.4959Z",
    fill: "url(#paint110_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M38.213 70.268C37.8129 74.7552 37.1694 78.896 35.4649 83.0714C35.0648 84.0416 35.0822 84.2495 34.1952 86.19C35.3083 84.8732 37.0128 78.3243 37.8999 79.9702C38.2651 80.6632 38.3521 85.8261 38.5086 87.4374C38.5608 82.4477 38.7 65.2956 38.613 63.4072C38.613 63.3552 38.3869 68.085 38.1956 70.268H38.213Z",
    fill: "url(#paint111_linear_12_16505)"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8738 84.7347L32.7346 84.752L32.8738 84.7347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5694 85.0292L33.6564 84.9426L33.5694 85.0292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5867 84.752L33.465 84.7347L33.5867 84.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6825 84.9426L32.7694 85.0292L32.6825 84.9426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7261 84.7693L33.5869 84.752L33.7261 84.7693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7432 84.856L33.6562 84.9426L33.7432 84.856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5781 84.856L32.6824 84.9426L32.5781 84.856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6127 84.7693L32.7345 84.752L32.6127 84.7693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9605 85.4452L33.0823 85.3759C33.0823 85.3759 33.204 85.3586 33.2562 85.3759L33.378 85.4452L33.1693 85.3412L32.9605 85.4452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5862 85.0293L29.6732 84.9426L29.7602 84.856C29.7602 84.856 29.7776 84.7867 29.7428 84.7694H29.6036L29.4645 84.7347H29.3775L29.2732 84.5268L29.221 84.4055C29.221 84.4055 29.1514 84.3536 29.134 84.4055L29.0818 84.5268L28.9775 84.7347H28.8905L28.7514 84.7694H28.6122C28.6122 84.7694 28.5426 84.8387 28.5774 84.8733L28.6644 84.96L28.7514 85.0466L28.8209 85.1159L28.7861 85.3411V85.4624C28.7861 85.4624 28.7861 85.5317 28.8383 85.5144L28.9601 85.4451L29.1688 85.3411L29.3775 85.4451L29.4993 85.5144C29.4993 85.5144 29.5862 85.5144 29.5688 85.4624V85.3411L29.4993 85.1159L29.5688 85.0466L29.5862 85.0293Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1607 78.3069L40.0215 78.3242L40.1607 78.3069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8563 78.6014L40.9433 78.5148L40.8563 78.6014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8736 78.3242L40.7519 78.3069L40.8736 78.3242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9694 78.5148L40.0563 78.6014L39.9694 78.5148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.013 78.3415L40.8738 78.3242L41.013 78.3415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0306 78.4108L40.9436 78.5148L41.0306 78.4108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.865 78.4108L39.9693 78.5148L39.865 78.4108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9001 78.3415L40.0218 78.3242L39.9001 78.3415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2479 79.0174L40.3696 78.9481C40.3696 78.9481 40.4914 78.9308 40.5436 78.9481L40.6653 79.0174L40.4566 78.9135L40.2479 79.0174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8736 78.6015L36.9606 78.5149L37.0476 78.4283C37.0476 78.4283 37.065 78.359 37.0302 78.3416H36.891L36.7519 78.307H36.6649L36.5606 78.0818L36.5084 77.9605C36.5084 77.9605 36.4562 77.9085 36.4214 77.9605L36.3692 78.0818L36.2649 78.2897H36.1779L36.0388 78.3243H35.917C35.917 78.3243 35.8475 78.3936 35.8822 78.4283L35.9692 78.5149L36.0562 78.6015L36.1257 78.6708L36.091 78.896V79.0346C36.091 79.0346 36.091 79.1039 36.1431 79.0866L36.2649 79.0173L36.4736 78.9134L36.6823 79.0173L36.8041 79.0866C36.8041 79.0866 36.8736 79.0866 36.8736 79.0346V78.896L36.8041 78.6708L36.8736 78.6015Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8646 70.8745L33.7428 70.8918L33.8646 70.8745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.56 71.1863L34.647 71.0823L34.56 71.1863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5947 70.8918L34.4556 70.8745L34.5947 70.8918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6731 71.0823L33.76 71.1863L33.6731 71.0823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7169 70.9091L34.5951 70.8918L34.7169 70.9091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7517 70.9957L34.6473 71.0823L34.7517 70.9957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5862 70.9957L33.6732 71.0823L33.5862 70.9957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6033 70.9091L33.7424 70.8918L33.6033 70.9091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9516 71.5849L34.0734 71.5156C34.0734 71.5156 34.1951 71.4983 34.2473 71.5156L34.3691 71.5849L34.1603 71.481L33.9516 71.5849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5772 71.1863L30.6642 71.0997L30.7512 71.013C30.7512 71.013 30.786 70.9437 30.7338 70.9264H30.5946L30.4555 70.8918H30.3685L30.2642 70.6665L30.212 70.5453C30.212 70.5453 30.1424 70.4933 30.125 70.5453L30.0728 70.6665L29.9685 70.8744H29.8815L29.7424 70.9091H29.6032C29.6032 70.9091 29.5337 70.9784 29.5858 71.013L29.6728 71.0997L29.7598 71.1863L29.8293 71.2556L29.7946 71.4808V71.6194C29.7946 71.6194 29.7946 71.6887 29.8467 71.6714L29.9685 71.6021L30.1772 71.4982L30.3859 71.6021L30.5077 71.6714C30.5077 71.6714 30.5946 71.6714 30.5772 71.6194V71.4808L30.5251 71.2556L30.5946 71.1863H30.5772Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6482 62.4888L40.5091 62.5062L40.6482 62.4888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3438 62.7833L41.4308 62.6967L41.3438 62.7833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3786 62.5062L41.2394 62.4888L41.3786 62.5062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4568 62.6967L40.5438 62.7833L40.4568 62.6967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5002 62.5235L41.3784 62.5062L41.5002 62.5235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.535 62.6101L41.4307 62.6967L41.535 62.6101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3524 62.6101L40.4568 62.6967L40.3524 62.6101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3871 62.5235L40.5089 62.5062L40.3871 62.5235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.735 63.1994L40.8567 63.13C40.8567 63.13 40.9785 63.1127 41.0306 63.13L41.1524 63.1994L40.9437 63.0954L40.735 63.1994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3608 62.7834L37.4478 62.6968L37.5347 62.6102C37.5347 62.6102 37.5521 62.5409 37.5 62.5235H37.3608L37.2217 62.4889H37.1347L37.0303 62.281L36.9782 62.1597C36.9782 62.1597 36.9086 62.1077 36.8912 62.1597L36.839 62.281L36.7347 62.4889H36.6477L36.5086 62.5235H36.3694C36.3694 62.5235 36.2998 62.5928 36.352 62.6275L36.439 62.7141L36.5259 62.8007L36.5955 62.87L36.5607 63.0953V63.2165C36.5607 63.2165 36.5607 63.2858 36.5955 63.2685L36.7173 63.1992L36.926 63.0953L37.1347 63.1992L37.2565 63.2685C37.2565 63.2685 37.326 63.2685 37.326 63.2165V63.0953L37.2738 62.87L37.3434 62.8007L37.3608 62.7834Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2034 55.9747L33.0643 55.992L33.2034 55.9747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8819 56.2865L33.9863 56.1826L33.8819 56.2865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9168 55.992L33.7951 55.9747L33.9168 55.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.995 56.1826L33.0994 56.2865L32.995 56.1826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0557 56.0267L33.9166 55.992L34.0557 56.0267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0733 56.0959L33.9863 56.1825L34.0733 56.0959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9081 56.0959L32.9951 56.1825L32.9081 56.0959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9252 56.0267L33.0644 55.992L32.9252 56.0267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2906 56.6851L33.4124 56.6158C33.4124 56.6158 33.5342 56.5985 33.5863 56.6158L33.7081 56.6851L33.4994 56.5812L33.2906 56.6851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9164 56.2866L30.0033 56.2L30.0903 56.1133C30.0903 56.1133 30.1251 56.044 30.0729 56.0267H29.9338L29.812 55.992H29.725L29.6207 55.7841L29.5685 55.6629C29.5685 55.6629 29.4989 55.6109 29.4815 55.6629L29.4294 55.7841L29.325 55.992H29.238L29.0989 56.0267H28.9597C28.9597 56.0267 28.8902 56.096 28.9423 56.1307L29.0293 56.2173L29.1163 56.3039L29.1859 56.3732L29.1511 56.5984V56.737C29.1511 56.737 29.1511 56.8063 29.2032 56.789L29.325 56.7197L29.5337 56.6158L29.7424 56.7197L29.8642 56.789C29.8642 56.789 29.9338 56.789 29.9338 56.737V56.5984L29.8642 56.3732L29.9338 56.3039L29.9164 56.2866Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8911 49.3044L40.7694 49.3217L40.8911 49.3044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.587 49.5989L41.674 49.5123L41.587 49.5989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6218 49.3217L41.4826 49.3044L41.6218 49.3217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7001 49.5123L40.8045 49.5989L40.7001 49.5123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7434 49.339L41.6217 49.3217L41.7434 49.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7782 49.4257L41.6739 49.5123L41.7782 49.4257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6128 49.4257L40.6998 49.5123L40.6128 49.4257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6303 49.339L40.7695 49.3217L40.6303 49.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9957 50.0149L41.1175 49.9456C41.1175 49.9456 41.2392 49.9283 41.2914 49.9456L41.4132 50.0149L41.2044 49.9109L40.9957 50.0149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6043 49.5989L37.6912 49.5123L37.7782 49.4256C37.7782 49.4256 37.7956 49.3563 37.7608 49.339H37.6216L37.4825 49.3044H37.3955L37.2912 49.0965L37.239 48.9752C37.239 48.9752 37.1694 48.9232 37.152 48.9752L37.0999 49.0965L36.9955 49.3044H36.8911L36.752 49.339H36.6128C36.6128 49.339 36.5433 49.4083 36.5955 49.443L36.6824 49.5296L36.7694 49.6162L36.839 49.6855L36.8042 49.9108V50.0494C36.8042 50.0494 36.8042 50.1187 36.8564 50.1013L36.9781 50.032L37.1694 49.9281L37.3781 50.032L37.4999 50.1013C37.4999 50.1013 37.5869 50.1013 37.5695 50.0494V49.9108L37.4999 49.6855L37.5695 49.6162L37.6043 49.5989Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.3212 39.5675L72.2169 39.5848L72.3212 39.5675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8775 39.8101L72.947 39.7234L72.8775 39.8101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8774 39.5329L72.7731 39.5156L72.8774 39.5329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1818 39.7754L72.2687 39.862L72.1818 39.7754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9818 39.5502L72.8775 39.5329L72.9818 39.5502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9994 39.6195L72.9472 39.7235L72.9994 39.6195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0949 39.6888L72.1819 39.7754L72.0949 39.6888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1125 39.6195L72.2168 39.5848L72.1125 39.6195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4428 40.2607L72.5297 40.1914C72.5297 40.1914 72.6167 40.1567 72.6515 40.1914L72.7559 40.2434L72.5819 40.1567L72.4428 40.278V40.2607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8776 39.8101L72.9471 39.7062L73.0167 39.6022C73.0167 39.6022 73.0167 39.5329 72.9993 39.5156H72.895L72.7906 39.4983H72.721L72.6341 39.2904L72.5819 39.1691C72.5819 39.1691 72.5297 39.1171 72.5123 39.1691L72.4775 39.2904L72.408 39.4983H72.3384L72.234 39.5503L72.1297 39.5849C72.1297 39.5849 72.0775 39.6369 72.1297 39.6715L72.2166 39.7582L72.3036 39.8448L72.3558 39.9141V40.1393L72.3384 40.2779C72.3384 40.3299 72.3558 40.3472 72.3906 40.3299L72.4775 40.2606L72.6167 40.1393L72.7906 40.2259L72.8776 40.2779C72.8776 40.2779 72.9297 40.2779 72.9297 40.2259L72.895 40.1047L72.8428 39.8794L72.895 39.8101H72.8776Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.8166 43.9336L79.7122 43.9509L79.8166 43.9336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3733 44.1761L80.4429 44.0895L80.3733 44.1761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3732 43.899L80.2689 43.8817L80.3732 43.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6776 44.1415L79.7646 44.2281L79.6776 44.1415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4777 43.9163L80.3733 43.8989L80.4777 43.9163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4952 43.9856L80.4431 44.0895L80.4952 43.9856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6083 44.0549L79.6779 44.1415L79.6083 44.0549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6083 43.9856L79.7127 43.9509L79.6083 43.9856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9386 44.6268L80.0256 44.5575C80.0256 44.5575 80.1125 44.5228 80.1473 44.5575L80.2517 44.6095L80.0951 44.5228L79.956 44.6441L79.9386 44.6268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3736 44.1761L80.4431 44.0722L80.5127 43.9682C80.5127 43.9682 80.5127 43.8989 80.4953 43.8989H80.391L80.2866 43.8816H80.217L80.1301 43.6737L80.0779 43.5524C80.0779 43.5524 80.0257 43.5004 80.0083 43.5524L79.9735 43.6737L79.904 43.8816H79.8344L79.73 43.9336L79.6257 43.9682C79.6257 43.9682 79.5735 44.0202 79.6257 44.0548L79.7126 44.1415L79.7996 44.2281L79.8518 44.2974V44.5226L79.8344 44.6612C79.8344 44.7132 79.8518 44.7305 79.8866 44.7132L79.9735 44.6439L80.1127 44.5226L80.2692 44.6092L80.3562 44.6612C80.3562 44.6612 80.4257 44.6612 80.4084 44.6092L80.3736 44.488L80.3214 44.2627L80.3736 44.1934V44.1761Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4421 50.6904L72.3377 50.7078L72.4421 50.6904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9987 50.9503L73.0683 50.8463L72.9987 50.9503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.303 50.9156L72.39 51.0022L72.303 50.9156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1031 50.6731L72.9987 50.6558L73.1031 50.6731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1376 50.7424L73.068 50.8463L73.1376 50.7424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2333 50.829L72.3029 50.9156L72.2333 50.829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2509 50.7424L72.3378 50.7078L72.2509 50.7424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5811 51.3834L72.6681 51.3141C72.6681 51.3141 72.7551 51.2794 72.8073 51.3141L72.8942 51.366L72.7203 51.2794L72.5811 51.4007V51.3834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9989 50.9503L73.0684 50.8463L73.138 50.7424C73.138 50.7424 73.138 50.6731 73.1032 50.6557H72.9989L72.8945 50.6384H72.8249L72.738 50.4305L72.6858 50.3092C72.6858 50.3092 72.6336 50.2746 72.6162 50.3092L72.5814 50.4305L72.5119 50.6384H72.4423L72.3379 50.6904L72.2336 50.725C72.2336 50.725 72.1814 50.777 72.2336 50.8117L72.3205 50.8983L72.4075 50.9849L72.4597 51.0542V51.2794L72.4423 51.418C72.4423 51.47 72.4597 51.4873 72.4945 51.47L72.5814 51.4007L72.7206 51.2794L72.8945 51.3661L72.9815 51.418C72.9815 51.418 73.0337 51.418 73.0337 51.3661L72.9989 51.2448L72.9467 51.0196L72.9989 50.9503Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.8166 57.6206L79.7122 57.6379L79.8166 57.6206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3733 57.8804L80.4429 57.7765L80.3733 57.8804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6776 57.8458L79.7646 57.9324L79.6776 57.8458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4777 57.6033L80.3733 57.5859L80.4777 57.6033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4952 57.6725L80.4431 57.7765L80.4952 57.6725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6083 57.7592L79.6779 57.8458L79.6083 57.7592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6083 57.6725L79.7127 57.6379L79.6083 57.6725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9386 58.3135L80.0256 58.2442C80.0256 58.2442 80.1125 58.2096 80.1473 58.2442L80.2517 58.2962L80.0951 58.2096L79.956 58.3309L79.9386 58.3135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3736 57.8804L80.4431 57.7765L80.5127 57.6725C80.5127 57.6725 80.5127 57.6032 80.4953 57.5859H80.391L80.2866 57.5686H80.217L80.1301 57.3607L80.0779 57.2394C80.0779 57.2394 80.0257 57.2047 80.0083 57.2394L79.9735 57.3607L79.904 57.5686H79.8344L79.73 57.6206L79.6257 57.6552C79.6257 57.6552 79.5735 57.7072 79.6257 57.7418L79.7126 57.8285L79.7996 57.9151L79.8518 57.9844V58.2096L79.8344 58.3482C79.8344 58.4002 79.8518 58.4175 79.8866 58.4002L79.9735 58.3309L80.1127 58.2096L80.2692 58.2962L80.3562 58.3482C80.3562 58.3482 80.4257 58.3482 80.4084 58.2962L80.3736 58.175L80.3214 57.9497L80.3736 57.8804Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5297 63.2167L72.4254 63.2513L72.5297 63.2167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0865 63.4766L73.156 63.39L73.0865 63.4766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0864 63.1994L72.9821 63.1821L73.0864 63.1994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3907 63.4419L72.4777 63.5285L72.3907 63.4419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2253 63.286L73.1557 63.39L73.2253 63.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.321 63.3553L72.3906 63.4419L72.321 63.3553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.321 63.286L72.4253 63.2513L72.321 63.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6518 63.9272L72.7387 63.8579C72.7387 63.8579 72.8257 63.8232 72.8779 63.8579L72.9648 63.9099L72.8083 63.8232L72.6518 63.9445V63.9272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0862 63.4766L73.1558 63.3726L73.2253 63.2687C73.2253 63.2687 73.2253 63.1994 73.1905 63.1821H73.0862L72.9818 63.1647H72.9123L72.8253 62.9568L72.7731 62.8529C72.7731 62.8529 72.7209 62.8009 72.7035 62.8529L72.6688 62.9742L72.5992 63.1821H72.5296L72.4252 63.234H72.3209C72.3209 63.234 72.2687 63.3033 72.3209 63.338L72.4079 63.4246L72.4948 63.5112L72.547 63.5805V63.8058V63.927C72.547 63.979 72.5644 63.9963 72.5992 63.979L72.6861 63.9097L72.8427 63.7884L72.9992 63.8751L73.0862 63.927C73.0862 63.927 73.1558 63.927 73.1384 63.8751L73.1036 63.7538L73.0514 63.5286L73.1036 63.4593L73.0862 63.4766Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5565 70.2334L79.4695 70.268L79.5565 70.2334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1306 70.4933L80.1827 70.3893L80.1306 70.4933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1305 70.2161L80.0262 70.1988L80.1305 70.2161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4344 70.4586L79.504 70.5452L79.4344 70.4586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2519 70.3027L80.1823 70.3894L80.2519 70.3027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3476 70.372L79.4345 70.4586L79.3476 70.372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3651 70.2854L79.4695 70.2681L79.3651 70.2854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6954 70.9439L79.7824 70.8746C79.7824 70.8746 79.8693 70.84 79.9215 70.8746L80.0085 70.9266L79.8519 70.84L79.6954 70.9612V70.9439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1303 70.4934L80.1999 70.3894L80.2694 70.2855C80.2694 70.2855 80.2694 70.2162 80.2346 70.1988H80.1303L80.0259 70.1815H79.9564L79.852 69.9736L79.7998 69.8523C79.7998 69.8523 79.7476 69.8003 79.7302 69.8523L79.6955 69.9736L79.6259 70.1815H79.5563L79.452 70.2335H79.3476C79.3476 70.2335 79.2954 70.3028 79.3476 70.3374L79.4346 70.4241L79.5215 70.5107L79.5737 70.58V70.8052L79.5563 70.9438C79.5563 70.9958 79.5737 71.0131 79.6085 70.9958L79.6955 70.9265L79.852 70.8052L80.0085 70.8918L80.0955 70.9438C80.0955 70.9438 80.1477 70.9438 80.1477 70.8918L80.1129 70.7532L80.0607 70.528L80.1129 70.4587L80.1303 70.4934Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.2163 79.1386L72.1119 79.1559L72.2163 79.1386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.773 79.3984L72.8426 79.2945L72.773 79.3984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0773 79.3465L72.1643 79.4331L72.0773 79.3465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8774 79.1213L72.773 79.1039L72.8774 79.1213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9123 79.1906L72.8427 79.2945L72.9123 79.1906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.008 79.2772L72.0776 79.3465L72.008 79.2772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.008 79.1905L72.1124 79.1559L72.008 79.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3559 79.8317L72.4428 79.7624C72.4428 79.7624 72.5298 79.7278 72.582 79.7624L72.6863 79.8144L72.5124 79.7278L72.3733 79.8491L72.3559 79.8317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7731 79.3986L72.8427 79.2946L72.9123 79.1907C72.9123 79.1907 72.9123 79.1214 72.8949 79.1214H72.7905L72.6862 79.1041H72.6166L72.5296 78.8962L72.4775 78.7922C72.4775 78.7922 72.4253 78.7402 72.4079 78.7922L72.3731 78.9135L72.3035 79.1214H72.234L72.1296 79.1734L72.0252 79.208C72.0252 79.208 71.9731 79.26 72.0252 79.2946L72.1122 79.3813L72.1992 79.4679L72.2513 79.5372V79.7624V79.901C72.2513 79.953 72.2687 79.9703 72.3035 79.953L72.3905 79.8837L72.5296 79.7624L72.7036 79.849L72.7905 79.901C72.7905 79.901 72.8427 79.901 72.8427 79.849L72.8079 79.7278L72.7557 79.5025L72.8079 79.4332L72.7731 79.3986Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3082 41.7505L33.169 41.7679L33.3082 41.7505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0038 42.0451L34.0907 41.9584L34.0038 42.0451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0385 41.7679L33.8994 41.7505L34.0385 41.7679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1169 41.9584L33.2038 42.0451L33.1169 41.9584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1607 41.7852L34.0389 41.7679L34.1607 41.7852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1955 41.8545L34.0911 41.9584L34.1955 41.8545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.03 41.8545L33.117 41.9584L33.03 41.8545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0475 41.7852L33.1693 41.7679L33.0475 41.7852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3954 42.461L33.5172 42.3917C33.5172 42.3917 33.6389 42.3744 33.6911 42.3917L33.8128 42.461L33.6041 42.3571L33.3954 42.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0211 42.0451L30.108 41.9585L30.195 41.8719C30.195 41.8719 30.2124 41.8026 30.1776 41.7852H30.0385L29.8993 41.7506H29.8123L29.708 41.5427L29.6558 41.4214C29.6558 41.4214 29.5862 41.3694 29.5688 41.4214L29.5167 41.5427L29.4123 41.7506H29.3253L29.1862 41.7852H29.0471C29.0471 41.7852 28.9775 41.8545 29.0297 41.8892L29.1166 41.9758L29.2036 42.0625L29.2732 42.1318L29.2384 42.357V42.4956C29.2384 42.4956 29.2384 42.5649 29.2906 42.5476L29.4123 42.4783L29.621 42.3743L29.8297 42.4783L29.9515 42.5476C29.9515 42.5476 30.0211 42.5476 30.0211 42.4956V42.357L29.9515 42.1318L30.0211 42.0625V42.0451Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7875 38.2335L42.6484 38.2508L42.7875 38.2335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4831 38.4414L43.5701 38.3721L43.4831 38.4414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5179 38.2508L43.3787 38.2335L43.5179 38.2508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5962 38.3721L42.6832 38.4414L42.5962 38.3721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6743 38.3201L43.57 38.372L43.6743 38.3201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4918 38.3201L42.5962 38.372L42.4918 38.3201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8918 38.7012L43.0136 38.6665C43.0136 38.6665 43.1353 38.6665 43.1875 38.6665L43.3093 38.7012L43.1005 38.6319L42.8918 38.7012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5002 38.4413L39.5871 38.372L39.6741 38.3027C39.6741 38.3027 39.6915 38.2508 39.6393 38.2508H39.5002L39.3784 38.2334H39.2741L39.1697 38.0948L39.1175 38.0082C39.1175 38.0082 39.0479 37.9735 39.0305 38.0082L38.9784 38.0948L38.874 38.2334H38.787H38.6479L38.5262 38.2508C38.474 38.2508 38.4566 38.2854 38.4914 38.3027L38.5783 38.372L38.6653 38.4413L38.7349 38.4933L38.7001 38.6492V38.7359C38.7001 38.7359 38.7001 38.7878 38.7523 38.7705L38.874 38.7359L39.0827 38.6666L39.2914 38.7359L39.4132 38.7705C39.4132 38.7705 39.4828 38.7705 39.4828 38.7359V38.6492L39.4132 38.4933L39.4828 38.4413H39.5002Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.3292 35.2363L67.19 35.2536L67.3292 35.2363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0248 35.4442L68.1117 35.3922L68.0248 35.4442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0421 35.2536L67.9204 35.2363L68.0421 35.2536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1378 35.3922L67.2248 35.4442L67.1378 35.3922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1815 35.2709L68.0423 35.2536L68.1815 35.2709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1986 35.3229L68.1116 35.3922L68.1986 35.3229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0334 35.3229L67.1378 35.3922L67.0334 35.3229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0681 35.2709L67.1898 35.2536L67.0681 35.2709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4159 35.7213L67.5377 35.6867C67.5377 35.6867 67.6594 35.6867 67.7116 35.6867L67.8334 35.7213L67.642 35.652L67.4333 35.7213H67.4159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0247 35.4442L68.1117 35.3922L68.1987 35.3229C68.1987 35.3229 68.2334 35.271 68.1639 35.271H68.0421L67.903 35.2536H67.816L67.7117 35.115L67.6595 35.0457C67.6595 35.0457 67.5899 35.0111 67.5725 35.0457L67.5203 35.115L67.416 35.2536H67.329L67.1899 35.271H67.0507C67.0507 35.271 66.9811 35.3056 67.0333 35.3403L67.1203 35.4096L67.2073 35.4615L67.2768 35.5135L67.242 35.6521V35.7387C67.242 35.7387 67.242 35.7907 67.2942 35.7734L67.416 35.7387L67.6247 35.6694L67.816 35.7387L67.9378 35.7734C67.9378 35.7734 68.0073 35.7734 68.0073 35.7387V35.6521L67.9378 35.5135L68.0073 35.4615L68.0247 35.4442Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0864 32.62L74.9472 32.6373L75.0864 32.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7649 32.8278L75.8692 32.7585L75.7649 32.8278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7993 32.6373L75.6776 32.62L75.7993 32.6373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8951 32.7585L74.982 32.8278L74.8951 32.7585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9387 32.6547L75.7995 32.6373L75.9387 32.6547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9558 32.7066L75.8688 32.7586L75.9558 32.7066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7906 32.7066L74.895 32.7586L74.7906 32.7066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8253 32.6547L74.947 32.6373L74.8253 32.6547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1731 33.0877L75.2949 33.0531C75.2949 33.0531 75.4166 33.0531 75.4688 33.0531L75.5906 33.0877L75.3818 33.0184L75.1731 33.0877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7648 32.8279L75.8692 32.776L75.9562 32.7067C75.9562 32.7067 75.9736 32.6547 75.9388 32.6547H75.7996L75.6605 32.6374H75.5735L75.4692 32.4988L75.417 32.4295C75.417 32.4295 75.3474 32.3948 75.33 32.4295L75.2778 32.4988L75.1735 32.6374H75.0865L74.9474 32.6547H74.8082C74.8082 32.6547 74.7386 32.6893 74.7908 32.724L74.8952 32.7933L74.9822 32.8453L75.0517 32.8972L75.0169 33.0532V33.1398C75.0169 33.1398 75.0169 33.1918 75.0691 33.1744L75.1909 33.1398L75.3996 33.0705L75.6083 33.1398L75.7301 33.1744C75.7301 33.1744 75.7996 33.1745 75.7996 33.1398V33.0532L75.7301 32.8972L75.7996 32.8453L75.7648 32.8279Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2036 29.9L29.0818 29.9174L29.2036 29.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.899 30.1079L29.986 30.0386L29.899 30.1079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9337 29.9174L29.7946 29.9L29.9337 29.9174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0121 30.0386L29.1164 30.1079L29.0121 30.0386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0554 29.9347L29.9337 29.9174L30.0554 29.9347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0902 29.9866L29.9858 30.0386L30.0902 29.9866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9252 29.9866L29.0122 30.0386L28.9252 29.9866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9423 29.9347L29.0814 29.9174L28.9423 29.9347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3077 30.3678L29.4295 30.3331C29.4295 30.3331 29.5512 30.3331 29.6034 30.3331L29.7251 30.3678L29.5164 30.2985L29.3077 30.3678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8991 30.108L29.9861 30.0387L30.073 29.9694C30.073 29.9694 30.1078 29.9174 30.0556 29.9174H29.9165L29.7773 29.9001H29.6904L29.586 29.7615L29.5338 29.6922C29.5338 29.6922 29.4643 29.6575 29.4469 29.6922L29.3947 29.7615L29.2903 29.9001H29.2034L29.0642 29.9174H28.9251C28.9251 29.9174 28.8555 29.952 28.9077 29.9867L28.9946 30.056L29.0816 30.1253L29.1512 30.1773L29.1164 30.3332V30.4198C29.1164 30.4198 29.1164 30.4718 29.1686 30.4545L29.2903 30.4198L29.499 30.3505L29.7078 30.4198L29.8295 30.4545C29.8295 30.4545 29.8991 30.4545 29.8991 30.4198V30.3332L29.8469 30.1773L29.9165 30.1253L29.8991 30.108Z",
    fill: "white"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M76.408 31.6846C76.408 35.5308 66.0765 38.6494 53.3448 38.6494C40.613 38.6494 30.2815 35.5308 30.2815 31.6846C30.2815 27.8384 40.613 24.7198 53.3448 24.7198C66.0765 24.7198 76.408 27.8384 76.408 31.6846Z",
    fill: "url(#paint112_radial_12_16505)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M56.7192 28.0982C54.4581 27.8037 52.1796 27.6997 49.7793 27.9077C48.3357 28.0289 47.3269 28.6526 45.9702 28.8605C44.1787 29.1378 42.4047 29.2244 40.6653 29.6402C38.2999 30.2119 33.8125 31.6153 33.6038 33.8849C33.4646 35.4788 37.4128 36.0852 37.4128 36.0852C37.5694 36.1025 38.6477 36.7436 39.2913 37.142C40.0566 37.6272 41.1002 38.1123 42.1438 38.1816C43.3265 38.2509 44.2831 37.6965 45.431 37.6791C46.0572 37.6791 46.6486 37.8177 47.2399 37.939C49.1532 38.3202 51.1882 38.2509 53.1014 37.939C54.2146 37.7484 55.3451 37.5579 56.4757 37.4192C57.4149 37.298 58.0584 37.4886 58.9803 37.5925C61.0326 37.8351 62.4763 37.5925 64.233 36.7436C64.8591 36.449 65.4679 36.0679 65.4679 36.0679C65.4679 36.0679 66.0245 35.9119 66.5463 35.8773C68.4421 35.808 70.3553 34.6992 70.6858 33.6597C71.2946 31.7539 63.7634 29.3457 60.7196 28.7566C59.3803 28.4967 58.0584 28.2715 56.7366 28.0982H56.7192Z",
    fill: "url(#paint113_linear_12_16505)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.9273 29.2936C50.2142 29.4669 49.5185 30.2292 50.1794 30.7143C50.6142 31.0262 51.4665 31.0781 51.9187 30.7836C52.5797 30.3678 51.9883 29.5708 51.3795 29.311C51.223 29.2417 51.1186 29.2417 50.9273 29.2936Z",
    fill: "url(#paint114_linear_12_16505)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3614 22.6406C40.996 20.7522 39.0827 19.4008 36.2998 20.1977C33.83 20.9081 32.6995 24.1652 31.969 26.4175C30.7514 30.1771 32.6647 33.5902 36.4564 33.8154C39.848 34.0233 43.7267 33.1051 46.8574 31.927C47.8141 31.5632 48.9098 31.3033 49.6925 30.6103C51.3449 29.1376 48.3532 27.1972 47.3444 26.227C46.0574 24.9795 44.7529 23.7668 43.344 22.6579L43.3614 22.6406Z",
    fill: "url(#paint115_linear_12_16505)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3619 26.2097C46.0748 24.9623 44.7529 23.7495 43.3615 22.6407C42.0222 21.5665 40.0742 20.3191 38.4914 20.1459C36.6477 19.938 34.6823 20.579 33.9866 22.4848C33.2387 24.5638 36.039 26.4176 37.9 27.1973C40.1959 28.1501 45.4834 29.5881 50.1622 29.8307C50.4057 28.514 48.1793 27.024 47.3445 26.2097H47.3619Z",
    fill: "url(#paint116_linear_12_16505)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M47.3619 26.2097C45.4138 24.3212 43.2919 22.5021 40.8569 21.2546C38.6479 20.1285 35.0302 19.5568 33.9866 22.4847C33.2387 24.5638 36.039 26.4176 37.9 27.1972C40.1959 28.1501 45.4834 29.5881 50.1622 29.8307C50.4057 28.514 48.1793 27.024 47.3445 26.2097H47.3619Z",
    fill: "url(#paint117_linear_12_16505)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M41.309 26.1924C40.1089 24.7718 38.7348 22.6927 36.8911 22.0863C35.2562 21.5493 33.2038 22.6061 34.2822 24.4599C35.0301 25.7593 36.5607 26.6429 37.9173 27.1973C39.1349 27.6997 41.1698 28.3235 43.5005 28.8605C42.77 27.9769 42.0569 27.076 41.309 26.1924Z",
    fill: "url(#paint118_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M43.7616 28.9472C40.3177 27.9943 34.8563 27.2147 33.7432 23.0912H33.7258C33.9867 25.0317 34.6302 26.1752 36.3347 27.2666C38.4393 28.6007 41.3265 28.8606 43.7616 28.9992C43.7964 28.9992 43.7964 28.9472 43.7616 28.9472Z",
    fill: "url(#paint119_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M38.8914 33.6769C38.474 33.6422 36.7868 33.313 36.3868 33.2264C35.4302 33.0185 34.404 32.4295 33.6387 31.8404C33.0821 31.4073 31.9864 30.5237 31.9168 29.7614C32.1255 32.3428 34.6475 33.9021 37.0999 33.7982C37.813 33.7635 38.4566 33.8675 39.1697 33.6769C39.0827 33.6942 38.9958 33.7115 38.9088 33.6942L38.8914 33.6769Z",
    fill: "url(#paint120_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M40.7523 20.8561C39.6739 20.1631 38.3694 19.9206 37.1345 20.0592C37.1345 20.0592 38.9956 20.3884 40.4914 21.0814C42.0567 21.809 44.4918 23.6282 44.457 23.5935C43.2916 22.4847 41.7784 21.5318 40.7349 20.8561H40.7523Z",
    fill: "url(#paint121_linear_12_16505)"
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9007 25.4475C43.9007 25.4475 45.153 26.4697 46.5444 18.8812C46.9966 16.4557 46.3357 13.2678 44.1268 11.8818C42.944 11.1368 41.3787 10.9289 40.0568 11.3967C38.6132 11.9164 37.7087 13.5104 37.587 14.983C37.2739 18.6387 36.926 20.2672 38.0044 21.4454C40.4046 24.0615 43.918 25.4302 43.918 25.4302L43.9007 25.4475Z",
    fill: "url(#paint122_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M42.8225 12.2282C41.2223 11.7431 39.6048 12.1069 38.4394 13.3197C38.1959 13.5796 37.935 13.8741 37.7263 14.1687C38.0568 12.9559 38.8743 11.8297 40.057 11.3966C41.3789 10.9288 42.9442 11.1367 44.127 11.8817C45.5184 12.748 46.3011 14.3592 46.5794 16.0398C45.8489 14.2899 44.6662 12.7826 42.8399 12.2282H42.8225Z",
    fill: "url(#paint123_linear_12_16505)"
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5175 19.6606C37.5523 18.829 37.9523 18.0667 38.8916 17.5989C40.2308 16.9232 42.1963 17.0445 43.1529 18.188C45.3444 20.7868 45.0487 24.8929 44.3008 25.378C43.866 25.6552 39.5525 22.9178 39.0829 22.3807C38.422 21.6531 37.5001 20.6655 37.5349 19.6606H37.5175Z",
    fill: "url(#paint124_linear_12_16505)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M41.6395 21.8783C40.9959 20.9947 40.3872 19.9033 39.5001 19.2449C38.3696 18.4306 37.6217 19.626 37.7434 20.6482C37.9869 21.2893 38.4913 21.861 38.9783 22.2595C40.2306 23.3163 41.5873 24.1999 43.1005 24.8929C42.5613 23.9227 42.3352 22.8139 41.6395 21.861V21.8783Z",
    fill: "url(#paint125_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M44.5442 20.8735C44.2311 19.8859 43.8311 18.9677 43.1701 18.1707C42.2135 17.0272 40.2307 16.906 38.9088 17.5817C38.0044 18.0494 37.6043 18.7598 37.5522 19.5567C37.7783 16.5941 41.396 15.2774 43.5354 17.651C44.3529 18.5519 44.6137 19.7127 44.5442 20.8561V20.8735Z",
    fill: "url(#paint126_linear_12_16505)"
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M44.4396 25.2395C44.4396 25.2395 44.37 25.3261 44.3352 25.3608C44.37 25.3261 44.4048 25.2915 44.4396 25.2395Z",
    fill: "#FFFF68"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6408 21.3587C54.0061 18.3614 54.0931 15.9012 51.9537 13.9781C50.0405 12.2456 46.788 13.3024 44.4921 13.8741C40.6482 14.827 38.6828 18.0669 40.4743 21.4107C42.0744 24.3906 44.8921 27.1973 47.5533 29.2244C48.3707 29.8481 49.1534 30.645 50.1622 30.9396C52.2842 31.5633 52.3711 28.0116 52.6668 26.6429C53.0495 24.9104 53.3973 23.1432 53.6234 21.376L53.6408 21.3587Z",
    fill: "url(#paint127_linear_12_16505)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M49.8493 28.6872C49.4492 27.665 48.997 26.6775 48.7013 25.638C46.0228 25.3608 43.3617 24.4425 41.3962 22.8832C43.0312 25.2915 45.3445 27.5091 47.5534 29.1897C48.3709 29.8134 49.1536 30.6103 50.1624 30.9049C50.4232 30.9742 50.632 30.9915 50.8407 30.9568C50.4754 30.2118 50.1276 29.4495 49.8319 28.6699L49.8493 28.6872Z",
    fill: "url(#paint128_linear_12_16505)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7018 26.6256C53.0844 24.8931 53.4323 23.1259 53.6584 21.3587C53.8671 19.6608 54.0237 17.2526 53.3279 15.8146C52.5279 14.1514 50.8407 12.9039 48.8579 13.3371C46.6838 13.8049 46.5794 17.1486 46.8925 19.1411C47.2925 21.5839 48.8405 26.8335 51.1016 30.9223C52.3539 30.4198 52.4583 27.7691 52.7018 26.6256Z",
    fill: "url(#paint129_linear_12_16505)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M52.7018 26.6256C53.2932 23.9748 53.728 21.2374 53.5193 18.5C53.3279 16.0398 51.9017 12.6787 48.8579 13.337C46.6838 13.8048 46.5794 17.1486 46.8925 19.141C47.2925 21.5839 48.8405 26.8335 51.1016 30.9222C52.3539 30.4198 52.4583 27.769 52.7018 26.6256Z",
    fill: "url(#paint130_linear_12_16505)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.8409 23.351C50.8756 21.1681 50.7365 18.9331 49.9364 16.958C49.6407 16.2303 49.1711 15.1562 48.3362 14.8963C47.0666 14.5151 46.91 15.9531 46.8404 16.8194C46.5969 20.1112 48.058 23.6975 49.1363 26.7641C49.5016 27.8036 49.9886 28.7912 50.4756 29.7787C50.0408 28.9125 50.6843 26.5562 50.7365 25.6033C50.7713 24.8757 50.8061 24.1134 50.8235 23.3684L50.8409 23.351Z",
    fill: "url(#paint131_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M48.4752 25.0141C47.4838 21.601 45.2575 16.5594 48.1969 13.4581C46.6837 14.7056 46.0401 15.849 46.0054 17.8588C45.9706 20.3536 47.2577 22.9178 48.423 25.0488C48.423 25.0834 48.4752 25.0488 48.4752 25.0314V25.0141Z",
    fill: "url(#paint132_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M41.8658 23.3684C41.6745 23.0046 41.0657 21.3933 40.9266 21.0121C40.5961 20.0939 40.5613 18.9158 40.6657 17.9456C40.7353 17.2526 40.9092 15.8492 41.5354 15.3987C39.4308 16.9407 39.4482 19.886 40.8222 21.8957C41.2223 22.4848 41.4658 23.0912 42.005 23.5763C41.9528 23.5243 41.9006 23.455 41.8484 23.3684H41.8658Z",
    fill: "url(#paint133_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M53.78 18.188C53.8148 16.9059 53.3104 15.6758 52.5625 14.7056C52.5625 14.7056 53.2582 16.4554 53.4669 18.084C53.6757 19.7819 53.3974 22.7965 53.3974 22.7618C53.7278 21.2026 53.7452 19.4007 53.78 18.1706V18.188Z",
    fill: "url(#paint134_linear_12_16505)"
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7707 23.0392C50.7707 23.0392 50.9794 24.7197 57.5192 19.886C59.6063 18.344 61.3978 15.416 60.6847 12.7652C60.3021 11.3446 59.2585 10.0798 57.9018 9.49076C56.4234 8.84973 54.5797 9.43879 53.4318 10.4783C50.5793 13.0598 49.1183 14.0646 49.1009 15.7452C49.0661 19.4701 50.7881 23.0392 50.7881 23.0392H50.7707Z",
    fill: "url(#paint135_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M59.4498 12.1068C58.5628 10.5822 57.067 9.71593 55.2929 9.81988C54.9102 9.83721 54.5102 9.88919 54.1275 9.95849C55.2407 9.26547 56.6843 8.97094 57.9018 9.4907C59.2585 10.0798 60.3195 11.3445 60.6847 12.7652C61.1369 14.4284 60.5804 16.2302 59.589 17.7029C60.2847 15.8318 60.4586 13.822 59.4498 12.1068Z",
    fill: "url(#paint136_linear_12_16505)"
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.0229 14.0298C50.6491 13.4235 51.5013 13.1116 52.5623 13.4235C54.0755 13.8566 55.5017 15.3639 55.4148 16.9058C55.2234 20.4575 52.0057 23.5414 51.1187 23.2469C50.2664 22.9697 49.2576 17.6508 49.275 16.9058C49.2924 15.8837 49.275 14.7575 50.0229 14.0298Z",
    fill: "url(#paint137_linear_12_16505)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.5101 19.1409C50.5971 17.7375 50.7537 16.3342 51.2928 15.0174C51.4668 14.6016 52.1799 13.5621 51.3276 13.4235C50.9276 13.3542 50.3014 13.77 50.0231 14.0299C49.2752 14.7576 49.2926 15.8837 49.2752 16.9059C49.2752 17.6682 50.284 22.9698 51.1363 23.247C51.2059 23.2643 51.3102 23.2643 51.4146 23.247C50.7537 21.9649 50.458 20.2497 50.5101 19.1235V19.1409Z",
    fill: "url(#paint138_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M54.5452 19.9725C55.0148 19.0023 55.3627 17.9975 55.4323 16.906C55.5192 15.3467 54.093 13.8394 52.5798 13.4236C51.5536 13.129 50.7361 13.4236 50.11 13.978C52.4233 11.847 56.128 13.4236 56.0758 16.7847C56.0584 18.0494 55.4149 19.1409 54.5452 19.9725Z",
    fill: "url(#paint139_linear_12_16505)"
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M58.824 25.1009C61.0851 23.0912 62.807 21.3413 62.8766 18.8984C62.9461 16.7328 60.3198 15.9358 58.5979 15.2255C55.7106 14.0647 52.3364 15.4854 51.1014 18.7945C50.0057 21.7398 49.7274 25.1356 49.9013 27.8903C49.9535 28.7392 49.8665 29.6921 50.2666 30.4025C51.0841 31.8751 53.5539 29.3283 54.667 28.4793C56.0759 27.4052 57.4847 26.279 58.824 25.1009Z",
    fill: "url(#paint140_linear_12_16505)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.884 31.0436C49.884 30.5931 52.0929 26.3138 52.4408 25.1357C52.6321 24.4946 53.2582 22.5022 52.4755 22.0517C51.6929 21.6013 50.9623 23.715 50.7884 24.2001C50.0405 26.2618 49.884 30.8703 49.884 31.0263V31.0436Z",
    fill: "url(#paint141_linear_12_16505)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M49.536 29.3283C49.1533 29.0684 46.8574 24.8411 46.0921 23.9055C45.6747 23.3857 44.3702 21.7398 43.5527 22.1383C42.7353 22.5195 44.0919 24.3213 44.3876 24.7371C45.6747 26.5216 49.3968 29.259 49.536 29.3456V29.3283Z",
    fill: "url(#paint142_linear_12_16505)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M53.8146 15.572C53.345 15.8319 52.9102 16.1784 52.5102 16.5769C52.5623 16.5422 52.6145 16.5249 52.6493 16.4903C52.6841 16.4556 52.7363 16.421 52.7711 16.3863C53.1189 16.0918 53.4494 15.8319 53.7973 15.572H53.8146Z",
    fill: "url(#paint143_linear_12_16505)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6667 28.4794C56.0755 27.4052 57.4844 26.2791 58.8236 25.101C60.1107 23.9575 61.8326 22.2769 62.424 20.9082C63.1023 19.3143 62.9632 17.5991 61.5022 16.9581C59.9194 16.2477 57.5713 18.6386 56.3886 20.2499C54.945 22.225 52.2838 26.7815 50.788 30.853C51.8664 31.0955 53.7275 29.2071 54.6667 28.4967V28.4794Z",
    fill: "url(#paint144_linear_12_16505)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M54.667 28.4794C56.8237 26.8335 58.9631 25.049 60.685 22.9526C62.2504 21.0642 63.7288 17.9283 61.4851 16.9407C59.9023 16.2304 57.5542 18.6213 56.3715 20.2325C54.9279 22.2076 52.2667 26.7642 50.7709 30.8356C51.8493 31.0782 53.7104 29.1897 54.6496 28.4794H54.667Z",
    fill: "url(#paint145_linear_12_16505)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.7626 23.2299C57.1019 22.277 58.5977 21.4107 59.7456 20.2153C60.3196 19.6262 60.9805 18.9505 61.2762 18.1536C61.4501 17.8071 61.4675 17.4779 61.311 17.1487C61.1718 16.9928 61.1197 16.8888 61.1544 16.8542C61.1023 16.8542 61.0675 16.8369 61.0153 16.8195C59.4673 16.6983 57.4497 18.7773 56.3887 20.2153C55.6408 21.2548 54.5451 23.0047 53.4493 25.0144C54.1798 24.356 54.9625 23.767 55.7452 23.2126L55.7626 23.2299Z",
    fill: "url(#paint146_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M53.2927 25.274C55.0494 22.3114 57.2061 17.5643 61.0326 16.7153V16.698C59.2933 16.8713 58.128 17.4083 56.7365 18.8637C55.0146 20.6655 54.0058 23.1603 53.2405 25.274C53.2405 25.3087 53.2753 25.3087 53.2927 25.274Z",
    fill: "url(#paint147_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M50.5621 20.9081C50.7012 20.5443 51.4491 19.0889 51.6231 18.7424C52.0579 17.9108 52.8406 17.0272 53.5711 16.3862C54.0929 15.9184 55.1539 14.9828 55.8322 14.9482C53.5537 15.0695 51.5361 17.2178 50.9621 19.3488C50.8056 19.9725 50.5273 20.5269 50.5099 21.1506C50.5099 21.0813 50.5273 21.012 50.5621 20.9254V20.9081Z",
    fill: "url(#paint148_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M61.0674 22.8659C61.9545 21.9477 62.5111 20.8042 62.7198 19.7474C62.7198 19.7474 61.9371 21.3586 60.9283 22.6407C59.8847 23.9748 57.6584 26.0538 57.6932 26.0191C58.9629 25.0316 60.1978 23.7322 61.05 22.8659H61.0674Z",
    fill: "url(#paint149_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2,
    d: "M60.5459 22.658C61.4329 21.7398 61.9895 20.5963 62.1982 19.5395C62.1982 19.5395 61.4156 21.1507 60.4068 22.4328C59.3632 23.7669 57.1369 25.8459 57.1716 25.8113C58.4413 24.8237 59.6762 23.5243 60.5285 22.658H60.5459Z",
    fill: "url(#paint150_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M60.0068 22.3982C60.8938 21.4799 61.4504 20.3364 61.6591 19.2796C61.6591 19.2796 60.8765 20.8909 59.8677 22.1729C58.8241 23.507 56.5978 25.586 56.6325 25.5514C57.9022 24.5638 59.1371 23.2644 59.9894 22.3982H60.0068Z",
    fill: "url(#paint151_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M59.4848 22.1903C60.3718 21.2721 60.9284 20.1286 61.1371 19.0718C61.1371 19.0718 60.3545 20.683 59.3457 21.9651C58.3021 23.3165 56.0758 25.3782 56.1105 25.3609C57.3802 24.3733 58.6151 23.0739 59.4674 22.2077L59.4848 22.1903Z",
    fill: "url(#paint152_linear_12_16505)"
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9973 27.0586C54.0058 28.0461 51.049 30.0385 52.7188 31.4938C53.5188 32.1695 54.6146 32.4121 55.5886 32.7586C58.7542 33.9021 62.6328 34.7337 66.0245 34.4738C69.8162 34.1793 71.5033 30.7662 70.2162 27.0412C69.4509 24.8063 68.5813 21.5145 66.094 20.8388C63.3111 20.0938 61.2762 21.4971 58.9455 23.4202C57.554 24.5464 56.2669 25.7938 55.0146 27.0586H54.9973Z",
    fill: "url(#paint153_linear_12_16505)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M70.1991 27.0238C69.9208 26.2095 69.3816 24.5983 68.9989 23.6627C69.0685 26.3828 65.6769 28.2193 62.1982 28.6524C59.885 29.5014 58.8414 30.3156 58.4066 30.4196C61.5025 31.4938 62.7374 34.6989 66.0073 34.4391C69.799 34.1445 71.4862 30.7314 70.1991 27.0065V27.0238Z",
    fill: "url(#paint154_linear_12_16505)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9973 27.0585C56.2496 25.7937 57.5541 24.5636 58.9282 23.4202C60.2501 22.3113 62.1981 20.908 63.7809 20.7001C65.6245 20.4749 67.5899 21.2025 68.3031 23.1083C69.0857 25.1873 66.3202 27.0758 64.4592 27.8901C62.1807 28.8776 56.9106 30.4023 52.2318 30.7314C51.971 29.4147 54.1625 27.8901 54.9973 27.0585Z",
    fill: "url(#paint155_linear_12_16505)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M54.9973 27.0585C56.928 25.1354 58.9978 23.2815 61.4154 21.9995C63.6069 20.8387 67.2073 20.1976 68.3031 23.1083C69.0857 25.1873 66.3202 27.0758 64.4592 27.8901C62.1807 28.8776 56.9106 30.4022 52.2318 30.7314C51.971 29.4147 54.1625 27.8901 54.9973 27.0585Z",
    fill: "url(#paint156_linear_12_16505)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M64.4069 27.6996C65.6244 26.868 66.8593 25.9151 67.3637 24.5464C67.8508 23.2124 67.5029 21.7397 66.1462 21.1333C64.5809 20.423 62.7894 21.2719 61.4153 21.9996C58.0585 23.7841 54.8929 26.5735 53.1884 29.9866C54.0754 29.6227 61.2588 29.8653 64.4069 27.6996Z",
    fill: "url(#paint157_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M58.6327 29.7265C62.0591 28.7044 67.5205 27.8381 68.5467 23.7147H68.5641C68.338 25.6551 67.7118 26.8159 66.0247 27.9247C63.9375 29.2934 61.0677 29.6053 58.6327 29.7785C58.5979 29.7785 58.5979 29.7265 58.6327 29.7265Z",
    fill: "url(#paint158_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M63.5895 34.3871C64.0069 34.3525 65.6767 33.9887 66.0767 33.902C67.0333 33.6768 68.0595 33.0704 68.8074 32.464C69.3466 32.0309 70.4424 31.13 70.4946 30.3503C70.3206 32.9318 67.8334 34.5257 65.3984 34.4738C64.6853 34.4564 64.0417 34.5604 63.3286 34.3871C63.4156 34.4045 63.5025 34.4218 63.5895 34.4045V34.3871Z",
    fill: "url(#paint159_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M61.52 21.5838C62.5809 20.8735 63.9028 20.6136 65.1203 20.7349C65.1203 20.7349 63.2593 21.0987 61.7808 21.8091C60.2329 22.5541 57.8326 24.4079 57.85 24.3905C58.998 23.2644 60.4938 22.2769 61.52 21.5838Z",
    fill: "url(#paint160_linear_12_16505)"
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4055 29.7961C50.4055 29.7961 52.0057 30.3851 45.7616 35.6174C43.7614 37.2806 40.4915 38.3374 38.0564 37.0554C36.752 36.3623 35.7606 35.0456 35.4997 33.5903C35.2214 31.9964 36.2128 30.3505 37.4999 29.4669C40.6828 27.2839 42.0047 26.1058 43.657 26.4696C47.3096 27.2839 50.4055 29.7961 50.4055 29.7961Z",
    fill: "url(#paint161_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M37.7083 35.704C36.4212 34.4912 35.9168 32.828 36.4386 31.1301C36.5429 30.7663 36.6821 30.3851 36.856 30.0213C35.9168 30.9569 35.2906 32.2909 35.5167 33.5903C35.7776 35.0456 36.769 36.3624 38.0735 37.0554C39.6041 37.8697 41.4826 37.7484 43.1697 37.1247C41.1869 37.3672 39.1693 37.0727 37.7257 35.6867L37.7083 35.704Z",
    fill: "url(#paint162_linear_12_16505)"
  }), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7786 27.0066C41.0307 27.4743 40.5437 28.2193 40.5959 29.3281C40.6654 30.9048 41.8134 32.6373 43.344 32.9145C46.8748 33.5555 50.4403 31.1473 50.5447 30.2117C50.6317 29.4667 45.7094 27.1625 44.9615 26.9892C43.9527 26.7813 42.6482 26.4521 41.7612 26.9892L41.7786 27.0066Z",
    fill: "url(#paint163_linear_12_16505)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45.3612 29.1897C44.6133 28.5313 43.8654 27.873 42.961 27.5611C41.5695 27.076 40.5434 27.821 40.6129 29.3283C40.6825 30.9049 41.8304 32.6374 43.361 32.9146C44.3003 33.0879 45.1003 32.9493 45.8656 32.4295C46.0396 32.3082 47.5354 30.7836 47.4484 30.749C46.6831 30.3851 46.0222 29.7961 45.3612 29.207V29.1897Z",
    fill: "url(#paint164_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M46.5443 32.7586C45.4833 32.9838 44.4223 33.1051 43.344 32.9145C41.796 32.6373 40.6654 30.9048 40.5958 29.3282C40.5437 28.2714 41.0133 27.5264 41.709 27.0586C39.1 28.8085 39.7784 32.7759 43.0831 33.5036C44.3354 33.7808 45.5529 33.417 46.5617 32.7586H46.5443Z",
    fill: "url(#paint165_linear_12_16505)"
  }), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.5099 30.4024C50.5099 30.4024 50.5447 30.2984 50.5621 30.2465C50.5621 30.2984 50.5273 30.3504 50.5099 30.4024Z",
    fill: "#FFFF68"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M40.0215 37.5924C41.726 37.7483 43.8306 37.1073 45.4482 35.8425C43.2392 36.986 40.0215 37.5924 40.0215 37.5924Z",
    fill: "url(#paint166_linear_12_16505)"
  }), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6059 28.566C51.5016 28.7739 51.432 28.9818 51.3972 29.1897C53.38 29.9693 56.1107 29.8134 58.1979 29.7614C60.5112 29.7094 63.3463 28.514 64.1985 26.227C64.6681 24.997 64.5638 23.5416 63.8681 22.4155C63.1202 21.1854 61.4852 20.6656 60.0938 20.8216C58.1631 21.0468 56.8934 21.4626 55.4672 22.8486C54.2149 24.0441 53.3105 25.5687 52.4756 27.076C52.2147 27.5611 51.8494 28.0462 51.6233 28.5486L51.6059 28.566Z",
    fill: "url(#paint167_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M63.6422 25.1184C63.7813 23.5592 63.1552 22.1558 61.8159 21.3069C61.5202 21.1336 61.2246 20.943 60.8941 20.8044C62.0768 20.8737 63.2769 21.4108 63.8857 22.4157C64.564 23.5418 64.6684 25.0145 64.2162 26.2273C63.677 27.6653 62.3377 28.6875 60.8419 29.2419C62.3203 28.2543 63.4857 26.8683 63.6596 25.1011L63.6422 25.1184Z",
    fill: "url(#paint168_linear_12_16505)"
  }), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1285 22.4675C56.772 22.1037 57.433 22.0517 57.9374 22.6927C58.807 23.7842 59.0679 25.6207 58.1983 26.6949C57.3286 27.769 56.0937 28.5313 54.7892 28.9472C53.7282 29.2937 52.5977 29.0511 51.5193 29.363C52.7368 26.331 55.1197 23.0219 56.1285 22.4502V22.4675Z",
    fill: "url(#paint169_linear_12_16505)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M56.4238 22.1902C56.4238 22.1902 56.2846 22.2595 56.215 22.2942C55.2062 22.8486 52.8408 26.1577 51.6233 29.207C52.5799 28.9298 53.5887 29.0857 54.5453 28.8778C54.5453 26.4869 55.0497 24.0614 56.4411 22.1902H56.4238Z",
    fill: "url(#paint170_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M55.9718 28.3061C56.8241 27.8384 57.5893 27.3013 58.1981 26.539C59.0678 25.4475 58.8069 23.6283 57.9372 22.5195C57.3458 21.7745 56.5979 21.5493 55.8674 21.6532C58.6503 21.3067 60.5288 24.3733 58.7373 26.7815C58.059 27.6998 57.0328 28.1675 55.9718 28.3235V28.3061Z",
    fill: "url(#paint171_linear_12_16505)"
  }), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M51.9365 29.0339C51.9365 29.0339 51.8495 28.9819 51.8148 28.9646C51.8495 28.9819 51.8843 29.0166 51.9365 29.0339Z",
    fill: "#FFFF68"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M50.423 30.4891C50.423 30.4891 48.8751 31.1128 55.3975 35.5134C57.4846 36.9167 60.8241 37.7137 63.1548 36.4143C64.4245 35.7213 65.3463 34.4739 65.5202 33.1572C65.7116 31.7018 64.6332 30.2638 63.2765 29.5362C59.9718 27.7343 58.5804 26.7295 56.9628 27.1453C53.3625 28.0635 50.4057 30.4891 50.4057 30.4891H50.423Z",
    fill: "url(#paint172_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M63.433 35.1844C64.6505 34.0236 65.068 32.499 64.4592 30.9917C64.3201 30.6625 64.1635 30.3333 63.9896 30.0215C64.981 30.8184 65.6767 31.9966 65.5202 33.1747C65.3463 34.5087 64.4244 35.7388 63.1547 36.4318C61.6763 37.2461 59.7979 37.2288 58.076 36.7437C60.0762 36.865 62.059 36.5012 63.433 35.1844Z",
    fill: "url(#paint173_linear_12_16505)"
  }), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.876 27.5265C59.6413 27.9077 60.1805 28.566 60.1979 29.5709C60.2152 30.9916 59.1717 32.6202 57.6411 32.9493C54.1625 33.7117 50.4056 31.7192 50.3012 30.8703C50.2316 30.3852 54.8582 27.6132 55.5887 27.4399C56.5801 27.1973 57.9715 27.0934 58.8934 27.5439L58.876 27.5265Z",
    fill: "url(#paint174_linear_12_16505)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M58.0236 28.9472C58.8932 28.8952 59.6585 29.1898 60.0064 29.9694C60.3716 28.8433 59.3454 27.7691 58.354 27.4399C57.0843 27.0414 55.6059 27.6652 54.4754 28.2196C53.7101 28.6007 52.9796 29.0685 52.336 29.6229C52.0577 29.8481 50.9272 31.3554 50.6663 31.3554C51.2229 31.8752 53.3274 33.0187 54.0058 32.6548C54.1623 31.7193 55.2059 29.1032 58.0062 28.9472H58.0236Z",
    fill: "url(#paint175_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M54.4405 32.9838C55.5189 33.1397 56.5799 33.1917 57.6408 32.9492C59.1714 32.62 60.215 30.9914 60.1976 29.5707C60.1976 28.6005 59.6932 27.9595 58.9627 27.5783C61.676 29.0336 61.2064 32.6546 57.9539 33.4689C56.719 33.7808 55.4841 33.5036 54.4405 32.9665V32.9838Z",
    fill: "url(#paint176_linear_12_16505)"
  }), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.3708 31.0434C50.3708 31.0434 50.3186 30.9568 50.3186 30.9048C50.3186 30.9568 50.3534 30.9915 50.3708 31.0434Z",
    fill: "#FFFF68"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M55.7454 35.6695C57.1717 36.5531 59.6415 37.558 62.3722 36.7783C62.4244 36.7783 60.5285 37.1768 55.7454 35.6695Z",
    fill: "url(#paint177_linear_12_16505)"
  }), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6403 29.9347C52.788 28.4967 51.7097 28.4793 50.2139 28.2888C48.7181 28.462 47.6397 28.4967 46.7874 29.9347C45.9178 31.4073 44.6307 34.5085 45.796 36.1198C46.3004 36.8128 48.231 37.2633 50.2139 37.2633C52.2141 37.2633 54.1447 36.8128 54.6317 36.1198C55.797 34.5085 54.5099 31.4073 53.6403 29.9347Z",
    fill: "url(#paint178_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M46.9443 31.0781C47.4139 30.1945 47.9183 29.2416 48.6314 28.5312C47.9009 28.7045 47.3096 29.0683 46.7878 29.9346C46.0225 31.2167 44.9441 33.7635 45.4659 35.4614C45.7616 33.9367 46.1964 32.4987 46.9443 31.0781Z",
    fill: "url(#paint179_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M55.0319 35.1668C55.3624 33.4863 54.371 31.1647 53.6405 29.9519C53.1187 29.0683 52.4925 28.7218 51.762 28.5312C53.4839 30.4544 54.4406 32.7067 55.0319 35.1495V35.1668Z",
    fill: "url(#paint180_linear_12_16505)"
  }), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M54.2841 31.1994C54.0754 30.7143 53.8493 30.2812 53.6406 29.9347C52.7883 28.4967 51.71 28.4793 50.2142 28.2888C48.7184 28.462 47.64 28.4967 46.7877 29.9347C46.5094 30.3851 46.1964 31.0088 45.9355 31.7018C48.2835 29.6228 51.8143 29.4669 54.2841 31.1994Z",
    fill: "url(#paint181_linear_12_16505)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M46.1443 36.4489C46.9269 36.9513 48.5445 37.2805 50.2142 37.2805C52.2144 37.2805 54.1451 36.83 54.6321 36.137C54.6669 36.1024 54.6843 36.0504 54.7017 36.0157C52.9102 37.0553 49.2924 37.4018 46.1443 36.4489Z",
    fill: "url(#paint182_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M40.2132 32.7239C39.848 32.1695 39.6219 31.5285 39.3957 30.8701C39.3088 30.6103 38.9087 29.7093 39.0305 29.4495C38.7174 30.0905 39.0305 31.1993 39.1696 31.8577C38.9087 31.6844 38.1782 30.4543 37.9347 30.4717C37.4129 30.489 38.0913 32.9492 38.0391 32.9492C37.5521 32.8452 36.4215 31.8057 36.7346 31.2513C36.3346 31.9097 36.8042 33.313 37.0999 33.954C37.5173 34.8896 38.3869 35.6866 39.274 36.1544C39.2914 36.1717 39.2914 36.1717 39.274 36.1544C38.5261 35.496 37.5173 34.3525 37.4477 33.3303C37.7782 33.365 38.1087 33.7461 38.3696 33.9714C39.0653 34.5951 39.761 34.9589 40.648 35.2708C40.1089 35.0802 39.6219 34.3179 39.2566 33.9021C38.8218 33.3996 38.4739 32.7932 38.4043 32.1176C38.4043 32.2042 39.7088 33.0358 39.848 33.1398C40.3872 33.5382 41.0133 33.8328 41.6568 34.0407C40.9959 33.7461 40.5437 33.2784 40.1958 32.7413L40.2132 32.7239Z",
    fill: "url(#paint183_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M55.2408 13.1464C54.806 12.8692 54.2842 12.696 53.7798 12.5227C53.5711 12.4534 52.858 12.1589 52.6667 12.2628C53.1711 12.0029 54.0407 12.2628 54.5625 12.3321C54.4234 12.1242 53.4493 11.5871 53.4493 11.3966C53.4493 10.9981 55.3974 11.4832 55.3974 11.4485C55.3104 11.0674 54.4755 10.2011 54.0581 10.461C54.5799 10.1491 55.6757 10.4956 56.1801 10.7209C56.9106 11.0327 57.5541 11.6911 57.9368 12.3841C57.415 11.8124 56.5105 11.0327 55.6931 10.9981C55.7278 11.258 56.0235 11.5005 56.2148 11.7084C56.7192 12.2455 57.0149 12.7826 57.2584 13.4583C57.1019 13.0251 56.4931 12.6786 56.1627 12.4014C55.7626 12.0549 55.2756 11.8124 54.7538 11.7604C54.8234 11.7604 55.5017 12.7653 55.5713 12.8692C55.8844 13.285 56.1279 13.7701 56.3018 14.2552C56.0583 13.7528 55.6931 13.4063 55.2582 13.1464H55.2408Z",
    fill: "url(#paint184_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M35.6739 29.3629C36.0044 29.4322 36.3348 29.4842 36.6479 29.5708C36.3175 29.3456 35.326 28.7219 35.2739 28.3061C35.2043 27.7517 35.9522 28.1502 36.1783 28.2368C36.7523 28.4447 37.4828 28.7392 38.0916 28.514C37.8654 28.6006 36.7697 28.0289 36.5088 27.9423C36.0392 27.769 35.6043 27.5611 35.1869 27.2666C34.352 26.6775 33.7433 25.8632 33.2389 24.9969C33.3954 25.5514 33.5693 26.1577 33.7781 26.7122C33.9868 27.2839 34.4216 27.821 34.5955 28.3581C33.9172 28.0289 32.6475 27.0067 32.6997 26.1577C32.6649 26.7815 32.7693 27.4225 32.9258 28.0116C33.0649 28.5313 33.5693 29.103 33.4824 29.6401C32.978 29.5708 32.2823 28.5313 32.0388 28.0982C32.2823 29.5535 33.8129 30.8009 35.2739 31.0088C34.352 30.5064 33.8302 29.4322 33.6041 28.4447C34.1781 29.0684 34.9086 29.2243 35.6565 29.3629H35.6739Z",
    fill: "url(#paint185_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2,
    d: "M66.5462 30.4891C66.2157 30.5411 65.8852 30.6104 65.5722 30.6971C65.9026 30.4718 66.894 29.8481 66.9462 29.4323C67.0158 28.8779 66.2679 29.2764 66.0418 29.363C65.4678 29.5709 64.7373 29.8828 64.1285 29.6402C64.3547 29.7268 65.4504 29.1551 65.7113 29.0685C66.1809 28.8952 66.6158 28.6873 67.0332 28.3928C67.8681 27.8037 68.4768 27.0068 68.9812 26.1232C68.8247 26.6776 68.6507 27.284 68.442 27.8384C68.2333 28.4101 67.7985 28.9472 67.6246 29.4843C68.3029 29.1551 69.5726 28.1329 69.5204 27.284C69.5552 27.9077 69.4508 28.5314 69.2943 29.1378C69.1551 29.6575 68.6507 30.2466 68.7377 30.7664C69.2421 30.6971 69.9378 29.6575 70.1813 29.2244C69.9378 30.6797 68.4072 31.9271 66.9462 32.1351C67.8681 31.6326 68.4072 30.5584 68.616 29.5709C68.042 30.1946 67.3115 30.3505 66.5636 30.4891H66.5462Z",
    fill: "url(#paint186_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M61.5373 24.9103C61.4677 25.1702 61.3981 25.43 61.3459 25.7073C61.2938 25.3954 61.172 24.4425 60.8937 24.2519C60.5111 24.0094 60.5459 24.7024 60.5285 24.893C60.4763 25.3954 60.4589 26.0364 60.0589 26.4003C60.198 26.2617 60.1632 25.2568 60.1806 25.0489C60.2154 24.6504 60.2154 24.2519 60.1284 23.8534C59.9719 23.0392 59.6066 22.3115 59.1196 21.6358C59.4849 21.9477 59.8675 22.2768 60.198 22.6407C60.5459 22.9872 60.7894 23.5069 61.1372 23.8188C61.1372 23.2124 60.8241 21.913 60.1632 21.6531C60.6328 21.8437 61.0677 22.1382 61.4677 22.4674C61.7982 22.7446 62.0591 23.3164 62.4765 23.4376C62.5982 23.0392 62.0765 22.1729 61.8329 21.8437C62.8244 22.5367 63.2244 24.096 62.8591 25.2221C62.807 24.3732 62.1982 23.6109 61.5547 23.1085C61.8156 23.7495 61.6764 24.3386 61.5199 24.9276L61.5373 24.9103Z",
    fill: "url(#paint187_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M56.2322 16.7675C56.4931 16.6982 56.754 16.6116 57.0149 16.5076C56.7714 16.7155 56.0235 17.3046 56.0061 17.6511C56.0061 18.1015 56.5627 17.7204 56.754 17.6164C57.2062 17.4085 57.7628 17.0967 58.2846 17.2353C58.0933 17.1833 57.2584 17.7377 57.0497 17.8243C56.6845 17.9976 56.354 18.2228 56.0409 18.4827C55.4148 19.0371 54.9799 19.7301 54.6669 20.4924C54.7538 20.0246 54.8234 19.5222 54.9625 19.0544C55.0843 18.5866 55.3974 18.1015 55.4843 17.6511C54.9625 17.9802 54.0059 18.9158 54.1277 19.6088C54.0407 19.1064 54.0755 18.5866 54.1451 18.0842C54.2146 17.6511 54.5625 17.1313 54.4581 16.7155C54.0581 16.8195 53.5711 17.7204 53.4146 18.1015C53.4841 16.9061 54.6321 15.7626 55.78 15.4681C55.0843 15.9532 54.7364 16.8714 54.6321 17.6857C55.0495 17.1313 55.6235 16.9407 56.2148 16.7675H56.2322Z",
    fill: "url(#paint188_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M43.5005 19.1757C43.6223 19.8687 43.8658 20.5097 44.4919 21.2201C44.1962 20.3018 43.9005 18.9331 44.4397 18.0496C44.8572 18.1708 44.8572 18.5693 44.9615 18.9505C45.1181 19.5395 45.2572 20.3192 45.7964 20.683C45.6051 20.5444 45.4485 19.3316 45.3964 19.0544C45.0833 17.8417 45.0833 16.0398 45.8138 14.9483C45.0833 16.0225 44.2658 16.8541 43.9005 18.1535C43.6397 16.5076 44.805 15.035 45.8138 13.8915C45.3442 14.4286 44.5441 14.7577 44.0397 15.3295C43.5353 15.9012 42.9091 16.421 42.5265 17.0967C42.4569 16.3517 43.1005 15.1389 43.5005 14.5152C42.5439 15.2082 41.9351 16.2997 41.7786 17.4605C41.5873 18.8812 42.1612 19.6262 42.5613 20.9082C42.0917 19.4356 42.3352 17.5298 43.5005 16.4037C43.6223 17.3219 43.3614 18.2228 43.5179 19.1584L43.5005 19.1757Z",
    fill: "url(#paint189_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M50.5449 30.1078C50.4753 29.8133 50.4231 29.5187 50.3883 29.2935C50.11 29.9519 50.284 30.7315 49.8143 31.3033C49.1882 32.0829 49.5187 30.1598 49.5708 29.8826C49.0143 30.4716 48.9447 31.1127 48.6316 31.8577C48.5968 31.234 48.6664 30.6449 48.7708 30.0558C47.762 31.0953 47.588 33.1917 48.0576 34.5084H48.075C47.9185 33.5382 48.2838 32.4987 48.9273 31.771C49.049 32.6546 48.649 33.6248 49.3099 34.3872C49.3621 33.5555 49.4143 32.7586 49.5361 31.9443C49.4143 32.6893 49.9013 33.7461 50.197 34.4045C50.0578 33.5209 50.0752 32.1349 50.4579 31.3206C50.4579 31.3206 51.0493 32.8279 51.084 32.9838C51.2232 33.7634 51.2928 34.5777 51.2754 35.3747C51.5884 34.5604 51.9537 32.9145 51.6928 32.0656C52.232 32.464 52.4233 33.2264 52.5451 33.8501C52.4059 33.1571 52.4581 32.3947 52.3189 31.7017C52.1624 30.9567 51.7276 30.4023 51.4841 29.7093C51.4841 30.2811 51.4841 30.8008 51.3623 31.3379C50.8231 31.2166 50.597 30.6795 50.4753 30.1425L50.5449 30.1078Z",
    fill: "url(#paint190_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M40.0044 15.4506C40.0044 15.4506 40.0392 15.4506 40.0566 15.4506C39.6392 15.9358 39.1348 16.161 38.5086 16.2823C38.9609 16.1956 39.4653 16.2823 39.9175 16.1783C40.0566 16.1437 40.648 15.7798 40.7871 15.8665C40.735 15.8318 40.7002 15.7452 40.648 15.7105C40.8915 15.2427 41.5872 14.2206 42.1786 14.1859C41.5176 14.2032 40.9437 14.671 40.2653 14.4978C39.3609 14.2899 41.1176 13.8047 41.3785 13.7354C41.0306 13.8047 40.1958 13.5275 39.9001 13.3543C40.7871 12.9905 41.6394 12.8519 42.5612 12.6613C40.9437 12.592 39.6566 12.8692 38.2999 13.7528C38.4912 13.6315 39.7957 13.7528 39.1 14.1339C38.6304 14.3938 38.1782 14.5844 37.8477 15.0175C38.2303 14.8096 38.7 14.6364 39.1348 14.5844C39.3609 14.5497 40.074 14.5497 40.1436 14.8269C39.3261 14.9309 38.1434 15.364 37.6912 16.109C38.4043 15.7279 39.2391 15.5199 40.0218 15.4506H40.0044Z",
    fill: "url(#paint191_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2,
    d: "M61.6937 32.0484C61.6937 32.0484 61.6589 32.0657 61.6589 32.083C61.5893 31.39 61.7981 30.8703 62.1981 30.3852C61.6763 31.0435 61.0676 31.4593 60.6675 32.239C60.3544 32.828 59.8674 33.0879 59.3109 33.4171C59.5717 33.2785 60.0935 33.3305 60.4066 33.1399C60.7197 32.9493 60.9806 32.6721 61.398 32.6548C61.5893 33.3478 60.911 33.9022 60.9632 34.5606C61.5893 34.2487 61.6067 33.3305 62.2851 33.0359C63.1721 32.6548 62.1981 34.1794 62.0416 34.3873C62.2503 34.0928 63.1373 33.8329 63.5026 33.7809C63.1199 34.6645 62.546 35.3229 61.9894 36.0679C63.3113 35.115 64.094 34.0581 64.4244 32.4122C64.3722 32.6548 63.2591 33.3651 63.4852 32.5855C63.6417 32.0657 63.8331 31.6153 63.7461 31.0089C63.6069 31.442 63.3808 31.8751 63.1025 32.2043C62.946 32.3776 62.3894 32.8107 62.1285 32.6201C62.6851 32.0137 63.2591 30.8876 62.9982 29.952C62.7547 30.7317 62.2677 31.4593 61.7111 32.0137L61.6937 32.0484Z",
    fill: "url(#paint192_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2,
    d: "M38.4568 23.0912C38.1785 22.5368 37.7959 21.8265 37.2741 21.4627C36.6827 21.0295 36.1957 20.9082 35.4826 21.0815C36.6131 21.4453 37.5176 22.3982 38.3872 23.1605C38.422 23.1952 38.4742 23.1432 38.4568 23.0912Z",
    fill: "url(#paint193_linear_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M21.3242 18.2748L20.4719 18.9504L20.3328 17.8763C20.3328 17.7723 20.211 17.6857 20.1067 17.703C20.0023 17.703 19.9153 17.8243 19.9327 17.9283L20.0719 19.0197L19.0457 18.6213C18.9413 18.5866 18.8196 18.6213 18.7848 18.7425C18.75 18.8465 18.7848 18.9678 18.9065 19.0024L19.9327 19.4009L19.0805 20.0766C18.9935 20.1459 18.9761 20.2672 19.0457 20.3538C19.1153 20.4404 19.237 20.4577 19.324 20.3884L20.1762 19.7128L20.3154 20.7869C20.3154 20.8909 20.4371 20.9775 20.5415 20.9602C20.6111 20.9602 20.6806 20.8909 20.698 20.8389C20.698 20.8043 20.698 20.7696 20.698 20.735L20.5589 19.6435L21.5851 20.0419C21.6894 20.0766 21.8112 20.0419 21.846 19.9207C21.8808 19.8167 21.846 19.6954 21.7242 19.6608L20.7154 19.2623L21.5677 18.5866C21.5677 18.5866 21.6199 18.5346 21.6373 18.5C21.6546 18.4307 21.6373 18.3614 21.6025 18.2921C21.5329 18.2055 21.4111 18.1881 21.3242 18.2574V18.2748Z",
    fill: "url(#paint194_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M29.9163 15.5201C29.9163 15.5201 30.0033 15.4335 30.0207 15.3815C30.0729 15.2775 30.0381 15.1389 29.9685 15.0523C29.8468 14.9137 29.638 14.8791 29.4989 15.0003C29.4467 15.035 29.4119 15.087 29.3945 15.1389C29.3597 15.2429 29.3771 15.3815 29.4467 15.4681C29.4641 15.4854 29.4815 15.5201 29.5163 15.5374L29.2902 16.5769L28.2292 17.4259L28.0205 16.0745L28.5771 15.1563C28.5771 15.1563 28.6466 15.1563 28.664 15.1563C28.7858 15.1563 28.8727 15.0523 28.9249 14.9484C28.9423 14.8964 28.9597 14.8444 28.9423 14.7751C28.9075 14.6019 28.751 14.4632 28.5597 14.4979C28.4379 14.4979 28.3509 14.6019 28.2988 14.7058C28.2814 14.7578 28.264 14.8098 28.2814 14.8791C28.2814 14.8964 28.2814 14.9137 28.2814 14.9484L27.9161 15.5374L27.8118 14.7924C27.8987 14.7231 27.9509 14.6019 27.9335 14.4979C27.9335 14.4113 27.8813 14.3246 27.7944 14.2727C27.7074 14.2207 27.6378 14.2034 27.5509 14.2034C27.4291 14.2034 27.3421 14.3073 27.29 14.4113C27.2726 14.4632 27.2552 14.5152 27.2726 14.5845C27.2726 14.7058 27.3595 14.7924 27.4639 14.8444L27.5857 15.5894L27.0639 15.1216C27.0639 15.1216 27.0639 15.0696 27.0639 15.0523C27.0465 14.8791 26.8725 14.7405 26.6812 14.7751C26.5595 14.7751 26.4725 14.8791 26.4203 14.983C26.4029 15.035 26.3855 15.1043 26.4029 15.1563C26.4377 15.3295 26.5942 15.4681 26.7856 15.4335C26.8204 15.4335 26.8551 15.4335 26.8725 15.4161L27.6726 16.1265L27.8813 17.4779L26.6116 16.9754L26.0898 16.0399C26.0898 16.0399 26.1246 15.9879 26.142 15.9532C26.2116 15.78 26.142 15.5894 25.9507 15.5201C25.7768 15.4508 25.5854 15.5201 25.5159 15.7107C25.4463 15.8839 25.5159 16.0745 25.7072 16.1438C25.7246 16.1438 25.742 16.1438 25.7768 16.1438L26.1072 16.7502L25.3941 16.473C25.3767 16.3517 25.2898 16.2651 25.1854 16.2131C25.0115 16.1438 24.8202 16.2131 24.7506 16.4037C24.681 16.5769 24.7506 16.7675 24.9419 16.8368C25.0463 16.8715 25.168 16.8541 25.2724 16.7848L25.9855 17.062L25.3246 17.2699C25.3246 17.2699 25.2898 17.2526 25.2724 17.2353C25.0984 17.166 24.9071 17.2353 24.8375 17.4259C24.768 17.5991 24.8375 17.7897 25.0289 17.859C25.2028 17.9283 25.3941 17.859 25.4637 17.6684C25.4637 17.6338 25.4811 17.6165 25.4811 17.5818L26.4899 17.2526L27.7596 17.7551L26.6812 18.604H25.6202C25.6202 18.604 25.5854 18.5347 25.5681 18.5C25.4463 18.3614 25.2376 18.3268 25.0984 18.4481C25.0463 18.4827 25.0115 18.5347 24.9941 18.5867C24.9593 18.6906 24.9767 18.8292 25.0463 18.9159C25.0984 18.9852 25.1854 19.0371 25.2724 19.0371C25.3593 19.0371 25.4463 19.0371 25.5159 18.9678C25.5159 18.9678 25.5507 18.9332 25.5681 18.9159H26.2638L25.6724 19.401C25.5681 19.3663 25.4463 19.3836 25.3419 19.4529C25.2898 19.4876 25.255 19.5396 25.2376 19.5915C25.2028 19.6955 25.2202 19.8341 25.2898 19.9207C25.4115 20.0593 25.6202 20.094 25.7594 19.9727C25.8463 19.9034 25.8985 19.7821 25.8811 19.6782L26.4725 19.2104L26.3334 19.8861C26.3334 19.8861 26.2986 19.9034 26.2812 19.9207C26.229 19.9554 26.1942 20.0073 26.1768 20.0593C26.1246 20.1633 26.1594 20.3019 26.229 20.3885C26.3507 20.5271 26.5595 20.5618 26.6986 20.4405C26.7508 20.4058 26.7856 20.3539 26.803 20.3019C26.8378 20.1979 26.8204 20.0593 26.7508 19.9727C26.7334 19.9554 26.716 19.9207 26.6812 19.9034L26.9073 18.8639L27.9857 18.0149L28.1944 19.3663L27.6378 20.2846C27.6378 20.2846 27.5683 20.2846 27.5509 20.2846C27.4291 20.2846 27.3421 20.3712 27.29 20.4925C27.2726 20.5444 27.2552 20.5964 27.2726 20.6657C27.2726 20.7523 27.3248 20.839 27.4117 20.8736C27.4813 20.9256 27.5683 20.9429 27.6552 20.9429C27.777 20.9256 27.8639 20.839 27.9161 20.735C27.9335 20.683 27.9509 20.6137 27.9335 20.5618C27.9335 20.5444 27.9335 20.5271 27.9335 20.4925L28.2988 19.9034L28.4031 20.6484C28.3162 20.7177 28.264 20.839 28.2814 20.9429C28.3162 21.1162 28.4727 21.2548 28.664 21.2201C28.7858 21.2201 28.8727 21.1162 28.9249 21.0122C28.9423 20.9602 28.9597 20.9083 28.9423 20.839C28.9423 20.7177 28.8553 20.6311 28.7336 20.5791L28.6292 19.8341L29.151 20.3019C29.151 20.3019 29.151 20.3365 29.151 20.3712C29.1858 20.5618 29.3424 20.683 29.5337 20.6484C29.6554 20.6311 29.7424 20.5444 29.7946 20.4405C29.812 20.3885 29.8294 20.3192 29.812 20.2672C29.812 20.1806 29.7598 20.1113 29.6902 20.042C29.6206 19.99 29.5337 19.9727 29.4467 19.9727C29.4119 19.9727 29.3945 19.9727 29.3597 20.0073L28.5597 19.297L28.3509 17.9456L29.6206 18.4481L30.1424 19.3836C30.1424 19.3836 30.1077 19.4356 30.0903 19.4703C30.0207 19.6435 30.0903 19.8341 30.2816 19.9034C30.4555 19.9727 30.6468 19.9034 30.7164 19.7128C30.786 19.5396 30.7164 19.349 30.5251 19.2797C30.5077 19.2797 30.4903 19.2797 30.4555 19.2624L30.125 18.656L30.8382 18.9332C30.8556 19.0545 30.9425 19.1411 31.0469 19.1931C31.2208 19.2624 31.4121 19.1931 31.4817 19.0025C31.5513 18.8292 31.4817 18.6386 31.2904 18.5693C31.186 18.5347 31.0643 18.552 30.9599 18.6213L30.2468 18.3441L30.9077 18.1362C30.9077 18.1362 30.9425 18.1535 30.9599 18.1709C31.1338 18.2402 31.3252 18.1709 31.3947 17.9803C31.4643 17.807 31.3947 17.6165 31.2034 17.5472C31.0295 17.4779 30.8382 17.5472 30.7686 17.7377C30.7686 17.7724 30.7686 17.7897 30.7512 17.8244L29.7424 18.1535L28.4727 17.6511L29.5337 16.8022H30.5947C30.5947 16.8022 30.6294 16.8715 30.6468 16.9061C30.7686 17.0447 30.9773 17.0794 31.1164 16.9581C31.1686 16.9234 31.2034 16.8715 31.2208 16.8195C31.273 16.7155 31.2382 16.5769 31.1686 16.4903C31.0469 16.3517 30.8382 16.3171 30.699 16.4383C30.699 16.4383 30.6642 16.473 30.6468 16.4903H29.9511L30.5425 16.0052C30.6468 16.0399 30.7686 16.0225 30.8729 15.9532C30.9251 15.9186 30.9599 15.8666 30.9773 15.8146C31.0121 15.7107 30.9947 15.5721 30.9251 15.4854C30.8034 15.3468 30.5947 15.3122 30.4555 15.4335C30.3685 15.5028 30.3164 15.624 30.3338 15.728L29.7424 16.1958L29.8815 15.5201C29.8815 15.5201 29.9163 15.5028 29.9337 15.4854L29.9163 15.5201Z",
    fill: "url(#paint195_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M16.0542 22.6582L15.8281 23.6977L16.7325 22.97C16.7151 22.8141 16.7673 22.6582 16.8891 22.5715C17.0804 22.4329 17.3413 22.4503 17.4804 22.6409C17.6196 22.8314 17.6022 23.0913 17.4109 23.2299C17.2891 23.3339 17.1152 23.3512 16.976 23.2819L16.0716 24.0096H17.15C17.15 24.0096 17.1847 23.9749 17.2195 23.9576C17.4109 23.819 17.6718 23.8363 17.8109 24.0269C17.95 24.2175 17.9326 24.4773 17.7413 24.6159C17.55 24.7545 17.2891 24.7372 17.15 24.5466C17.1152 24.512 17.0978 24.4773 17.0804 24.4254L15.5672 24.3907L15.0106 24.8412L15.1845 26.0539L15.8455 26.3138L17.2717 25.846C17.2717 25.846 17.2717 25.7594 17.3065 25.7074C17.3935 25.4995 17.637 25.3782 17.8631 25.4649C18.0718 25.5515 18.1935 25.7941 18.1066 26.0193C18.0196 26.2445 17.7761 26.3485 17.55 26.2618C17.5152 26.2618 17.4978 26.2272 17.463 26.2099L16.4368 26.539L17.5152 26.9722C17.637 26.8856 17.7935 26.8509 17.95 26.9029C18.1762 26.9895 18.2805 27.2321 18.1935 27.4573C18.1066 27.6825 17.8631 27.7865 17.637 27.6998C17.4804 27.6479 17.3935 27.5093 17.3761 27.3533L16.2977 26.9202L16.8195 27.8558C16.8195 27.8558 16.8891 27.8558 16.9065 27.8731C17.1326 27.9597 17.2369 28.2023 17.15 28.4275C17.063 28.6527 16.8195 28.7567 16.5934 28.6701C16.3847 28.5834 16.2629 28.3409 16.3499 28.1156C16.3673 28.0637 16.3847 28.029 16.4195 27.9944L15.6889 26.6776L15.028 26.4178L14.054 27.1801L14.1583 27.8904L15.2715 28.8953C15.2715 28.8953 15.3585 28.8606 15.4107 28.8606C15.6368 28.826 15.8629 28.9819 15.8977 29.2245C15.9324 29.4497 15.7759 29.6749 15.5324 29.7096C15.3063 29.7442 15.0802 29.5883 15.0454 29.3457C15.0454 29.3111 15.0454 29.2764 15.0454 29.2418L14.2453 28.5315L14.4192 29.6749C14.5584 29.7269 14.6627 29.8482 14.6975 30.0041C14.7323 30.2293 14.5758 30.4546 14.3323 30.4892C14.1062 30.5239 13.8801 30.3679 13.8453 30.1254C13.8279 29.9695 13.8975 29.8135 14.0018 29.7269L13.8279 28.5834L13.2713 29.5017C13.2713 29.5017 13.2887 29.571 13.3061 29.5883C13.3409 29.8135 13.1843 30.0388 12.9408 30.0734C12.7147 30.1081 12.4886 29.9521 12.4538 29.7096C12.419 29.4843 12.5756 29.2591 12.8191 29.2245C12.8713 29.2245 12.906 29.2245 12.9582 29.2245L13.7409 27.9424L13.6366 27.2321L12.4886 26.7816L11.932 27.2321L11.619 28.7047C11.619 28.7047 11.6885 28.7567 11.7233 28.7913C11.8625 28.9819 11.8451 29.2418 11.6537 29.3804C11.4624 29.5363 11.2015 29.5017 11.0624 29.3111C10.9232 29.1205 10.9406 28.8606 11.132 28.722C11.1667 28.7047 11.1841 28.6874 11.2189 28.6701L11.445 27.6305L10.5406 28.3409C10.558 28.4968 10.5058 28.6527 10.3841 28.7394C10.1927 28.878 9.93183 28.8606 9.79269 28.6701C9.65354 28.4795 9.67094 28.2196 9.86226 28.081C9.98401 27.977 10.1579 27.9597 10.2971 28.029L11.2015 27.3014H10.1232C10.1232 27.3014 10.0884 27.336 10.0536 27.3533C9.86226 27.4919 9.60136 27.4746 9.46222 27.284C9.32307 27.0935 9.34047 26.8336 9.53179 26.695C9.72311 26.5564 9.98401 26.5737 10.1232 26.7643C10.1579 26.7989 10.1753 26.8336 10.1927 26.8856L11.7059 26.9202L12.2625 26.4697L12.0886 25.257L11.4276 24.9971L10.0014 25.4649C10.0014 25.4649 10.0014 25.5515 9.96662 25.6035C9.87965 25.8114 9.63615 25.9327 9.41004 25.846C9.20132 25.7594 9.07957 25.5169 9.16654 25.2916C9.2535 25.0837 9.497 24.9624 9.72311 25.0491C9.7579 25.0491 9.79269 25.0837 9.81008 25.101L10.8363 24.7719L9.7579 24.3387C9.63615 24.4427 9.47961 24.46 9.32307 24.408C9.11436 24.3214 8.9926 24.0789 9.07957 23.8536C9.16654 23.6284 9.41004 23.5244 9.63615 23.6111C9.79269 23.663 9.87965 23.8016 9.89705 23.9576L10.9754 24.3907L10.4536 23.4551C10.4536 23.4551 10.3841 23.4551 10.3667 23.4378C10.1405 23.3512 10.0362 23.1086 10.1232 22.8834C10.2101 22.6582 10.4536 22.5542 10.6797 22.6409C10.9058 22.7275 11.0102 22.97 10.9232 23.1953C10.9232 23.2472 10.8885 23.2819 10.8537 23.3165L11.5842 24.6333L12.2451 24.8931L13.2191 24.1308L13.1148 23.4205L12.0016 22.4156C12.0016 22.4156 11.9146 22.4503 11.8625 22.4503C11.6364 22.4849 11.4102 22.329 11.3755 22.0864C11.3407 21.8612 11.4972 21.636 11.7407 21.6013C11.9668 21.5667 12.1929 21.7226 12.2277 21.9478C12.2277 21.9825 12.2277 22.0171 12.2277 22.0518L13.0278 22.7621L12.8539 21.6187C12.7147 21.5667 12.6104 21.4454 12.5756 21.2895C12.5408 21.0642 12.6973 20.839 12.9408 20.8044C13.1669 20.7697 13.3931 20.9256 13.4278 21.1682C13.4452 21.3241 13.3757 21.4801 13.2713 21.5667L13.4452 22.7102L14.0018 21.7919C14.0018 21.7919 13.9844 21.7226 13.9844 21.7053C13.9496 21.4801 14.1062 21.2548 14.3497 21.2202C14.5758 21.1855 14.8019 21.3415 14.8367 21.584C14.8715 21.8092 14.7149 22.0345 14.4714 22.0691C14.4192 22.0691 14.3845 22.0691 14.3323 22.0691L13.5496 23.3512L13.654 24.0615L14.8019 24.512L15.3585 24.0615L15.6715 22.5889C15.6715 22.5889 15.602 22.5369 15.5672 22.5022C15.428 22.3117 15.4454 22.0518 15.6368 21.9132C15.8281 21.7746 16.089 21.7919 16.2281 21.9825C16.3673 22.1731 16.3499 22.4329 16.1586 22.5715C16.1238 22.5889 16.1064 22.6062 16.0716 22.6235L16.0542 22.6582ZM13.6887 24.564L13.7931 25.3263L14.3845 24.8585L13.6713 24.5813L13.6887 24.564ZM13.3931 25.3782L13.2887 24.6159L12.6973 25.0837L13.4104 25.3609L13.3931 25.3782ZM13.8975 26.002L14.0018 26.7643L14.5932 26.2965L13.8801 26.0193L13.8975 26.002ZM13.2365 25.7594L12.5234 25.4822L12.6278 26.2445L13.2191 25.7767L13.2365 25.7594ZM14.7671 25.9153L14.6627 25.153L14.054 25.6208L14.7671 25.898V25.9153ZM13.6018 26.8163L13.48 26.0539L12.8887 26.5217L13.6018 26.7989V26.8163Z",
    fill: "url(#paint196_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M57.2061 35.323L56.4234 36.0333L56.2147 34.9938C56.1973 34.8898 56.0929 34.8205 55.9712 34.8379C55.8668 34.8552 55.7972 34.9591 55.8146 35.0804L56.0233 36.1373L54.9972 35.8081C54.8928 35.7734 54.7884 35.8254 54.7537 35.9467C54.7189 36.0506 54.771 36.1546 54.8928 36.1892L55.919 36.5011L55.1363 37.2288C55.1363 37.2288 55.0493 37.4367 55.1363 37.506C55.2059 37.5926 55.345 37.5926 55.4146 37.506L56.1973 36.7956L56.406 37.8351C56.4234 37.9391 56.5277 38.0084 56.6321 37.9911C56.7017 37.9911 56.7712 37.9218 56.7886 37.8525C56.7886 37.8178 56.7886 37.7832 56.7886 37.7485L56.5799 36.6917L57.6061 37.0208C57.7105 37.0555 57.8148 36.9862 57.8496 36.8822C57.8844 36.7783 57.8322 36.6743 57.7105 36.6397L56.6843 36.3278L57.467 35.6002C57.467 35.6002 57.5192 35.5482 57.5192 35.5135C57.5365 35.4442 57.5192 35.3749 57.467 35.323C57.3974 35.2363 57.2583 35.2363 57.1887 35.323H57.2061Z",
    fill: "url(#paint197_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M62.9807 12.5574C62.9807 12.5574 63.0502 12.4708 63.0676 12.4188C63.1024 12.3148 63.0676 12.1935 62.9981 12.1069C62.8763 11.9683 62.6676 11.9683 62.5458 12.0896C62.5111 12.1242 62.4763 12.1762 62.4589 12.2282C62.4241 12.3322 62.4589 12.4534 62.5285 12.5401C62.5458 12.5574 62.5632 12.5747 62.598 12.592L62.4589 13.6315L61.4675 14.5325L61.1718 13.2331L61.6414 12.2975C61.6414 12.2975 61.711 12.2975 61.7284 12.2975C61.8501 12.2802 61.9371 12.1935 61.9719 12.0723C61.9719 12.0203 61.9893 11.9683 61.9719 11.899C61.9371 11.7258 61.7632 11.6218 61.5892 11.6565C61.4675 11.6738 61.3805 11.7604 61.3457 11.8817C61.3457 11.9337 61.3283 11.9856 61.3457 12.0549C61.3457 12.0723 61.3457 12.0896 61.3631 12.1069L61.05 12.7133L60.8935 11.9856C60.8935 11.9856 61.0153 11.7951 60.9805 11.6738C60.9631 11.5872 60.9109 11.5179 60.8413 11.4659C60.7718 11.4139 60.6848 11.3966 60.5978 11.4312C60.4761 11.4486 60.3891 11.5352 60.3543 11.6565C60.3543 11.7084 60.3369 11.7604 60.3543 11.8297C60.3717 11.9337 60.4587 12.0376 60.563 12.0723L60.7196 12.7999L60.1804 12.3841C60.1804 12.3841 60.1804 12.3495 60.1804 12.3148C60.1456 12.1416 59.9717 12.0376 59.7977 12.0723C59.6934 12.0896 59.589 12.1762 59.5542 12.2975C59.5542 12.3495 59.5368 12.4015 59.5542 12.4708C59.589 12.644 59.763 12.748 59.9369 12.7133C59.9717 12.7133 59.9891 12.7133 60.0238 12.6787L60.8413 13.3197L61.137 14.6191L59.8673 14.2206L59.2933 13.3543C59.2933 13.3543 59.3281 13.3024 59.3281 13.2677C59.3803 13.0945 59.2933 12.9212 59.1194 12.8692C58.9455 12.8173 58.7715 12.9039 58.7194 13.0771C58.6672 13.2504 58.7542 13.4236 58.9281 13.4929C58.9455 13.4929 58.9629 13.4929 58.9977 13.4929L59.3629 14.0647L58.6498 13.8395C58.6324 13.7355 58.5454 13.6489 58.4237 13.6142C58.2498 13.5622 58.0758 13.6489 58.0236 13.8221C57.9715 13.9954 58.0584 14.1686 58.2324 14.2206C58.3367 14.2553 58.4585 14.2206 58.5454 14.1513L59.2586 14.3765L58.615 14.6364C58.615 14.6364 58.5802 14.6191 58.5628 14.6191C58.3889 14.5671 58.215 14.6537 58.1628 14.827C58.1106 15.0002 58.1976 15.1735 58.3715 15.2428C58.5454 15.2948 58.7194 15.2082 58.7715 15.0349C58.7715 15.0002 58.7715 14.9829 58.7715 14.9483L59.7456 14.5498L61.0153 14.9483L60.0238 15.8492L58.9803 15.9012C58.9803 15.9012 58.9455 15.8492 58.9281 15.8319C58.8063 15.6933 58.5976 15.6933 58.4759 15.8145C58.4411 15.8492 58.4063 15.9012 58.3889 15.9531C58.3541 16.0571 58.3889 16.1784 58.4585 16.265C58.5107 16.3343 58.5976 16.369 58.6846 16.369C58.7715 16.369 58.8585 16.3343 58.9107 16.2823C58.9107 16.2823 58.9455 16.2477 58.9455 16.2303L59.6238 16.1957L59.0672 16.6981C58.9629 16.6635 58.8411 16.6981 58.7542 16.7674C58.7194 16.8021 58.6846 16.8541 58.6672 16.906C58.6324 17.01 58.6672 17.1313 58.7368 17.2179C58.8585 17.3565 59.0672 17.3565 59.189 17.2352C59.2759 17.1659 59.3107 17.0446 59.2933 16.9407L59.8499 16.4383L59.763 17.1139C59.763 17.1139 59.7282 17.1313 59.7108 17.1486C59.676 17.1832 59.6412 17.2352 59.6238 17.2872C59.589 17.3911 59.6238 17.5124 59.6934 17.599C59.8151 17.7376 60.0238 17.7376 60.163 17.6164C60.1978 17.5817 60.2326 17.5297 60.25 17.4778C60.2847 17.3738 60.25 17.2525 60.1804 17.1659C60.163 17.1486 60.1282 17.1313 60.1108 17.1139L60.25 16.0744L61.2414 15.1735L61.537 16.4729L61.0674 17.4085C61.0674 17.4085 60.9979 17.4085 60.9805 17.4085C60.8587 17.4258 60.7718 17.5124 60.737 17.6337C60.737 17.6857 60.7196 17.7376 60.737 17.807C60.7544 17.8936 60.8065 17.9629 60.8761 18.0149C60.9457 18.0668 61.0326 18.0842 61.1196 18.0495C61.2414 18.0322 61.3283 17.9456 61.3631 17.8243C61.3631 17.7723 61.3805 17.7203 61.3631 17.651C61.3631 17.6337 61.3631 17.6164 61.3457 17.5817L61.6588 16.9753L61.8153 17.703C61.8153 17.703 61.6936 17.8936 61.7284 18.0149C61.7632 18.1881 61.9371 18.3094 62.111 18.2574C62.2328 18.2401 62.3197 18.1535 62.3545 18.0322C62.3719 17.9802 62.3719 17.9282 62.3545 17.8589C62.3371 17.755 62.2502 17.651 62.1458 17.6164L61.9893 16.8887L62.5285 17.3045C62.5285 17.3045 62.5285 17.3565 62.5285 17.3738C62.5632 17.5471 62.7372 17.651 62.9111 17.6164C63.0155 17.599 63.1198 17.5124 63.1546 17.3911C63.1546 17.3392 63.172 17.2872 63.1546 17.2179C63.1372 17.1313 63.085 17.062 63.0155 17.01C62.9459 16.958 62.8589 16.9407 62.772 16.958C62.7372 16.958 62.7198 16.958 62.685 16.9927L61.8501 16.3516L61.5544 15.0522L62.8241 15.4507L63.3981 16.317C63.3981 16.317 63.3633 16.369 63.3633 16.4036C63.3111 16.5769 63.3981 16.7501 63.572 16.8194C63.746 16.8714 63.9199 16.7848 63.9721 16.6115C64.0243 16.4383 63.9373 16.265 63.7634 16.213C63.746 16.213 63.7286 16.213 63.6938 16.213L63.3285 15.6413L64.0416 15.8665C64.0764 15.9705 64.146 16.0744 64.2678 16.0917C64.4417 16.1437 64.6156 16.0571 64.6852 15.8838C64.7374 15.7106 64.6504 15.5373 64.4765 15.4854C64.3721 15.4507 64.2504 15.4854 64.1634 15.5547L63.4503 15.3294L64.0764 15.0696C64.0764 15.0696 64.1112 15.0869 64.1286 15.0869C64.3025 15.1389 64.4765 15.0522 64.5287 14.879C64.5808 14.7057 64.4939 14.5325 64.3199 14.4805C64.146 14.4285 63.9721 14.5151 63.9199 14.6884C63.9199 14.723 63.9199 14.7404 63.9199 14.775L62.9459 15.1735L61.6762 14.775L62.6676 13.8741L63.7112 13.8221C63.7112 13.8221 63.746 13.8741 63.7634 13.8914C63.8851 14.03 64.0938 14.03 64.2156 13.9088C64.2504 13.8741 64.2852 13.8221 64.3025 13.7702C64.3373 13.6662 64.3025 13.5449 64.233 13.4583C64.1112 13.3197 63.9025 13.3197 63.7808 13.441C63.7808 13.441 63.746 13.4756 63.746 13.4929L63.0676 13.5276L63.6242 13.0252C63.7286 13.0598 63.8503 13.0252 63.9373 12.9559C63.9721 12.9212 64.0069 12.8692 64.0243 12.8173C64.059 12.7133 64.0243 12.592 63.9547 12.5054C63.8329 12.3668 63.6242 12.3668 63.5025 12.4881C63.4155 12.5574 63.3807 12.6787 63.3981 12.7826L62.8415 13.285L62.9285 12.6094C62.9285 12.6094 62.9633 12.592 62.9807 12.5747V12.5574Z",
    fill: "url(#paint198_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M12.6279 61.5188C13.8802 61.5188 14.9064 62.5237 14.9064 63.7711C14.9064 65.0185 13.8976 66.0407 12.6453 66.0407C11.393 66.0407 10.3668 65.0358 10.3668 63.7884C10.3668 62.541 11.3756 61.5188 12.6279 61.5188Z",
    fill: "url(#paint199_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M68.7728 8.64182L68.1988 9.62936L67.6422 8.64182C67.5901 8.53787 67.4509 8.50321 67.3466 8.55519C67.2422 8.60717 67.2074 8.74577 67.2596 8.84972L67.8162 9.85459H66.6682C66.5465 9.85459 66.4595 9.95854 66.4595 10.0798C66.4595 10.2011 66.5639 10.2877 66.6682 10.2877H67.8162L67.2422 11.2753C67.19 11.3792 67.2248 11.5005 67.3292 11.5698C67.4335 11.6218 67.5553 11.5871 67.6248 11.5005L68.1988 10.513L68.7554 11.5005C68.8076 11.6044 68.9467 11.6391 69.0511 11.5871C69.1206 11.5525 69.1554 11.4832 69.1554 11.3965C69.1554 11.3619 69.1554 11.3272 69.1206 11.2926L68.5641 10.2877H69.712C69.8338 10.2877 69.9207 10.1838 69.9207 10.0625C69.9207 9.94122 69.8164 9.85459 69.712 9.85459H68.5641L69.138 8.86705C69.1554 8.8324 69.1728 8.79774 69.1728 8.76309C69.1728 8.69379 69.138 8.62449 69.0685 8.57252C68.9641 8.52054 68.8424 8.55519 68.7728 8.65914V8.64182Z",
    fill: "url(#paint200_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M79.5217 16.6809L79.7478 17.9629L80.2522 17.0967C80.2522 17.0967 80.4087 16.9927 80.4783 17.0274C80.5653 17.0793 80.5827 17.1833 80.5479 17.2526L80.0435 18.1189L81.261 17.6511C81.348 17.6164 81.4523 17.6511 81.4871 17.755C81.5219 17.8417 81.4871 17.9456 81.3827 17.9803L79.7652 18.5866L79.5565 18.9505L80.7914 18.4827C80.8783 18.448 80.9827 18.4827 81.0175 18.5866C81.0523 18.6733 81.0175 18.7772 80.9131 18.8119L79.2956 19.4183L79.0869 19.7648L80.3218 19.297C80.4087 19.2623 80.5131 19.297 80.5479 19.4009C80.5827 19.4876 80.5479 19.5915 80.4435 19.6262L78.826 20.2326L78.3737 21.0295L78.8607 21.8611H79.7826L81.1045 20.7523C81.174 20.7003 81.2784 20.7003 81.348 20.7696C81.4175 20.8389 81.4001 20.9429 81.3306 21.0122L80.3218 21.8438H80.7392L82.0611 20.7523C82.1306 20.683 82.235 20.7003 82.3046 20.7696C82.3568 20.8389 82.3568 20.9429 82.2872 21.0122L81.2784 21.8438H81.6958L83.0177 20.7523C83.0873 20.683 83.1916 20.7003 83.2612 20.7696C83.3134 20.8389 83.3134 20.9429 83.2438 21.0122L82.235 21.8438H83.2438C83.3308 21.8438 83.4177 21.9131 83.4177 21.9997C83.4177 22.0864 83.3482 22.173 83.2438 22.173H82.235L83.2438 23.0046C83.3134 23.0566 83.3308 23.1779 83.2612 23.2472C83.1916 23.3165 83.0873 23.3338 83.0177 23.2645L81.6784 22.173H81.261L82.2698 23.0046C82.3394 23.0566 82.3568 23.1779 82.2872 23.2472C82.2176 23.3165 82.1133 23.3338 82.0437 23.2645L80.7044 22.173H80.287L81.2958 23.0046C81.3654 23.0566 81.3827 23.1779 81.3132 23.2472C81.261 23.3165 81.1392 23.3338 81.0697 23.2645L79.7304 22.173H78.8086L78.339 23.0046L78.8086 23.8016L80.4261 24.3906C80.5131 24.4253 80.5653 24.5292 80.5305 24.6159C80.4957 24.7025 80.3913 24.7545 80.3044 24.7198L79.0695 24.2694L79.2782 24.6159L80.8957 25.2049C80.9827 25.2396 81.0349 25.3435 81.0001 25.4301C80.9653 25.5168 80.861 25.5688 80.774 25.5341L79.5391 25.0836L79.7478 25.4301L81.3654 26.0192C81.4523 26.0539 81.5045 26.1578 81.4697 26.2271C81.4349 26.3137 81.3306 26.3657 81.2436 26.3311L80.0087 25.8806L80.5131 26.7469C80.5131 26.7469 80.5305 26.9375 80.4435 26.9721C80.3566 27.0241 80.2522 26.9894 80.2174 26.9028L79.713 26.0365L79.5043 27.3186C79.5043 27.4052 79.3999 27.4745 79.313 27.4572C79.226 27.4572 79.1564 27.3533 79.1738 27.2666L79.4521 25.5688L79.2434 25.2222L79.0347 26.5216C79.0347 26.6083 78.9303 26.6776 78.8434 26.6602C78.7564 26.6429 78.6868 26.5563 78.7042 26.4697L78.9825 24.7718L78.7738 24.4253L78.5651 25.7247C78.5651 25.8113 78.4607 25.8806 78.3737 25.8633C78.2868 25.8633 78.2172 25.7593 78.2346 25.6727L78.5129 23.9748L78.0607 23.1952H77.0867L76.6344 23.9748L76.9301 25.6727C76.9301 25.7593 76.8779 25.846 76.791 25.8633C76.704 25.8633 76.617 25.8113 76.5997 25.7247L76.3735 24.4426L76.1648 24.8064L76.4605 26.5043C76.4605 26.5909 76.4083 26.6776 76.3214 26.6949C76.2344 26.6949 76.1474 26.6429 76.13 26.5563L75.9039 25.2742L75.6952 25.6381L75.9909 27.3359C75.9909 27.4226 75.9387 27.5092 75.8517 27.5265C75.7648 27.5265 75.6778 27.4745 75.6604 27.3879L75.4343 26.1058L74.9299 26.9721C74.9299 26.9721 74.7734 27.0761 74.7038 27.0414C74.6168 26.9894 74.5994 26.8855 74.6342 26.8162L75.1386 25.9499L73.9037 26.4177C73.8168 26.4523 73.7124 26.4177 73.6776 26.3137C73.6428 26.2271 73.6776 26.1232 73.782 26.1058L75.3995 25.4994L75.6082 25.1529L74.3733 25.6207C74.2864 25.6554 74.182 25.6207 74.1472 25.5168C74.1124 25.4301 74.1472 25.3262 74.2516 25.2915L75.8691 24.6852L76.0779 24.3387L74.843 24.8064C74.756 24.8411 74.6516 24.8064 74.6168 24.7025C74.5821 24.6159 74.6168 24.5119 74.7212 24.4773L76.3388 23.8709L76.7736 23.1086L76.2692 22.2423H75.3821L74.0603 23.3511C73.9907 23.4204 73.8863 23.4031 73.8168 23.3338C73.7472 23.2645 73.7646 23.1605 73.8341 23.0912L74.843 22.2596H74.4255L73.1036 23.3684C73.0341 23.4204 72.9297 23.4204 72.8601 23.3511C72.7906 23.2818 72.808 23.1779 72.8775 23.1086L73.8863 22.2769H73.4689L72.147 23.3684C72.0774 23.4377 71.9731 23.4204 71.9035 23.3511C71.8513 23.2818 71.8513 23.1779 71.9209 23.1086L72.9297 22.2769H71.9209C71.8339 22.2769 71.747 22.2076 71.747 22.1037C71.747 21.9997 71.8166 21.9304 71.9209 21.9304H72.9297L71.9209 21.0988C71.8513 21.0468 71.8339 20.9256 71.9035 20.8563C71.9557 20.787 72.0774 20.7696 72.147 20.8389L73.4863 21.9304H73.9037L72.8949 21.0988C72.8253 21.0468 72.808 20.9256 72.8775 20.8563C72.9471 20.787 73.0515 20.7696 73.121 20.8389L74.4603 21.9304H74.8777L73.8689 21.0988C73.7994 21.0468 73.782 20.9256 73.8515 20.8563C73.9037 20.787 74.0255 20.7696 74.095 20.8389L75.4343 21.9304H76.3214L76.8258 21.0642L76.3735 20.3019L74.756 19.7128C74.669 19.6781 74.6168 19.5742 74.6516 19.4876C74.6864 19.4009 74.7908 19.349 74.8777 19.3836L76.1126 19.8341L75.9039 19.4876L74.2864 18.8985C74.1994 18.8639 74.1472 18.7599 74.182 18.6733C74.2168 18.5866 74.3212 18.5347 74.4081 18.5693L75.643 19.0198L75.4343 18.6733L73.8168 18.0842C73.7298 18.0496 73.6776 17.9456 73.7124 17.859C73.7472 17.7724 73.8515 17.7204 73.9385 17.755L75.1734 18.2055L74.669 17.3392C74.669 17.3392 74.6516 17.1486 74.7386 17.114C74.8256 17.062 74.9299 17.0967 74.9647 17.1833L75.4691 18.0496L75.6778 16.7675C75.6778 16.6809 75.7822 16.6116 75.8691 16.6289C75.9561 16.6289 76.0257 16.7328 76.0083 16.8195L75.73 18.5173L75.9387 18.8639L76.1474 17.5818C76.1474 17.4952 76.2518 17.4259 76.3388 17.4432C76.4257 17.4432 76.4953 17.5471 76.4779 17.6338L76.1996 19.3316L76.4083 19.6781L76.617 18.3961C76.617 18.3094 76.7214 18.2401 76.8084 18.2575C76.8953 18.2575 76.9649 18.3614 76.9475 18.448L76.6692 20.1459L77.1214 20.9256H78.0955L78.5477 20.1286L78.252 18.4307C78.252 18.3441 78.3042 18.2575 78.3911 18.2401C78.4781 18.2401 78.5651 18.2921 78.5825 18.3787L78.8086 19.6608L79.0173 19.3143L78.7216 17.6164C78.7216 17.5298 78.7738 17.4432 78.8607 17.4259C78.9477 17.4259 79.0347 17.4778 79.0521 17.5645L79.2782 18.8465L79.4869 18.4827L79.1912 16.7848C79.1912 16.6982 79.2434 16.6116 79.3304 16.5942C79.4173 16.5942 79.5043 16.6462 79.5217 16.7328V16.6809ZM77.0867 21.2028L76.5997 22.0517L77.0867 22.9007H78.0607L78.5477 22.0517L78.0607 21.2028H77.0867Z",
    fill: "url(#paint201_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M58.2151 4.57042C59.2761 4.63972 60.0762 5.55796 60.0066 6.61481C59.937 7.67165 59.0152 8.46862 57.9542 8.39932C56.8932 8.33001 56.0932 7.41177 56.1627 6.35493C56.2323 5.29808 57.1541 4.50112 58.2151 4.57042Z",
    fill: "url(#paint202_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M32.0208 9.56026C32.7513 9.61224 33.3078 10.2359 33.2557 10.9636C33.2035 11.6913 32.5773 12.2457 31.8468 12.1937C31.1163 12.1417 30.5597 11.518 30.6119 10.7904C30.6641 10.0627 31.2902 9.50829 32.0208 9.56026Z",
    fill: "url(#paint203_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M45.466 6.1125L44.9268 6.90947L44.5268 6.0432C44.492 5.95658 44.3703 5.92193 44.2833 5.95658C44.1963 5.99123 44.1615 6.1125 44.1963 6.19913L44.6138 7.08272L43.6397 7.01342C43.5354 7.01342 43.4484 7.08272 43.4484 7.18667C43.4484 7.29063 43.518 7.37725 43.6224 7.37725L44.5964 7.44655L44.0572 8.24352C44.0572 8.24352 44.0224 8.4341 44.1094 8.48607C44.1963 8.53805 44.3007 8.52072 44.3529 8.4341L44.8921 7.63713L45.2921 8.5034C45.3269 8.59002 45.4486 8.642 45.5356 8.59002C45.6052 8.55537 45.64 8.5034 45.64 8.4341C45.64 8.39945 45.64 8.38212 45.64 8.34747L45.2225 7.46388L46.1965 7.53318C46.3009 7.53318 46.3879 7.46388 46.3879 7.35993C46.3879 7.25597 46.3183 7.16935 46.2139 7.16935L45.2399 7.10005L45.7791 6.30308C45.7791 6.30308 45.8139 6.25111 45.8139 6.21646C45.8139 6.14715 45.7965 6.09518 45.7269 6.06053C45.64 6.00855 45.5356 6.02588 45.4834 6.1125H45.466Z",
    fill: "url(#paint204_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M90.2706 45.6835L90.4097 47.0002L90.9663 46.1686C90.9663 46.1686 91.1228 46.0647 91.2098 46.1167C91.2794 46.1686 91.3141 46.2726 91.262 46.3592L90.7054 47.1908L91.9751 46.8097C92.062 46.775 92.1664 46.827 92.1838 46.9309C92.2186 47.0176 92.1664 47.1215 92.062 47.1388L90.3923 47.6413L90.1662 47.9878L91.4359 47.6066C91.5229 47.572 91.6272 47.624 91.6446 47.7279C91.6794 47.8145 91.6272 47.9185 91.5229 47.9358L89.8531 48.4382L89.627 48.7847L90.8967 48.4036C90.9837 48.3689 91.088 48.4209 91.1054 48.5249C91.1402 48.6115 91.088 48.7154 90.9837 48.7328L89.3139 49.2352L88.7921 50.0148L89.227 50.8811L90.1662 50.9504L91.575 49.9455C91.575 49.9455 91.7664 49.9109 91.8185 49.9802C91.8707 50.0495 91.8533 50.1708 91.7838 50.2227L90.7054 51.0024L91.1228 51.037L92.5317 50.0322C92.5317 50.0322 92.723 49.9975 92.7752 50.0668C92.8273 50.1361 92.8099 50.2574 92.7404 50.3094L91.662 51.0717L92.0794 51.1063L93.4883 50.1015C93.4883 50.1015 93.6796 50.0668 93.7318 50.1361C93.784 50.2054 93.7666 50.3267 93.697 50.3787L92.6186 51.141L93.6274 51.2103C93.7144 51.2103 93.8014 51.2969 93.784 51.4009C93.784 51.4875 93.697 51.5568 93.61 51.5568L92.6012 51.4875L93.5578 52.3884C93.5578 52.3884 93.6274 52.5617 93.5578 52.631C93.4883 52.7003 93.3839 52.7003 93.3143 52.631L92.0447 51.4355L91.6272 51.4009L92.5838 52.3018C92.5838 52.3018 92.6534 52.475 92.5838 52.5443C92.5143 52.6136 92.4099 52.6136 92.3403 52.5443L91.0706 51.3489L90.6532 51.3142L91.6098 52.2152C91.6098 52.2152 91.6794 52.3884 91.6098 52.4577C91.5403 52.527 91.4359 52.527 91.3663 52.4577L90.0966 51.2623L89.1574 51.193L88.6182 51.9899L89.0357 52.8215L90.6184 53.5319C90.6184 53.5319 90.7402 53.6705 90.7054 53.7571C90.6706 53.8437 90.5662 53.8784 90.4793 53.8437L89.2792 53.3067L89.4705 53.6705L91.0532 54.3808C91.0532 54.3808 91.175 54.5194 91.1402 54.6061C91.1054 54.6927 91.0011 54.7273 90.9141 54.6927L89.714 54.1556L89.9053 54.5194L91.4881 55.2298C91.4881 55.2298 91.6098 55.3684 91.575 55.455C91.5403 55.5416 91.4359 55.5763 91.3489 55.5416L90.1488 55.0045L90.601 55.9055C90.601 55.9055 90.601 56.096 90.5315 56.1307C90.4445 56.1653 90.3401 56.1307 90.3053 56.0441L89.8531 55.1431L89.54 56.4252C89.5227 56.5118 89.4183 56.5811 89.3313 56.5465C89.2444 56.5292 89.1748 56.4252 89.2096 56.3386L89.6096 54.658L89.4357 54.2942L89.1226 55.5763C89.1052 55.6629 89.0009 55.7322 88.9139 55.6975C88.8269 55.6802 88.7574 55.5763 88.7921 55.4896L89.1922 53.8091L89.0009 53.4453L88.6878 54.7273C88.6704 54.814 88.566 54.8833 88.4791 54.8486C88.3921 54.8313 88.3225 54.7273 88.3573 54.6407L88.7574 52.9601L88.3573 52.1459L87.3659 52.0766L86.8615 52.8389L87.0354 54.5714C87.0354 54.658 86.9833 54.7447 86.8789 54.762C86.7919 54.762 86.705 54.71 86.6876 54.6061L86.5484 53.2893L86.3223 53.6358L86.4963 55.3684C86.4963 55.455 86.4441 55.5416 86.3397 55.5589C86.2528 55.5589 86.1658 55.507 86.1484 55.403L86.0093 54.0863L85.7831 54.4328L85.9571 56.1653C85.9571 56.252 85.9049 56.3386 85.8005 56.3559C85.7136 56.3559 85.6266 56.3039 85.6092 56.2L85.4701 54.8833L84.9135 55.7149C84.9135 55.7149 84.7569 55.8188 84.67 55.7668C84.6004 55.7149 84.5656 55.6109 84.6178 55.5243L85.1744 54.6927L83.9047 55.0738C83.8177 55.1085 83.7134 55.0565 83.696 54.9526C83.6612 54.8659 83.7134 54.762 83.8177 54.7447L85.4875 54.2595L85.7136 53.913L84.4439 54.2942C84.3569 54.3288 84.2526 54.2769 84.2352 54.1729C84.2004 54.0863 84.2525 53.9823 84.3569 53.965L86.0266 53.4799L86.2528 53.1334L84.9831 53.5146C84.8961 53.5492 84.7917 53.4972 84.7743 53.3933C84.7396 53.3067 84.7917 53.2027 84.8961 53.1854L86.5658 52.6829L87.0702 51.938L86.6354 51.037L85.7484 50.9851L84.3395 51.9899C84.3395 51.9899 84.1482 52.0246 84.096 51.9553C84.0438 51.886 84.0612 51.7647 84.1308 51.7127L85.2092 50.9504L84.7917 50.9158L83.3829 51.9206C83.3829 51.9206 83.1916 51.9553 83.1394 51.886C83.0872 51.8167 83.1046 51.6954 83.1742 51.6434L84.2526 50.8638L83.8351 50.8291L82.4263 51.834C82.4263 51.834 82.235 51.8687 82.1828 51.7994C82.1306 51.73 82.148 51.6088 82.2176 51.5568L83.2959 50.7945L82.2871 50.7252C82.2002 50.7252 82.1132 50.6386 82.1306 50.5346C82.1306 50.448 82.2176 50.3613 82.3219 50.3787L83.3307 50.448L82.3741 49.5471C82.3741 49.5471 82.3045 49.3738 82.3741 49.3045C82.4437 49.2352 82.548 49.2352 82.6176 49.3045L83.8873 50.5L84.3047 50.5346L83.3481 49.6337C83.3481 49.6337 83.2785 49.4604 83.3481 49.3911C83.4177 49.3218 83.522 49.3218 83.5916 49.3911L84.8613 50.5866L85.2787 50.6212L84.3221 49.7203C84.3221 49.7203 84.2525 49.5471 84.3221 49.4778C84.3917 49.4085 84.4961 49.4085 84.5656 49.4778L85.8353 50.6732L86.7224 50.7425L87.2789 49.9109L86.8789 49.1139L85.2961 48.4036C85.2961 48.4036 85.1744 48.265 85.2092 48.1784C85.244 48.0917 85.3483 48.0571 85.4353 48.0917L86.6354 48.6288L86.4615 48.265L84.8787 47.5547C84.8787 47.5547 84.7569 47.416 84.7917 47.3294C84.8265 47.2428 84.9309 47.2081 85.0178 47.2428L86.218 47.7799L86.044 47.416L84.4613 46.7057C84.4613 46.7057 84.3395 46.5671 84.3743 46.4805C84.4091 46.3939 84.5134 46.3592 84.6004 46.3939L85.8005 46.9309L85.3483 46.03C85.3483 46.03 85.3483 45.8394 85.4353 45.8048C85.5222 45.7701 85.6266 45.8048 85.6614 45.8741L86.1136 46.775L86.4267 45.4929C86.4441 45.4063 86.5484 45.337 86.6354 45.3717C86.7224 45.389 86.7919 45.4929 86.7572 45.5796L86.3571 47.2601L86.531 47.624L86.8441 46.3419C86.8615 46.2553 86.9659 46.186 87.0528 46.2206C87.1398 46.2553 87.2094 46.3419 87.1746 46.4285L86.7745 48.1091L86.9485 48.4729L87.2616 47.1908C87.2789 47.1042 87.3833 47.0349 87.4703 47.0695C87.5572 47.0869 87.6268 47.1908 87.592 47.2774L87.192 48.958L87.592 49.7723L88.5834 49.8416L89.0878 49.0793L88.9139 47.3467C88.9139 47.2601 88.9661 47.1735 89.0704 47.1562C89.1574 47.1562 89.2444 47.2081 89.2618 47.3121L89.4009 48.6288L89.627 48.2823L89.4531 46.5671C89.4531 46.4805 89.5053 46.3939 89.6096 46.3765C89.6966 46.3765 89.7836 46.4285 89.8009 46.5325L89.9401 47.8492L90.1662 47.5027L89.9923 45.7701C89.9923 45.6835 90.0444 45.5969 90.1488 45.5796C90.2358 45.5796 90.3227 45.6315 90.3401 45.7355L90.2706 45.6835ZM87.5051 50.0495L86.9485 50.8638L87.3833 51.7474L88.3747 51.8167L88.9313 51.0024L88.4965 50.1188L87.5051 50.0495Z",
    fill: "url(#paint205_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M74.5295 12.9559C74.5295 12.9559 74.5817 12.8693 74.5817 12.8173C74.5817 12.7133 74.5469 12.6094 74.4425 12.5574C74.3034 12.4708 74.1294 12.5054 74.0251 12.644C73.9903 12.696 73.9729 12.7307 73.9729 12.7826C73.9729 12.8866 74.0077 12.9905 74.0946 13.0425C74.112 13.0425 74.1468 13.0772 74.1642 13.0772L74.2512 14.0127L73.5729 15.0176L73.0337 13.9261L73.2598 13.0079C73.2598 13.0079 73.312 13.0079 73.3293 12.9905C73.4163 12.9386 73.4859 12.8519 73.4859 12.748C73.4859 12.696 73.4859 12.644 73.4511 12.5921C73.3815 12.4535 73.2076 12.3842 73.0511 12.4535C72.9641 12.5054 72.8945 12.5921 72.8945 12.696C72.8945 12.748 72.8945 12.8 72.9293 12.8519C72.9293 12.8519 72.9467 12.8866 72.9641 12.9039L72.8249 13.5103L72.5293 12.9039C72.5293 12.9039 72.5988 12.7133 72.5293 12.6094C72.4945 12.5401 72.4423 12.4881 72.3553 12.4535C72.2858 12.4361 72.1988 12.4361 72.1292 12.4535C72.0423 12.5054 71.9727 12.5921 71.9727 12.696C71.9727 12.748 71.9727 12.8 72.0075 12.8519C72.0597 12.9386 72.1466 13.0079 72.251 13.0079L72.5467 13.6143L71.9727 13.3544C71.9727 13.3544 71.9727 13.3197 71.9553 13.3024C71.8857 13.1638 71.7118 13.0945 71.5553 13.1638C71.4683 13.2158 71.3987 13.3024 71.3987 13.4063C71.3987 13.4583 71.3987 13.5103 71.4335 13.5623C71.5031 13.7182 71.677 13.7702 71.8335 13.7009C71.8509 13.7009 71.8857 13.6662 71.9031 13.6489L72.7728 14.0301L73.312 15.1216L72.0944 15.0349L71.3987 14.3766C71.3987 14.3766 71.3987 14.3246 71.3987 14.2899C71.3987 14.134 71.2944 13.9954 71.1204 13.9781C70.9639 13.9781 70.8247 14.0994 70.8074 14.2553C70.8074 14.4112 70.9117 14.5498 71.0856 14.5671C71.0856 14.5671 71.1204 14.5671 71.1378 14.5671L71.59 15.0003L70.9117 14.9483C70.8595 14.8617 70.7726 14.7924 70.6682 14.7924C70.5117 14.7924 70.3725 14.8963 70.3551 15.0696C70.3551 15.2255 70.4595 15.3641 70.6334 15.3814C70.7378 15.3814 70.8421 15.3468 70.8943 15.2602L71.5727 15.3121L71.0682 15.676C71.0682 15.676 71.0335 15.676 71.0161 15.676C70.8595 15.676 70.7204 15.7799 70.703 15.9532C70.703 16.1091 70.8074 16.2477 70.9813 16.265C71.1378 16.265 71.277 16.1611 71.2944 15.9878C71.2944 15.9532 71.2944 15.9358 71.2944 15.9012L72.0597 15.3468L73.2772 15.4334L72.5988 16.4383L71.6944 16.7155C71.6944 16.7155 71.6596 16.6808 71.6248 16.6635C71.4857 16.5769 71.3118 16.6115 71.2074 16.7501C71.1726 16.7848 71.1552 16.8368 71.1552 16.8887C71.1552 16.9927 71.19 17.0966 71.277 17.1486C71.3465 17.2006 71.4161 17.2179 71.5031 17.2006C71.5726 17.2006 71.6422 17.1486 71.6944 17.0793C71.6944 17.0793 71.7118 17.0447 71.7292 17.0273L72.3206 16.8541L71.9379 17.4085C71.8335 17.4085 71.7292 17.4605 71.677 17.5471C71.6422 17.5817 71.6248 17.6337 71.6248 17.6857C71.6248 17.7897 71.677 17.8936 71.764 17.9456C71.9031 18.0322 72.077 17.9976 72.1814 17.859C72.2336 17.7723 72.251 17.6684 72.1988 17.5644L72.5814 17.01L72.651 17.6337C72.651 17.6337 72.6336 17.6684 72.6162 17.6857C72.5814 17.7204 72.5641 17.7723 72.5641 17.8243C72.5641 17.9283 72.5988 18.0322 72.7032 18.0842C72.8423 18.1708 73.0163 18.1362 73.1206 17.9976C73.1554 17.9456 73.1728 17.9109 73.1728 17.859C73.1728 17.755 73.138 17.6511 73.0337 17.5991C73.0163 17.5991 72.9815 17.5644 72.9641 17.5644L72.8771 16.6289L73.5555 15.624L74.0946 16.7155L73.8685 17.6337C73.8685 17.6337 73.8164 17.6337 73.7816 17.6511C73.6946 17.703 73.625 17.7897 73.625 17.8936C73.625 17.9456 73.625 17.9976 73.6598 18.0495C73.6946 18.1188 73.7468 18.1708 73.8337 18.2055C73.9033 18.2228 73.9903 18.2228 74.0599 18.2055C74.1468 18.1535 74.2164 18.0669 74.2164 17.9629C74.2164 17.9109 74.2164 17.859 74.1816 17.807C74.1816 17.807 74.1642 17.7723 74.1468 17.755L74.286 17.1486L74.5817 17.755C74.5817 17.755 74.5121 17.9456 74.5817 18.0495C74.6512 18.1881 74.8252 18.2574 74.9817 18.1881C75.0687 18.1362 75.1382 18.0495 75.1382 17.9456C75.1382 17.8936 75.1382 17.8416 75.1034 17.7897C75.0513 17.703 74.9643 17.6337 74.8599 17.6337L74.5643 17.0273L75.1382 17.2872C75.1382 17.2872 75.1382 17.3219 75.1556 17.3392C75.2252 17.4778 75.3991 17.5471 75.5557 17.4778C75.6426 17.4258 75.7122 17.3392 75.7122 17.2352C75.7122 17.1833 75.7122 17.1313 75.6774 17.0793C75.6426 17.01 75.5904 16.958 75.5035 16.9234C75.4339 16.8887 75.347 16.9061 75.2774 16.9234C75.26 16.9234 75.2252 16.958 75.2078 16.9754L74.3382 16.5942L73.799 15.5027L75.0165 15.5893L75.7122 16.2477C75.7122 16.2477 75.7122 16.2997 75.7122 16.3343C75.7122 16.4903 75.834 16.6289 75.9905 16.6462C76.147 16.6462 76.2862 16.5422 76.3036 16.369C76.3036 16.2131 76.1992 16.0744 76.0253 16.0571C76.0079 16.0571 75.9905 16.0571 75.9731 16.0571L75.5209 15.624L76.1992 15.676C76.2514 15.7626 76.3384 15.8319 76.4427 15.8319C76.5992 15.8319 76.7384 15.7106 76.7558 15.5547C76.7558 15.3988 76.6514 15.2602 76.4775 15.2428C76.3731 15.2428 76.2688 15.2775 76.2166 15.3641L75.5383 15.3121L76.0427 14.9483C76.0427 14.9483 76.0775 14.9483 76.0948 14.9483C76.2514 14.9483 76.4079 14.8444 76.4079 14.6711C76.4079 14.5152 76.2862 14.3766 76.1296 14.3592C75.9731 14.3592 75.834 14.4632 75.8166 14.6364C75.8166 14.6711 75.8166 14.6884 75.8166 14.7231L75.0513 15.2775L73.8337 15.1909L74.5121 14.186L75.4165 13.9088C75.4165 13.9088 75.4513 13.9434 75.4861 13.9608C75.6252 14.0474 75.7992 14.0127 75.8861 13.8741C75.9209 13.8222 75.9383 13.7875 75.9383 13.7355C75.9383 13.6316 75.9035 13.5276 75.8166 13.4757C75.6774 13.389 75.5035 13.4237 75.3991 13.5623C75.3991 13.5623 75.3817 13.5969 75.3643 13.6143L74.773 13.7875L75.1556 13.2331C75.26 13.2331 75.3643 13.1811 75.4165 13.0945C75.4513 13.0598 75.4687 13.0079 75.4687 12.9559C75.4687 12.8519 75.4165 12.748 75.3296 12.696C75.1904 12.6094 75.0165 12.644 74.9121 12.7826C74.8599 12.8693 74.8425 12.9732 74.8947 13.0772L74.5121 13.6316L74.4425 13.0079C74.4425 13.0079 74.4773 12.9732 74.4773 12.9559H74.5295Z",
    fill: "url(#paint206_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M41.0481 5.28094L41.1351 6.23384L41.7091 5.38489C41.6395 5.26362 41.6569 5.12502 41.7265 5.00374C41.8482 4.83048 42.0743 4.77851 42.2482 4.89979C42.4222 5.02106 42.4744 5.24629 42.3526 5.41955C42.2656 5.54082 42.1439 5.5928 42.0047 5.57547L41.4308 6.42441L42.3526 6.14721C42.3526 6.14721 42.37 6.09523 42.3874 6.07791C42.5091 5.90465 42.7352 5.85268 42.9092 5.97396C43.0831 6.09523 43.1353 6.32046 43.0135 6.49371C42.8918 6.66697 42.6657 6.71894 42.4917 6.59767C42.457 6.58034 42.4222 6.54569 42.4048 6.51104L41.1177 6.8922L40.7698 7.41196L41.2568 8.3995L41.883 8.43415L42.9788 7.65451C42.9788 7.65451 42.9788 7.56788 42.9788 7.53323C42.9788 7.32533 43.1701 7.1694 43.3788 7.18673C43.5875 7.18673 43.7441 7.37731 43.7267 7.58521C43.7267 7.79311 43.5353 7.94904 43.3266 7.93172C43.2918 7.93172 43.2744 7.93172 43.2397 7.93172L42.457 8.48613L43.4832 8.55543C43.5527 8.43415 43.6919 8.36485 43.831 8.38217C44.0397 8.38217 44.1963 8.57275 44.1789 8.78066C44.1789 8.98856 43.9876 9.14449 43.7788 9.12716C43.6397 9.12716 43.5179 9.02321 43.4658 8.90193L42.4396 8.83263L43.1353 9.49099C43.1353 9.49099 43.1875 9.49099 43.2223 9.49099C43.431 9.49099 43.5875 9.68157 43.5701 9.88948C43.5701 10.0974 43.3788 10.2533 43.1701 10.236C42.9614 10.236 42.8048 10.0454 42.8222 9.8375C42.8222 9.80285 42.8222 9.75087 42.857 9.71622L41.883 8.79798L41.2394 8.76333L40.6307 9.68157L40.909 10.2533L42.1265 10.8077C42.1265 10.8077 42.1961 10.7557 42.2309 10.7384C42.4222 10.6518 42.6483 10.7384 42.7353 10.9117C42.8222 11.1022 42.7353 11.3275 42.5613 11.4141C42.37 11.5007 42.1439 11.4141 42.0569 11.2409C42.0569 11.2062 42.0395 11.1889 42.0221 11.1542L41.1525 10.7557L41.6047 11.674C41.7438 11.674 41.8656 11.7606 41.9178 11.8819C42.0047 12.0725 41.9178 12.2977 41.7438 12.3843C41.5525 12.4709 41.3264 12.3843 41.2394 12.2111C41.1699 12.0898 41.1873 11.9339 41.2742 11.8299L40.822 10.9117L40.5959 11.8299C40.5959 11.8299 40.6307 11.8819 40.6481 11.8992C40.735 12.0898 40.6481 12.315 40.4741 12.4016C40.2828 12.4883 40.0567 12.4016 39.9698 12.2284C39.8828 12.0378 39.9697 11.8126 40.1437 11.726C40.1785 11.7086 40.2133 11.6913 40.2654 11.6913L40.5785 10.3919L40.3002 9.82017L39.2045 9.75087L38.8566 10.2706L38.9957 11.6047C38.9957 11.6047 39.0827 11.6393 39.1001 11.6567C39.274 11.7779 39.3262 12.0032 39.2045 12.1764C39.0827 12.3497 38.8566 12.4016 38.6827 12.2804C38.5087 12.1591 38.4566 11.9339 38.5783 11.7606C38.5783 11.7433 38.6131 11.7086 38.6305 11.6913L38.5435 10.7557L37.9695 11.6047C38.0391 11.726 38.0217 11.8646 37.9522 11.9858C37.8304 12.1591 37.6043 12.2111 37.4304 12.0898C37.2564 11.9685 37.2043 11.7433 37.326 11.57C37.413 11.4488 37.5347 11.3968 37.6739 11.3968L38.2478 10.5478L37.326 10.825C37.326 10.825 37.3086 10.877 37.2912 10.8943C37.1695 11.0676 36.9434 11.1196 36.7694 10.9983C36.5955 10.877 36.5433 10.6518 36.6651 10.4785C36.7868 10.3053 37.0129 10.2533 37.1869 10.3746C37.2216 10.3919 37.2564 10.4266 37.2738 10.4612L38.5609 10.0801L38.9088 9.5603L38.4218 8.57275L37.7782 8.5381L36.6825 9.31774C36.6825 9.31774 36.6825 9.40437 36.6825 9.43902C36.6825 9.64692 36.4911 9.80285 36.2824 9.78552C36.0737 9.78552 35.9172 9.59495 35.9346 9.38704C35.9346 9.17914 36.1259 9.02321 36.3346 9.04054C36.3694 9.04054 36.3868 9.04054 36.4216 9.04054L37.1869 8.48613L36.1607 8.41682C36.0911 8.52078 35.9519 8.6074 35.8128 8.59008C35.6041 8.59008 35.4476 8.3995 35.4649 8.1916C35.4649 7.98369 35.6563 7.82776 35.865 7.84509C36.0041 7.84509 36.1259 7.94904 36.1781 8.07032L37.2043 8.13962L36.5085 7.48126C36.5085 7.48126 36.4563 7.48126 36.4216 7.48126C36.2128 7.48126 36.0563 7.29068 36.0737 7.08278C36.0737 6.87487 36.265 6.71894 36.4737 6.73627C36.6825 6.73627 36.839 6.92685 36.8216 7.13475C36.8216 7.1694 36.8216 7.22138 36.7868 7.25603L37.7608 8.17427L38.387 8.20892L38.9957 7.29068L38.7174 6.71894L37.4999 6.16453C37.4999 6.16453 37.4304 6.21651 37.3956 6.23384C37.2042 6.32046 36.9781 6.23383 36.8912 6.06058C36.8042 5.87 36.8912 5.64477 37.0651 5.55815C37.2564 5.47152 37.4825 5.55815 37.5695 5.7314C37.5695 5.74873 37.5869 5.78338 37.6043 5.81803L38.4739 6.21651L38.0217 5.29827C37.8826 5.29827 37.7608 5.21164 37.6913 5.09036C37.6043 4.89979 37.6913 4.67456 37.8652 4.58793C38.0565 4.5013 38.2826 4.58793 38.3696 4.76118C38.4392 4.88246 38.4218 5.03839 38.3348 5.14234L38.787 6.06058L39.0131 5.14234C39.0131 5.14234 38.9783 5.09036 38.961 5.07304C38.874 4.88246 38.961 4.65723 39.1349 4.57061C39.3262 4.48398 39.5523 4.57061 39.6393 4.74386C39.7262 4.93444 39.6393 5.15967 39.4654 5.24629C39.4306 5.26362 39.3958 5.28094 39.3436 5.28094L39.0305 6.58034L39.3088 7.15208L40.4046 7.22138L40.7524 6.70162L40.6133 5.36757C40.6133 5.36757 40.5437 5.33292 40.5089 5.31559C40.335 5.19432 40.2828 4.96909 40.4046 4.79583C40.5263 4.62258 40.7524 4.57061 40.9264 4.69188C41.1003 4.81316 41.1525 5.03839 41.0307 5.21164C41.0307 5.22897 40.9959 5.26362 40.9786 5.28094H41.0481ZM39.5697 7.51591L39.8654 8.12229L40.248 7.55056L39.5697 7.49858V7.51591ZM39.5349 8.29555L39.2392 7.68916L38.8566 8.2609L39.5349 8.31287V8.29555ZM40.1437 8.69403L40.4394 9.30042L40.822 8.72868L40.1437 8.6767V8.69403ZM39.5175 8.65938L38.8392 8.6074L39.1349 9.21379L39.5175 8.64205V8.65938ZM40.8568 8.38217L40.5611 7.77579L40.1785 8.34752L40.8568 8.3995V8.38217ZM40.1263 9.47367L39.8306 8.86728L39.448 9.43902L40.1263 9.49099V9.47367Z",
    fill: "url(#paint207_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M13.4277 32.5854C14.2104 32.6374 14.7844 33.3131 14.7148 34.0927C14.6626 34.8723 13.9843 35.4441 13.2016 35.3748C12.4189 35.3228 11.845 34.6471 11.9145 33.8675C11.9667 33.0878 12.645 32.5161 13.4277 32.5854Z",
    fill: "url(#paint208_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M20.3154 29.7268L19.7415 30.5584L19.324 29.6402C19.2719 29.5362 19.1675 29.5016 19.0631 29.5362C18.9588 29.5882 18.924 29.6922 18.9762 29.7961L19.411 30.7317L18.3848 30.6451C18.2804 30.6451 18.1935 30.7144 18.1761 30.8183C18.1761 30.9223 18.2457 31.0089 18.35 31.0262L19.3762 31.1129L18.8022 31.9618C18.8022 31.9618 18.7675 32.1697 18.8544 32.2217C18.9414 32.2736 19.0631 32.2563 19.1153 32.1697L19.6893 31.3381L20.1067 32.2563C20.1589 32.3603 20.2633 32.3949 20.3676 32.3603C20.4372 32.3256 20.472 32.2736 20.472 32.2043C20.472 32.1697 20.472 32.135 20.472 32.1177L20.0371 31.1822L21.0633 31.2688C21.1677 31.2688 21.2547 31.1995 21.2721 31.0955C21.2721 30.9916 21.2025 30.9049 21.0981 30.8876L20.0719 30.8183L20.6633 29.9694C20.6633 29.9694 20.6981 29.9001 20.6981 29.8828C20.6981 29.8135 20.6807 29.7442 20.6111 29.7095C20.5242 29.6402 20.4024 29.6749 20.3502 29.7615L20.3154 29.7268Z",
    fill: "url(#paint209_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M27.2726 24.8757C27.2726 24.8757 27.3247 24.7718 27.3247 24.7198C27.3247 24.6158 27.2899 24.4946 27.1856 24.4426C27.0464 24.3386 26.8551 24.3733 26.7508 24.5292C26.716 24.5812 26.6986 24.6332 26.6986 24.6851C26.6986 24.7891 26.7334 24.9104 26.8377 24.9623C26.8551 24.9623 26.8899 24.997 26.9073 24.997L26.9943 26.0019L26.2638 27.0587L25.7072 25.8979L25.9507 24.9277C25.9507 24.9277 26.0029 24.9277 26.0376 24.9104C26.142 24.8584 26.2116 24.7718 26.2116 24.6505C26.2116 24.5985 26.2116 24.5465 26.1768 24.4946C26.1072 24.3386 25.9159 24.2693 25.7594 24.3386C25.655 24.3906 25.5854 24.4946 25.5854 24.5985C25.5854 24.6505 25.5854 24.7025 25.6202 24.7544C25.6202 24.7718 25.6376 24.7891 25.655 24.8064L25.4985 25.4475L25.1854 24.8064C25.2376 24.7198 25.255 24.5985 25.2028 24.4946C25.168 24.4253 25.0984 24.356 25.0288 24.3386C24.9593 24.304 24.8723 24.3213 24.7853 24.3386C24.681 24.3906 24.6114 24.4946 24.6114 24.5985C24.6114 24.6505 24.6114 24.7025 24.6462 24.7544C24.6984 24.8584 24.7853 24.9277 24.8897 24.9277L25.2028 25.5687L24.6114 25.2915C24.6114 25.2915 24.6114 25.2569 24.594 25.2395C24.5244 25.0836 24.3331 25.0143 24.1766 25.0836C24.0722 25.1356 24.0027 25.2395 24.0027 25.3435C24.0027 25.3955 24.0027 25.4475 24.0374 25.4994C24.107 25.6554 24.2983 25.7247 24.4549 25.638C24.4723 25.638 24.5071 25.6034 24.5244 25.5861L25.4463 26.0019L26.0029 27.1627L24.7158 27.0587L23.9853 26.3657C23.9853 26.3657 23.9853 26.3137 24.0027 26.2791C24.0027 26.1058 23.8809 25.9499 23.707 25.9499C23.533 25.9499 23.3765 26.0712 23.3765 26.2271C23.3765 26.4003 23.4983 26.5563 23.6722 26.5563C23.6896 26.5563 23.707 26.5563 23.7418 26.5563L24.2114 27.0067L23.4983 26.9548C23.4461 26.8508 23.3591 26.7988 23.2374 26.7815C23.0634 26.7815 22.9069 26.9028 22.9069 27.076C22.9069 27.2493 23.0286 27.4052 23.2026 27.4052C23.3069 27.4052 23.4113 27.3706 23.4809 27.2666L24.194 27.3186L23.6548 27.6997C23.6548 27.6997 23.62 27.6997 23.6026 27.6997C23.4287 27.6997 23.2721 27.821 23.2721 27.9769C23.2721 28.1502 23.3939 28.3061 23.5504 28.3061C23.7244 28.3061 23.8809 28.1848 23.8809 28.0116C23.8809 27.9769 23.8809 27.9596 23.8809 27.925L24.6984 27.3532L25.9855 27.4572L25.255 28.514L24.2809 28.7912C24.2809 28.7912 24.2462 28.7566 24.2114 28.7393C24.0722 28.6353 23.8809 28.67 23.7765 28.8259C23.7418 28.8779 23.7244 28.9298 23.7244 28.9818C23.7244 29.0858 23.7765 29.207 23.8635 29.259C23.9331 29.311 24.02 29.3283 24.0896 29.311C24.1592 29.2937 24.2462 29.2417 24.2983 29.1724C24.2983 29.1724 24.3157 29.1377 24.3331 29.1204L24.9593 28.9472L24.5592 29.5362C24.4549 29.5362 24.3505 29.5882 24.2809 29.6748C24.2462 29.7268 24.2288 29.7788 24.2288 29.8308C24.2288 29.9347 24.2636 30.056 24.3679 30.108C24.5071 30.2119 24.6984 30.1773 24.8027 30.0213C24.8723 29.9347 24.8723 29.8134 24.8375 29.7095L25.2376 29.1204L25.2897 29.7788C25.2897 29.7788 25.255 29.8134 25.255 29.8308C25.2202 29.8827 25.2028 29.9347 25.2028 29.9867C25.2028 30.0906 25.255 30.2119 25.3419 30.2639C25.4811 30.3678 25.6724 30.3332 25.7767 30.1773C25.8115 30.1253 25.8289 30.0733 25.8289 30.0213C25.8289 29.9174 25.7767 29.7961 25.6898 29.7441C25.6724 29.7441 25.6376 29.7095 25.6202 29.7095L25.5332 28.7046L26.2638 27.6478L26.8203 28.8086L26.5768 29.7788C26.5768 29.7788 26.5247 29.7788 26.4899 29.7961C26.3855 29.8481 26.3159 29.952 26.3159 30.056C26.3159 30.108 26.3159 30.1599 26.3507 30.2119C26.3855 30.2812 26.4551 30.3505 26.5247 30.3678C26.6116 30.4025 26.6812 30.3852 26.7682 30.3678C26.8725 30.3159 26.9421 30.2119 26.9421 30.108C26.9421 30.056 26.9421 30.004 26.9073 29.952C26.9073 29.9347 26.8899 29.9174 26.8725 29.9001L27.0291 29.259L27.3421 29.9001C27.2899 29.9867 27.2726 30.108 27.3247 30.2119C27.3943 30.3678 27.5856 30.4371 27.7422 30.3678C27.8465 30.3159 27.9161 30.2119 27.9161 30.108C27.9161 30.056 27.9161 30.004 27.8813 29.952C27.8291 29.8481 27.7422 29.7788 27.6378 29.7788L27.3247 29.1377L27.9161 29.4149C27.9161 29.4149 27.9161 29.4496 27.9335 29.4669C28.0031 29.6229 28.1944 29.6922 28.3509 29.6229C28.4553 29.5709 28.5249 29.4669 28.5249 29.363C28.5249 29.311 28.5249 29.259 28.4901 29.207C28.4553 29.1377 28.3857 29.0684 28.3161 29.0511C28.2292 29.0165 28.1596 29.0338 28.0726 29.0511C28.0552 29.0511 28.0205 29.0858 28.0031 29.1031L27.0812 28.6873L26.5247 27.5265L27.8117 27.6304L28.5422 28.3235C28.5422 28.3235 28.5422 28.3754 28.5249 28.4101C28.5249 28.5833 28.6466 28.7393 28.8205 28.7393C28.9945 28.7393 29.151 28.618 29.151 28.4447C29.151 28.2715 29.0293 28.1155 28.8553 28.1155C28.8379 28.1155 28.8205 28.1155 28.7858 28.1155L28.3161 27.6651L29.0293 27.7171C29.0814 27.821 29.1684 27.873 29.2902 27.8903C29.4641 27.8903 29.6206 27.769 29.6206 27.5958C29.6206 27.4225 29.4989 27.2666 29.3249 27.2666C29.2206 27.2666 29.1162 27.3013 29.0466 27.4052L28.3335 27.3532L28.8727 26.9721C28.8727 26.9721 28.9075 26.9721 28.9249 26.9721C29.0988 26.9721 29.2554 26.8508 29.2554 26.6775C29.2554 26.5043 29.1336 26.3484 28.9597 26.3484C28.7858 26.3484 28.6292 26.4696 28.6292 26.6429C28.6292 26.6775 28.6292 26.6949 28.6292 26.7295L27.8117 27.3013L26.5247 27.1973L27.2552 26.1405L28.2292 25.8633C28.2292 25.8633 28.264 25.8979 28.2987 25.9152C28.4379 26.0192 28.6292 25.9845 28.7336 25.8286C28.7684 25.7766 28.7858 25.7247 28.7858 25.6727C28.7858 25.5687 28.7336 25.4475 28.6466 25.3955C28.5075 25.2915 28.3161 25.3435 28.2118 25.4821C28.2118 25.4821 28.1944 25.5168 28.177 25.5341L27.5508 25.7073L27.9509 25.1183C28.0552 25.1183 28.1596 25.0663 28.2292 24.9797C28.264 24.9277 28.2814 24.8757 28.2814 24.8237C28.2814 24.7198 28.2466 24.5985 28.1422 24.5465C28.0031 24.4426 27.8117 24.4772 27.7074 24.6332C27.6378 24.7198 27.6378 24.8411 27.69 24.945L27.2899 25.5341L27.2378 24.8757C27.2378 24.8757 27.2726 24.8411 27.2726 24.8237V24.8757Z",
    fill: "url(#paint210_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M16.7848 35.1323L16.8718 36.1371L17.4979 35.2362C17.4284 35.1149 17.4458 34.959 17.5327 34.8377C17.6545 34.6645 17.898 34.6125 18.0893 34.7338C18.2806 34.8551 18.3154 35.1149 18.1937 35.2882C18.1067 35.4095 17.9676 35.4788 17.8284 35.4614L17.2023 36.3624L18.1763 36.0852C18.1763 36.0852 18.1937 36.0332 18.2111 35.9985C18.3328 35.8253 18.5763 35.7733 18.7676 35.8946C18.9416 36.0159 18.9938 36.2757 18.872 36.449C18.7503 36.6222 18.5067 36.6742 18.3154 36.5529C18.2806 36.5356 18.2459 36.501 18.2285 36.4663L16.8718 36.8475L16.4892 37.4019L16.9936 38.4414L17.6719 38.4934L18.8372 37.6791C18.8372 37.6791 18.8372 37.5925 18.8372 37.5578C18.8372 37.3326 19.0459 37.1767 19.272 37.194C19.4982 37.194 19.6547 37.4019 19.6373 37.6271C19.6373 37.8523 19.4286 38.0083 19.2025 37.9909C19.1677 37.9909 19.1329 37.9909 19.1155 37.9736L18.298 38.5627L19.3938 38.6493C19.4634 38.528 19.6025 38.4587 19.759 38.4761C19.9852 38.4761 20.1417 38.684 20.1243 38.9092C20.1243 39.1344 19.9156 39.2903 19.6895 39.273C19.5329 39.273 19.4112 39.1691 19.359 39.0478L18.2632 38.9612L18.9938 39.6542C18.9938 39.6542 19.0459 39.6542 19.0807 39.6542C19.3068 39.6542 19.4634 39.8621 19.446 40.0873C19.446 40.3125 19.2373 40.4685 19.0111 40.4511C18.785 40.4511 18.6285 40.2432 18.6459 40.018C18.6459 39.966 18.6459 39.9314 18.6807 39.8967L17.6545 38.9092L16.9762 38.8572L16.3152 39.8101L16.6109 40.4165L17.898 41.0055C17.898 41.0055 17.9676 40.9536 18.0023 40.9362C18.2111 40.8323 18.4372 40.9362 18.5415 41.1268C18.6285 41.3347 18.5415 41.56 18.3502 41.6639C18.1415 41.7505 17.9154 41.6639 17.811 41.4733C17.811 41.4387 17.7936 41.4214 17.7762 41.3867L16.8544 40.9709L17.324 41.9584C17.4632 41.9584 17.6023 42.0451 17.6719 42.1837C17.7762 42.3916 17.6719 42.6168 17.4806 42.7208C17.2892 42.8074 17.0457 42.7208 16.9414 42.5302C16.8718 42.3916 16.8892 42.2356 16.9762 42.1317L16.5065 41.1441L16.263 42.1144C16.263 42.1144 16.2978 42.1663 16.3152 42.1837C16.4022 42.3916 16.3152 42.6168 16.1239 42.7208C15.9326 42.8247 15.6891 42.7208 15.5847 42.5302C15.4804 42.3223 15.5847 42.097 15.776 41.9931C15.8108 41.9758 15.863 41.9584 15.8978 41.9584L16.2456 40.5897L15.95 39.9834L14.7846 39.8967L14.402 40.4511L14.5237 41.8545C14.5237 41.8545 14.6107 41.8891 14.6455 41.9065C14.8368 42.0277 14.8716 42.2876 14.7498 42.4609C14.6281 42.6515 14.3846 42.6861 14.1933 42.5648C14.0019 42.4435 13.9672 42.201 14.0889 42.0104C14.1063 41.9931 14.1237 41.9584 14.1585 41.9411L14.0715 40.9362L13.4454 41.8372C13.5149 41.9584 13.4975 42.1144 13.4106 42.2356C13.2888 42.4262 13.0453 42.4609 12.854 42.3396C12.6801 42.2183 12.6279 41.9758 12.7496 41.7852C12.8366 41.6639 12.9757 41.5946 13.1149 41.6119L13.741 40.711L12.767 40.9882C12.767 40.9882 12.7322 41.0402 12.7322 41.0749C12.6105 41.2654 12.3496 41.3001 12.1757 41.1788C12.0017 41.0575 11.9496 40.815 12.0713 40.6244C12.1931 40.4338 12.4366 40.3992 12.6279 40.5204C12.6627 40.5378 12.6975 40.5724 12.7149 40.6071L14.0715 40.2086L14.4542 39.6542L13.9498 38.6147L13.2714 38.5627L12.1061 39.377C12.1061 39.377 12.1061 39.4636 12.1061 39.5156C12.1061 39.7408 11.8974 39.8967 11.6713 39.8794C11.4452 39.8621 11.2886 39.6715 11.306 39.4463C11.306 39.221 11.5147 39.0651 11.7408 39.0824C11.7756 39.0824 11.8104 39.0824 11.8278 39.0998L12.6453 38.5107L11.5495 38.4241C11.4799 38.5454 11.3408 38.6147 11.1843 38.5973C10.9582 38.5973 10.8016 38.3894 10.819 38.1642C10.819 37.939 11.0277 37.783 11.2538 37.8004C11.4104 37.8004 11.5321 37.9043 11.5843 38.0256L12.6801 38.1122L11.9496 37.4192C11.9496 37.4192 11.88 37.4192 11.8626 37.4192C11.6365 37.4192 11.4799 37.2113 11.4973 36.9861C11.4973 36.7608 11.7061 36.6049 11.9322 36.6222C12.1583 36.6222 12.3148 36.8301 12.2974 37.0554C12.2974 37.1074 12.2974 37.142 12.2626 37.1767L13.2888 38.1642L13.9672 38.2162L14.6281 37.2633L14.3324 36.6569L13.0453 36.0678C13.0453 36.0678 12.9757 36.1198 12.941 36.1371C12.7496 36.2411 12.5061 36.1371 12.4018 35.9466C12.3148 35.7387 12.4018 35.5134 12.5931 35.4095C12.8018 35.3228 13.0279 35.4095 13.1323 35.6001C13.1323 35.6347 13.1497 35.652 13.1671 35.6867L14.0889 36.1025L13.6193 35.1149C13.4801 35.1149 13.341 35.0283 13.2714 34.8897C13.1845 34.6818 13.2714 34.4566 13.4628 34.3526C13.6715 34.266 13.8976 34.3526 14.0019 34.5432C14.0715 34.6818 14.0541 34.8377 13.9672 34.9417L14.4368 35.9292L14.6803 34.959C14.6803 34.959 14.6455 34.907 14.6281 34.8897C14.5237 34.6991 14.6281 34.4566 14.8194 34.3526C15.0107 34.266 15.2542 34.3526 15.3586 34.5432C15.4456 34.7338 15.3586 34.9763 15.1673 35.0803C15.1325 35.0976 15.0803 35.1149 15.0455 35.1149L14.6977 36.4836L14.9933 37.09L16.1587 37.1767L16.5413 36.6222L16.4196 35.2189C16.4196 35.2189 16.3326 35.1842 16.2978 35.1669C16.1239 35.0456 16.0717 34.8031 16.1935 34.6125C16.3152 34.4219 16.5761 34.3873 16.75 34.5086C16.9414 34.6298 16.9762 34.8897 16.8544 35.063C16.8544 35.0803 16.8196 35.1149 16.8022 35.1323H16.7848ZM15.1847 37.4885L15.4977 38.1295L15.8978 37.5405L15.1847 37.4885ZM15.1499 38.3028L14.8368 37.6618L14.4194 38.2508L15.1325 38.3028H15.1499ZM15.776 38.7359L16.0891 39.377L16.4892 38.7879L15.776 38.7359ZM15.1151 38.684L14.402 38.632L14.7151 39.273L15.1325 38.684H15.1151ZM16.5239 38.4241L16.2109 37.783L15.8108 38.3721L16.5239 38.4241ZM15.7412 39.5502L15.4282 38.9092L15.0107 39.4982L15.7239 39.5502H15.7412Z",
    fill: "url(#paint211_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M29.6383 67.0455C30.2296 66.6297 30.9254 66.4911 31.2037 66.7337C31.4819 66.9589 31.2384 67.4787 30.6645 67.8945C30.0731 68.2929 29.3774 68.4489 29.0991 68.2063C28.8208 67.9811 29.0643 67.4613 29.6383 67.0455Z",
    fill: "url(#paint212_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M41.2046 56.0267L40.8915 56.9103L40.3001 56.1827C40.3001 56.1827 40.1262 56.096 40.0566 56.1653C39.9871 56.2346 39.9697 56.3386 40.0219 56.4079L40.6306 57.1529L39.674 57.3261C39.5696 57.3435 39.5175 57.4301 39.5349 57.534C39.5349 57.638 39.6392 57.69 39.7436 57.6726L40.6828 57.4994L40.3523 58.4003C40.3175 58.4869 40.3523 58.5909 40.4567 58.6255C40.561 58.6602 40.648 58.6255 40.6828 58.5216L40.9959 57.638L41.6046 58.3656C41.6046 58.3656 41.7786 58.4523 41.8481 58.383C41.9003 58.3483 41.9177 58.279 41.9177 58.2097C41.9177 58.1751 41.9177 58.1577 41.8829 58.1231L41.2742 57.3781L42.2308 57.2048C42.3351 57.2048 42.3873 57.1009 42.3699 56.9969C42.3699 56.893 42.2656 56.841 42.1612 56.8583L41.222 57.0316L41.5524 56.1307C41.5524 56.1307 41.5524 56.0614 41.5524 56.0441C41.5524 55.9748 41.5003 55.9228 41.4307 55.9055C41.3437 55.8708 41.2394 55.9054 41.2046 56.0094V56.0267Z",
    fill: "url(#paint213_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M46.3182 50.0147C46.3182 50.0147 46.3355 49.9108 46.3182 49.8588C46.3008 49.7548 46.2312 49.6682 46.1268 49.6336C45.9703 49.5816 45.8138 49.6682 45.7616 49.8068C45.7616 49.8588 45.7442 49.9108 45.7616 49.9627C45.779 50.0667 45.8485 50.1533 45.9529 50.188C45.9703 50.188 46.0051 50.188 46.0225 50.188L46.3529 51.0716L45.9529 52.1977L45.1702 51.2968V50.3612C45.1702 50.3612 45.205 50.3439 45.2224 50.3266C45.3094 50.2573 45.3441 50.1533 45.3267 50.0494C45.3267 49.9974 45.292 49.9454 45.2572 49.9108C45.1528 49.7895 44.9615 49.7722 44.8397 49.8761C44.7528 49.9454 44.718 50.0494 44.7354 50.1533C44.7354 50.2053 44.7702 50.2573 44.805 50.2919C44.805 50.2919 44.8223 50.3266 44.8397 50.3266V50.933L44.4223 50.4305C44.4571 50.3439 44.4223 50.2226 44.3701 50.1533C44.3179 50.1014 44.2484 50.0667 44.1788 50.0494C44.1092 50.0494 44.0223 50.0494 43.9701 50.1187C43.8831 50.188 43.8483 50.2919 43.8657 50.3959C43.8657 50.4479 43.9005 50.4998 43.9353 50.5345C44.0049 50.6038 44.1092 50.6558 44.1962 50.6384L44.631 51.1409L44.0223 51.0369C44.0223 51.0369 44.0049 51.0023 43.9875 50.9849C43.8831 50.8637 43.6918 50.8463 43.57 50.9503C43.5005 51.0196 43.4483 51.1235 43.4657 51.2275C43.4657 51.2795 43.5005 51.3314 43.5353 51.3661C43.6396 51.4874 43.8309 51.5047 43.9527 51.4007C43.9701 51.4007 43.9875 51.3661 44.0049 51.3488L44.9267 51.5047L45.7094 52.4056L44.5267 52.6135L43.7092 52.1631C43.7092 52.1631 43.7092 52.1111 43.7092 52.0764C43.6744 51.9205 43.5353 51.8166 43.3613 51.8512C43.2048 51.8859 43.1004 52.0245 43.1352 52.1977C43.17 52.3536 43.3091 52.4576 43.4831 52.4229C43.4831 52.4229 43.5179 52.4229 43.5353 52.4229L44.0744 52.7175L43.4135 52.8387C43.4135 52.8387 43.2396 52.7348 43.1352 52.7521C42.9787 52.7868 42.8743 52.9254 42.9091 53.0986C42.9439 53.2546 43.083 53.3585 43.257 53.3239C43.3613 53.3065 43.4483 53.2372 43.4831 53.1333L44.144 53.012L43.744 53.4798C43.744 53.4798 43.7092 53.4798 43.6918 53.4798C43.5353 53.5144 43.4309 53.653 43.4657 53.8263C43.5005 53.9822 43.6396 54.0862 43.8135 54.0515C43.9701 54.0169 44.0744 53.8609 44.0397 53.705C44.0397 53.6704 44.0397 53.653 44.0223 53.6357L44.631 52.9254L45.8138 52.7001L45.4137 53.8263L44.6136 54.3114C44.6136 54.3114 44.5615 54.2767 44.5441 54.2767C44.3875 54.2248 44.231 54.2941 44.1788 54.45C44.1788 54.502 44.1614 54.554 44.1788 54.6059C44.1962 54.7099 44.2658 54.7965 44.3701 54.8312C44.4397 54.8658 44.5267 54.8485 44.5962 54.8312C44.6658 54.7965 44.718 54.7445 44.7528 54.6579C44.7528 54.6579 44.7528 54.6233 44.7528 54.6059L45.2746 54.2941L45.0485 54.9178C44.9441 54.9351 44.8745 55.0044 44.8397 55.1084C44.8397 55.1603 44.8223 55.2123 44.8397 55.2643C44.8571 55.3682 44.9267 55.4549 45.0311 55.4895C45.1876 55.5415 45.3441 55.4722 45.3963 55.3163C45.4311 55.2296 45.3963 55.1084 45.3441 55.0391L45.5703 54.4154L45.779 54.9871C45.779 54.9871 45.7616 55.0217 45.7616 55.0391C45.7616 55.091 45.7442 55.143 45.7616 55.195C45.779 55.2989 45.8485 55.3856 45.9529 55.4202C46.1094 55.4722 46.266 55.3856 46.3182 55.247C46.3182 55.195 46.3355 55.143 46.3182 55.091C46.3008 54.9871 46.2312 54.9005 46.1268 54.8658C46.1094 54.8658 46.0747 54.8658 46.0573 54.8658L45.7268 53.9822L46.1268 52.8561L46.9095 53.757V54.6926C46.9095 54.6926 46.8747 54.7099 46.8573 54.7445C46.7704 54.8138 46.7356 54.9178 46.753 55.0217C46.753 55.0737 46.7878 55.1257 46.8226 55.1603C46.8747 55.2123 46.9443 55.247 47.0139 55.2643C47.0834 55.2643 47.1704 55.247 47.2226 55.195C47.3096 55.1257 47.3443 55.0217 47.327 54.9178C47.327 54.8658 47.2922 54.8138 47.2574 54.7792C47.2574 54.7792 47.24 54.7445 47.2226 54.7445V54.1381L47.64 54.6406C47.6052 54.7272 47.64 54.8485 47.6922 54.9178C47.7966 55.0391 47.9879 55.0564 48.1096 54.9524C48.1966 54.8831 48.2314 54.7792 48.214 54.6752C48.214 54.6233 48.1792 54.5713 48.1444 54.5366C48.0749 54.4673 47.9705 54.4154 47.8661 54.4327L47.4313 53.9302L48.0401 54.0342C48.0401 54.0342 48.0575 54.0688 48.0749 54.0862C48.1792 54.2075 48.3705 54.2248 48.4923 54.1208C48.5793 54.0515 48.614 53.9476 48.5966 53.8436C48.5966 53.7916 48.5619 53.7397 48.5271 53.705C48.4749 53.653 48.4053 53.6184 48.3358 53.6011C48.2662 53.6011 48.1792 53.6184 48.127 53.6704C48.1096 53.6704 48.0922 53.705 48.0749 53.7397L47.153 53.5837L46.3703 52.6828L47.5531 52.4576L48.3705 52.9081C48.3705 52.9081 48.3705 52.96 48.3705 52.9947C48.4053 53.1506 48.5445 53.2546 48.7184 53.2199C48.8749 53.1853 48.9793 53.0467 48.9445 52.8734C48.9097 52.7001 48.7706 52.6135 48.5966 52.6482C48.5793 52.6482 48.5619 52.6482 48.5445 52.6482L48.0053 52.3536L48.6662 52.2324C48.6662 52.2324 48.8402 52.3363 48.9445 52.319C49.101 52.2843 49.2054 52.1457 49.1706 51.9725C49.1358 51.8166 48.9793 51.7126 48.8228 51.7473C48.7184 51.7646 48.6314 51.8339 48.5966 51.9378L47.9357 52.0591L48.3358 51.5913C48.3358 51.5913 48.3705 51.5913 48.3879 51.5913C48.5445 51.5567 48.6488 51.4007 48.614 51.2448C48.5793 51.0889 48.4401 50.9849 48.2662 51.0196C48.1096 51.0542 48.0053 51.1928 48.0401 51.3661C48.0401 51.4007 48.0401 51.4181 48.0575 51.4354L47.4487 52.1457L46.266 52.371L46.666 51.2448L47.4661 50.7597C47.4661 50.7597 47.5183 50.7944 47.5357 50.7944C47.6922 50.8463 47.8487 50.777 47.9009 50.6211C47.9009 50.5691 47.9183 50.5172 47.9009 50.4652C47.8835 50.3612 47.814 50.2746 47.7096 50.24C47.5531 50.188 47.3965 50.2573 47.3443 50.4132C47.3443 50.4305 47.3443 50.4479 47.3443 50.4652L46.8226 50.777L47.0487 50.1533C47.153 50.136 47.2226 50.0667 47.2574 49.9627C47.2574 49.9108 47.2748 49.8588 47.2574 49.8068C47.24 49.7029 47.1704 49.6162 47.0661 49.5816C46.9095 49.5296 46.753 49.6162 46.7008 49.7548C46.666 49.8415 46.7008 49.9627 46.753 50.032L46.5269 50.6558L46.3182 50.084C46.3182 50.084 46.3182 50.0494 46.3355 50.032L46.3182 50.0147Z",
    fill: "url(#paint214_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M69.3116 58.66L68.8941 59.6822L68.2158 58.7986C68.1462 58.712 68.0071 58.6947 67.9201 58.764C67.8331 58.8333 67.8158 58.9719 67.8853 59.0585L68.5637 59.9594L67.4505 60.1153C67.3288 60.1153 67.2592 60.2366 67.2766 60.3579C67.2766 60.4792 67.3983 60.5485 67.5201 60.5312L68.6332 60.3752L68.2158 61.4147C68.1636 61.5187 68.2158 61.64 68.3375 61.692C68.4419 61.7439 68.5637 61.692 68.6158 61.5707L69.0333 60.5485L69.7116 61.4321C69.7812 61.5187 69.9203 61.536 70.0073 61.4667C70.0769 61.4148 70.0942 61.3454 70.0942 61.2761C70.0942 61.2415 70.0943 61.2068 70.0595 61.1722L69.3811 60.2713L70.5117 60.1153C70.6334 60.1153 70.703 59.9941 70.6856 59.8728C70.6856 59.7515 70.5639 59.6822 70.4421 59.6995L69.329 59.8555L69.7464 58.816C69.7464 58.816 69.7638 58.7467 69.7464 58.712C69.7464 58.6427 69.6942 58.5734 69.6246 58.5387C69.5203 58.4868 69.3985 58.5387 69.3463 58.66H69.3116Z",
    fill: "url(#paint215_radial_12_16505)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9054 23.2473C9.67069 23.5418 10.0533 24.4081 9.74027 25.1704C9.44458 25.9327 8.57493 26.3139 7.80963 26.002C7.04434 25.7075 6.66169 24.8412 6.97477 24.0789C7.28784 23.3166 8.1401 22.9354 8.9054 23.2473Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5334 20.839L24.6812 21.5147L24.542 20.4405C24.542 20.3366 24.4203 20.25 24.3159 20.2673C24.2116 20.2673 24.1246 20.3886 24.142 20.4925L24.2811 21.584L23.2549 21.1855C23.1506 21.1509 23.0288 21.1855 22.994 21.3068C22.9593 21.4108 22.994 21.532 23.1158 21.5667L24.1246 21.9652L23.2723 22.6409C23.1854 22.7102 23.168 22.8314 23.2375 22.9181C23.3071 23.0047 23.4289 23.022 23.5158 22.9527L24.3681 22.277L24.5072 23.3512C24.5072 23.4552 24.629 23.5418 24.7334 23.5245C24.8029 23.5245 24.8725 23.4552 24.8899 23.4032C24.8899 23.3685 24.8899 23.3339 24.8899 23.2992L24.7507 22.2077L25.7769 22.6062C25.8813 22.6409 26.0031 22.6062 26.0378 22.4849C26.0726 22.381 26.0378 22.2597 25.9161 22.2251L24.8899 21.8266L25.7422 21.1509C25.7422 21.1509 25.7943 21.0989 25.8117 21.0643C25.8291 20.995 25.8117 20.9257 25.7769 20.8564C25.7074 20.7697 25.5856 20.7524 25.4813 20.8217L25.5334 20.839Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4151 37.8871L60.6324 38.5974L60.4237 37.5579C60.4063 37.4539 60.3019 37.3846 60.1975 37.4019C60.0932 37.4193 60.0236 37.5232 60.041 37.6445L60.2497 38.7013L59.2235 38.3722C59.1192 38.3375 59.0148 38.3895 58.98 38.5108C58.9452 38.6147 58.9974 38.7187 59.1192 38.7533L60.1454 39.0652L59.3627 39.7928C59.3627 39.7928 59.2757 40.0007 59.3627 40.07C59.4496 40.1393 59.5714 40.1567 59.641 40.07L60.4237 39.3597L60.6324 40.3992C60.6498 40.5032 60.7541 40.5725 60.8759 40.5552C60.9454 40.5552 61.015 40.4859 61.0324 40.4165C61.0324 40.3819 61.0324 40.3472 61.0324 40.3126L60.8237 39.2558L61.8499 39.5676C61.9543 39.6023 62.0586 39.5503 62.0934 39.4463C62.1282 39.3424 62.076 39.2211 61.9542 39.2038L60.9281 38.8919L61.7107 38.1643C61.7107 38.1643 61.7629 38.1123 61.7629 38.0776C61.7803 38.0083 61.7629 37.939 61.7107 37.8871C61.6412 37.8004 61.502 37.8004 61.4325 37.8871H61.4151Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M73.034 46.5843L72.8427 48.0223L73.6601 47.2773C73.6601 47.2773 73.8514 47.208 73.921 47.2773C73.9906 47.3466 73.9906 47.4679 73.921 47.5372L73.1035 48.2822L74.5646 48.2129C74.6689 48.2129 74.7559 48.2822 74.7559 48.3862C74.7559 48.4901 74.6863 48.5767 74.582 48.5767L72.6687 48.6807L72.3382 48.9925L73.7993 48.9232C73.9036 48.9232 73.9906 48.9925 73.9906 49.0965C73.9906 49.2004 73.921 49.2871 73.8167 49.2871L71.9034 49.391L71.573 49.7029L73.034 49.6336C73.1383 49.6336 73.2253 49.7029 73.2253 49.8068C73.2253 49.9108 73.1557 49.9974 73.0514 49.9974L71.1381 50.1014L70.3728 50.7944L70.5989 51.8339L71.5903 52.1457L73.3644 51.4181C73.4514 51.3834 73.5732 51.4181 73.6079 51.522C73.6427 51.626 73.6079 51.7299 73.5036 51.7646L72.1469 52.319L72.5818 52.4576L74.3558 51.7299C74.4602 51.6953 74.5646 51.7299 74.5993 51.8339C74.6341 51.9378 74.5994 52.0418 74.495 52.0764L73.1383 52.6309L73.5732 52.7695L75.3473 52.0418C75.4516 52.0071 75.556 52.0418 75.5908 52.1457C75.6255 52.2324 75.5908 52.3537 75.4864 52.3883L74.1297 52.9427L75.1907 53.2719C75.2951 53.3065 75.3473 53.4105 75.3125 53.5144C75.2777 53.6184 75.1733 53.6704 75.069 53.6357L74.008 53.3065L74.8081 54.5193C74.8602 54.6059 74.8429 54.7272 74.7559 54.7792C74.6689 54.8312 74.5472 54.8138 74.495 54.7272L73.4514 53.1333L73.0166 52.9947L73.8167 54.2075C73.8688 54.2941 73.8514 54.4154 73.7645 54.4673C73.6775 54.5193 73.5558 54.502 73.5036 54.4154L72.46 52.8214L72.0252 52.6828L72.8253 53.8956C72.8253 53.8956 72.86 54.1035 72.7731 54.1555C72.6861 54.2075 72.5644 54.1901 72.5122 54.1035L71.4686 52.5096L70.4946 52.1977L69.7119 52.9081L69.938 53.9129L71.4512 55.0737C71.4512 55.0737 71.5556 55.247 71.486 55.3336C71.4164 55.4202 71.2947 55.4376 71.2251 55.3683L70.0771 54.4847L70.1815 54.9351L71.6947 56.0959C71.6947 56.0959 71.7991 56.2692 71.7295 56.3558C71.6599 56.4424 71.5382 56.4598 71.4686 56.3905L70.3207 55.5069L70.425 55.9573L71.9382 57.1181C71.9382 57.1181 72.0426 57.2914 71.973 57.378C71.9034 57.4646 71.7817 57.4819 71.7121 57.4126L70.5642 56.5291L70.8077 57.6032C70.825 57.7072 70.7729 57.8111 70.6685 57.8285C70.5642 57.8458 70.4598 57.7938 70.4424 57.6898L70.1989 56.6157L69.538 57.9151C69.4858 58.0017 69.3814 58.0537 69.2771 58.0017C69.1901 57.9497 69.1379 57.8458 69.1901 57.7418L70.0598 56.0439L69.9554 55.5935L69.2945 56.8929C69.2423 56.9795 69.1379 57.0315 69.0336 56.9795C68.9466 56.9275 68.8944 56.8236 68.9466 56.7196L69.8163 55.0217L69.7119 54.5713L69.051 55.8707C68.9988 55.9573 68.8944 56.0093 68.7901 55.9573C68.7031 55.9053 68.6683 55.8014 68.7031 55.6974L69.5727 53.9996L69.3466 53.012L68.3031 52.6828L67.5552 53.3585L67.2943 55.247C67.2943 55.3509 67.1899 55.4202 67.0855 55.4029C66.9812 55.4029 66.9116 55.299 66.929 55.195L67.1203 53.757L66.7899 54.0689L66.529 55.9573C66.529 56.0613 66.4246 56.1306 66.3202 56.1132C66.2159 56.1132 66.1463 56.0093 66.1637 55.9053L66.355 54.4673L66.0246 54.7792L65.7637 56.6677C65.7637 56.7716 65.6593 56.8409 65.555 56.8236C65.4506 56.8236 65.381 56.7196 65.3984 56.6157L65.5897 55.1777L64.7723 55.9227C64.7723 55.9227 64.5809 55.992 64.5114 55.9227C64.4418 55.8534 64.4418 55.7321 64.5114 55.6628L65.3288 54.9178L63.8678 54.9871C63.7635 54.9871 63.6765 54.9178 63.6765 54.8138C63.6765 54.7099 63.7461 54.6233 63.8504 54.6233L65.7637 54.5193L66.0941 54.2075L64.6331 54.2768C64.5288 54.2768 64.4418 54.2075 64.4418 54.1035C64.4418 53.9996 64.5114 53.9129 64.6157 53.9129L66.529 53.809L66.8594 53.4971L65.3984 53.5664C65.2941 53.5664 65.2071 53.4971 65.2071 53.3932C65.2071 53.2892 65.2767 53.2026 65.381 53.2026L67.2943 53.0986L68.0248 52.4403L67.7813 51.3661L66.842 51.0716L65.0679 51.7992C64.981 51.8339 64.8592 51.7992 64.8244 51.6953C64.7897 51.5913 64.8244 51.4874 64.9288 51.4527L66.2855 50.8983L65.8506 50.7597L64.0765 51.4874C63.9722 51.522 63.8678 51.4874 63.833 51.3834C63.7982 51.2795 63.833 51.1755 63.9374 51.1409L65.2941 50.5865L64.8592 50.4479L63.0851 51.1755C62.9808 51.2102 62.8764 51.1755 62.8416 51.0716C62.8068 50.9676 62.8416 50.8637 62.946 50.829L64.3026 50.2746L63.2417 49.9454C63.1373 49.9108 63.0851 49.8068 63.1199 49.7029C63.1547 49.5989 63.2591 49.547 63.3634 49.5816L64.4244 49.9108L63.6243 48.698C63.6243 48.698 63.5895 48.4901 63.6765 48.4381C63.7635 48.3862 63.8852 48.4035 63.9374 48.4901L64.981 50.084L65.4158 50.2226L64.6157 49.0099C64.6157 49.0099 64.5809 48.802 64.6679 48.75C64.7549 48.698 64.8766 48.7153 64.9288 48.802L65.9724 50.3959L66.4072 50.5345L65.6071 49.3217C65.5549 49.2351 65.5723 49.1138 65.6593 49.0618C65.7463 49.0099 65.868 49.0272 65.9202 49.1138L66.9638 50.7077L67.903 51.0023L68.7205 50.2573L68.5118 49.3044L66.9986 48.1436C66.9986 48.1436 66.8942 47.9703 66.9638 47.8837C67.0334 47.7971 67.1551 47.7798 67.2247 47.8491L68.3726 48.7327L68.2683 48.2822L66.7551 47.1214C66.7551 47.1214 66.6507 46.9308 66.7203 46.8615C66.7899 46.7749 66.9116 46.7576 66.9812 46.8269L68.1291 47.7105L68.0248 47.26L66.5116 46.0992C66.5116 46.0992 66.4072 45.9086 66.4768 45.8393C66.5464 45.7527 66.6681 45.7354 66.7377 45.8047L67.8856 46.6883L67.6421 45.6141C67.6247 45.5102 67.6769 45.4062 67.7813 45.3889C67.8856 45.3716 67.99 45.4235 68.0074 45.5275L68.2509 46.6016L68.9118 45.3022C68.964 45.2156 69.0683 45.1636 69.1727 45.2156C69.2597 45.2676 69.3119 45.3715 69.2597 45.4755L68.39 47.1734L68.4944 47.6238L69.1553 46.3244C69.2075 46.2378 69.3119 46.1858 69.4162 46.2378C69.5032 46.2898 69.5554 46.3937 69.5032 46.4977L68.6335 48.1956L68.7379 48.646L69.3988 47.3466C69.451 47.26 69.5554 47.208 69.6597 47.26C69.7467 47.312 69.7815 47.4159 69.7467 47.5199L68.877 49.2178L69.1031 50.188L70.1467 50.5172L70.8946 49.8415L71.1555 47.953C71.1555 47.8491 71.2599 47.7798 71.3642 47.7971C71.4686 47.7971 71.5382 47.901 71.5208 48.005L71.3295 49.443L71.6599 49.1311L71.9208 47.2427C71.9208 47.1387 72.0252 47.0694 72.1295 47.0868C72.2339 47.0868 72.3035 47.1907 72.2861 47.2947L72.0947 48.7327L72.4252 48.4208L72.6861 46.5323C72.6861 46.4284 72.7905 46.3591 72.8948 46.3764C72.9992 46.3764 73.0688 46.4804 73.0514 46.5843H73.034ZM68.9292 50.5518L68.1291 51.2795L68.3726 52.3363L69.4162 52.6655L70.2163 51.9378L69.9728 50.881L68.9292 50.5518Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3222 23.6111L88.5831 25.1357L89.1745 24.1136C89.2267 24.0096 89.3484 23.975 89.4528 24.0443C89.5571 24.0962 89.5919 24.2175 89.5224 24.3215L88.931 25.3437L90.392 24.7892C90.4964 24.7546 90.6181 24.7892 90.6529 24.9105C90.6877 25.0145 90.6529 25.1357 90.5311 25.1704L88.6179 25.8807L88.3744 26.2965L89.8354 25.7421C89.9398 25.7075 90.0615 25.7421 90.0963 25.8634C90.1311 25.9674 90.0963 26.0886 89.9746 26.1233L88.0613 26.8336L87.8178 27.2494L89.2789 26.695C89.3832 26.6604 89.505 26.695 89.5397 26.8163C89.5745 26.9203 89.5397 27.0415 89.418 27.0762L87.5048 27.7865L86.9656 28.7394L87.5395 29.727H88.6353L90.2181 28.4102C90.305 28.3409 90.4268 28.3583 90.4964 28.4449C90.5659 28.5315 90.5485 28.6528 90.4616 28.7221L89.2615 29.7096H89.7485L91.3312 28.3929C91.4182 28.3236 91.54 28.3409 91.6095 28.4102C91.6791 28.4969 91.6617 28.6181 91.5921 28.6874L90.392 29.675H90.879L92.4618 28.3756C92.5487 28.3063 92.6705 28.3063 92.7401 28.3929C92.8096 28.4795 92.7923 28.6008 92.7227 28.6701L91.5226 29.6577H92.7053C92.8096 29.6577 92.914 29.7443 92.914 29.8482C92.914 29.9522 92.827 30.0561 92.7053 30.0561H91.5226L92.7227 31.0437C92.8096 31.113 92.827 31.2343 92.7575 31.3209C92.6879 31.4075 92.5661 31.4248 92.4792 31.3555L90.8964 30.0561H90.4094L91.6095 31.0437C91.6965 31.113 91.7139 31.2343 91.6443 31.3209C91.5747 31.4075 91.453 31.4248 91.366 31.3555L89.7832 30.0561H89.2962L90.4964 31.0437C90.5833 31.113 90.6007 31.2343 90.5311 31.3209C90.4616 31.4075 90.3398 31.4248 90.2529 31.3555L88.6701 30.0561H87.5743L87.0004 31.0437L87.5569 31.9966L89.4876 32.7069C89.5919 32.7416 89.6441 32.8628 89.6093 32.9668C89.5745 33.0707 89.4528 33.1227 89.3484 33.0881L87.8874 32.551L88.1309 32.9668L90.0615 33.6771C90.1659 33.7118 90.2181 33.8331 90.1833 33.937C90.1485 34.041 90.0268 34.0929 89.9224 34.0583L88.4614 33.5212L88.7049 33.937L90.6355 34.6473C90.7399 34.682 90.792 34.8033 90.7573 34.9072C90.7225 35.0112 90.6007 35.0632 90.4964 35.0285L89.0353 34.4914L89.6267 35.5136C89.6789 35.6176 89.6441 35.7388 89.5571 35.7908C89.4528 35.8428 89.331 35.8081 89.2789 35.7215L88.6875 34.6993L88.4266 36.2413C88.4092 36.3452 88.3048 36.4319 88.2005 36.4145C88.0961 36.4145 88.0092 36.2933 88.0265 36.1893L88.357 34.1796L88.1135 33.7638L87.8526 35.2884C87.8352 35.3923 87.7309 35.479 87.6265 35.4616C87.5221 35.4616 87.4352 35.3404 87.4526 35.2364L87.783 33.2267L87.5395 32.8109L87.2786 34.3355C87.2613 34.4394 87.1569 34.5261 87.0525 34.5087C86.9482 34.4914 86.8612 34.3875 86.8786 34.2835L87.2091 32.2738L86.6699 31.3382H85.5045L84.9654 32.2738L85.3132 34.2835C85.3306 34.3875 85.261 34.4914 85.1567 34.5087C85.0523 34.5261 84.948 34.4568 84.9306 34.3528L84.6697 32.8282L84.4262 33.244L84.774 35.2537C84.7914 35.3577 84.7219 35.4616 84.6175 35.479C84.5131 35.4963 84.4088 35.427 84.3914 35.323L84.1305 33.7984L83.887 34.2142L84.2349 36.2239C84.2522 36.3279 84.1827 36.4319 84.0609 36.4492C83.9566 36.4665 83.8522 36.3972 83.8348 36.2933L83.5739 34.7686L82.9826 35.7908C82.9304 35.8948 82.8086 35.9294 82.7043 35.8601C82.5999 35.8081 82.5651 35.6869 82.6347 35.5829L83.2261 34.5607L81.765 35.1151C81.6607 35.1498 81.5389 35.1151 81.5041 34.9939C81.4694 34.8899 81.5041 34.7686 81.6259 34.734L83.5391 34.0063L83.7826 33.5905L82.3216 34.1449C82.2173 34.1796 82.0955 34.1449 82.0607 34.0236C82.0259 33.9197 82.0607 33.7984 82.1825 33.7638L84.0957 33.0361L84.3392 32.6203L82.8782 33.1747C82.7738 33.2093 82.6521 33.1747 82.6173 33.0534C82.5825 32.9495 82.6173 32.8282 82.739 32.7935L84.6523 32.0659L85.1741 31.1476L84.5827 30.1254H83.5217L81.939 31.4422C81.852 31.5115 81.7303 31.5115 81.6607 31.4248C81.5911 31.3382 81.5911 31.2169 81.6781 31.1476L82.8782 30.1601H82.3912L80.8084 31.4595C80.8084 31.4595 80.5997 31.5115 80.5301 31.4422C80.4606 31.3555 80.478 31.2343 80.5475 31.165L81.7476 30.1774H81.2606L79.6779 31.4768C79.6779 31.4768 79.4692 31.5288 79.3996 31.4595C79.33 31.3729 79.3474 31.2516 79.4344 31.1823L80.6345 30.1947H79.4518C79.3474 30.1947 79.243 30.1081 79.243 30.0042C79.243 29.9002 79.33 29.7963 79.4518 29.7963H80.6345L79.4344 28.8087C79.3474 28.7394 79.33 28.6181 79.3996 28.5315C79.4692 28.4449 79.5909 28.4276 79.6779 28.4969L81.2606 29.7963H81.7476L80.5475 28.8087C80.5475 28.8087 80.4432 28.6181 80.5127 28.5315C80.5823 28.4449 80.7041 28.4276 80.791 28.4969L82.3738 29.7963H82.8608L81.6607 28.8087C81.5737 28.7394 81.5563 28.6181 81.6259 28.5315C81.6955 28.4449 81.8172 28.4276 81.9042 28.4969L83.487 29.7963H84.5479L85.1393 28.7567L84.6001 27.8385L82.6695 27.1282C82.5651 27.0935 82.5129 26.9722 82.5477 26.8683C82.5825 26.7643 82.7043 26.7124 82.8086 26.747L84.2696 27.2841L84.0261 26.8683L82.0955 26.1579C81.9911 26.1233 81.939 26.002 81.9738 25.8981C82.0085 25.7941 82.1303 25.7421 82.2347 25.7768L83.6957 26.3139L83.4522 25.8981L81.5215 25.1877C81.4172 25.1531 81.365 25.0318 81.3998 24.9278C81.4346 24.8239 81.5563 24.7719 81.6607 24.8066L83.1217 25.3437L82.5303 24.3215C82.4782 24.2175 82.5129 24.0962 82.5999 24.0443C82.7043 23.9923 82.826 24.0269 82.8782 24.1136L83.4696 25.1357L83.7305 23.5938C83.7478 23.4898 83.8522 23.4032 83.9566 23.4205C84.0609 23.4379 84.1479 23.5418 84.1305 23.6458L83.8 25.6555L84.0435 26.0713L84.3044 24.5467C84.3218 24.4427 84.4262 24.3561 84.5305 24.3734C84.6349 24.3908 84.7219 24.4947 84.7045 24.5987L84.374 26.6084L84.6175 27.0242L84.8784 25.4996C84.8958 25.3956 85.0002 25.309 85.1045 25.3263C85.2089 25.3437 85.2958 25.4476 85.2784 25.5516L84.948 27.5613L85.4872 28.4969H86.6525L87.1917 27.5613L86.8438 25.5516C86.8264 25.4476 86.896 25.3437 87.0004 25.3263C87.1047 25.309 87.2091 25.3783 87.2265 25.4996L87.4874 27.0242L87.7309 26.6084L87.383 24.5987C87.3656 24.4947 87.4352 24.3908 87.5395 24.3734C87.6439 24.3561 87.7483 24.4254 87.7656 24.5467L88.0265 26.0713L88.27 25.6555L87.9222 23.6458C87.9048 23.5418 87.9744 23.4379 88.0961 23.4205C88.2005 23.4032 88.3048 23.4725 88.3222 23.5938V23.6111ZM85.435 28.9646L84.861 29.9695L85.4524 30.9744H86.6177L87.1917 29.9695L86.6003 28.9646H85.435Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2625 51.7299C12.2625 51.7299 12.3147 51.6086 12.3147 51.5567C12.3147 51.4354 12.2451 51.3141 12.1407 51.2621C11.9668 51.1582 11.7581 51.2275 11.6711 51.3834C11.6363 51.4354 11.6189 51.5047 11.6189 51.5567C11.6189 51.6779 11.6885 51.7992 11.7929 51.8512C11.8277 51.8512 11.845 51.8858 11.8798 51.8858L12.0712 52.9773L11.358 54.2074L10.6449 52.9773L10.8362 51.8685C10.8362 51.8685 10.9058 51.8512 10.9232 51.8339C11.0276 51.7646 11.0971 51.6606 11.0971 51.5393C11.0971 51.4874 11.0971 51.4181 11.045 51.3661C10.9406 51.1928 10.7319 51.1409 10.5754 51.2448C10.471 51.3141 10.4014 51.4181 10.4014 51.5393C10.4014 51.6086 10.4014 51.6606 10.4536 51.7126C10.4536 51.7299 10.471 51.7472 10.4884 51.7646L10.3666 52.4922L9.96659 51.7992C10.0188 51.6953 10.0188 51.5567 9.96659 51.4527C9.91442 51.3661 9.84484 51.3141 9.75788 51.2968C9.67091 51.2795 9.56655 51.2968 9.49698 51.3314C9.39262 51.4007 9.32305 51.5047 9.32305 51.626C9.32305 51.6953 9.32305 51.7472 9.37523 51.7992C9.4448 51.9032 9.54916 51.9725 9.67091 51.9725L10.071 52.6655L9.37523 52.4056C9.37523 52.4056 9.37523 52.371 9.34044 52.3363C9.23609 52.1804 9.02737 52.1111 8.87083 52.215C8.76647 52.2843 8.6969 52.3883 8.6969 52.5096C8.6969 52.5615 8.6969 52.6308 8.74908 52.6828C8.85344 52.8561 9.06215 52.908 9.21869 52.8041C9.25348 52.8041 9.27087 52.7694 9.28826 52.7521L10.3318 53.1333L11.045 54.3634H9.61873L8.74908 53.653C8.74908 53.6184 8.74908 53.5837 8.74908 53.5664C8.74908 53.3758 8.59254 53.2199 8.40122 53.2199C8.20989 53.2199 8.05336 53.3758 8.05336 53.5664C8.05336 53.757 8.20989 53.9129 8.40122 53.9129C8.41861 53.9129 8.4534 53.9129 8.47079 53.9129L9.04476 54.3807H8.24468C8.17511 54.2767 8.07075 54.2248 7.949 54.2248C7.75767 54.2248 7.60114 54.3807 7.60114 54.5713C7.60114 54.7618 7.75767 54.9178 7.949 54.9178C8.07075 54.9178 8.17511 54.8485 8.24468 54.7445H9.04476L8.48818 55.2123C8.47079 55.2123 8.436 55.2123 8.41861 55.2123C8.22729 55.2123 8.07075 55.3682 8.07075 55.5588C8.07075 55.7494 8.22729 55.9053 8.41861 55.9053C8.60993 55.9053 8.76647 55.7494 8.76647 55.5588C8.76647 55.5242 8.76647 55.4895 8.76647 55.4722L9.63613 54.7618H11.0624L10.3492 55.9919L9.30566 56.3904C9.30566 56.3904 9.25348 56.3558 9.23609 56.3384C9.06215 56.2345 8.85344 56.3038 8.76647 56.4597C8.73169 56.5117 8.71429 56.5637 8.71429 56.633C8.71429 56.7543 8.78386 56.8755 8.88822 56.9275C8.97519 56.9795 9.06215 56.9795 9.14912 56.9622C9.23609 56.9448 9.30566 56.8755 9.35784 56.8062C9.35784 56.7889 9.37523 56.7716 9.39262 56.7369L10.0883 56.477L9.68831 57.1701C9.56655 57.1701 9.4622 57.2394 9.39262 57.3433C9.35784 57.3953 9.34044 57.4646 9.34044 57.5166C9.34044 57.6378 9.41002 57.7591 9.51437 57.8111C9.68831 57.8977 9.89702 57.8457 9.98399 57.6898C10.0362 57.5859 10.0362 57.4473 9.98399 57.3433L10.384 56.6503L10.5058 57.378C10.5058 57.378 10.471 57.4126 10.471 57.4299C10.4362 57.4819 10.4188 57.5512 10.4188 57.6032C10.4188 57.7245 10.4884 57.8457 10.5927 57.8977C10.7667 58.0017 10.9754 57.9324 11.0624 57.7764C11.0971 57.7245 11.1145 57.6552 11.1145 57.6032C11.1145 57.4819 11.045 57.3606 10.9406 57.3087C10.9058 57.3087 10.8884 57.274 10.8536 57.274L10.6623 56.1825L11.3754 54.9524L12.0886 56.1825L11.8972 57.2913C11.8972 57.2913 11.8277 57.3087 11.8103 57.326C11.7059 57.3953 11.6363 57.4992 11.6363 57.6205C11.6363 57.6725 11.6363 57.7418 11.6885 57.7938C11.7407 57.8804 11.8103 57.9324 11.8972 57.9497C11.9842 57.967 12.0886 57.9497 12.1581 57.915C12.2625 57.8457 12.3321 57.7418 12.3321 57.6205C12.3321 57.5512 12.3321 57.4992 12.2799 57.4473C12.2799 57.4299 12.2625 57.4126 12.2451 57.3953L12.3668 56.6676L12.7669 57.3606C12.7147 57.4646 12.7147 57.6032 12.7669 57.7071C12.8712 57.8804 13.08 57.9324 13.2365 57.8284C13.3409 57.7591 13.4104 57.6552 13.4104 57.5339C13.4104 57.4646 13.4104 57.4126 13.3582 57.3606C13.2887 57.2567 13.1843 57.1874 13.0626 57.1874L12.6625 56.4944L13.3582 56.7543C13.3582 56.7543 13.3582 56.7889 13.393 56.8236C13.48 56.9795 13.7061 57.0488 13.8626 56.9448C13.967 56.8755 14.0366 56.7716 14.0366 56.6503C14.0366 56.5983 14.0366 56.529 13.9844 56.477C13.9322 56.3904 13.8626 56.3384 13.7757 56.3211C13.6887 56.3038 13.5844 56.3211 13.5148 56.3558C13.48 56.3558 13.4626 56.3904 13.4452 56.4077L12.4016 56.0266L11.6885 54.7965H13.1147L13.9844 55.5068C13.9844 55.5415 13.9844 55.5761 13.9844 55.6108C13.9844 55.8014 14.1409 55.9573 14.3323 55.9573C14.5236 55.9573 14.6801 55.8014 14.6801 55.6108C14.6801 55.4202 14.5236 55.2643 14.3323 55.2643C14.3149 55.2643 14.2801 55.2643 14.2627 55.2643L13.6887 54.7965H14.4888C14.5584 54.9004 14.6627 54.9524 14.7845 54.9524C14.9758 54.9524 15.1323 54.7965 15.1323 54.6059C15.1323 54.4153 14.9758 54.2594 14.7845 54.2594C14.6627 54.2594 14.5584 54.3287 14.4888 54.4327H13.6887L14.2453 53.9649C14.2627 53.9649 14.2975 53.9649 14.3149 53.9649C14.5062 53.9649 14.6627 53.809 14.6627 53.6184C14.6627 53.4278 14.5062 53.2719 14.3149 53.2719C14.1235 53.2719 13.967 53.4278 13.967 53.6184C13.967 53.653 13.967 53.6877 13.967 53.705L13.0973 54.4153H11.6711L12.3842 53.1852L13.4278 52.7868C13.4278 52.7868 13.48 52.8214 13.4974 52.8387C13.6713 52.9427 13.88 52.8734 13.967 52.7175C14.0018 52.6655 14.0192 52.6135 14.0192 52.5442C14.0192 52.4229 13.9496 52.3016 13.8453 52.2497C13.6713 52.163 13.4626 52.215 13.3756 52.371C13.3756 52.3883 13.3582 52.4056 13.3409 52.4403L12.6625 52.7001L13.0626 52.0071C13.1843 52.0071 13.2887 51.9378 13.3582 51.8339C13.393 51.7819 13.4104 51.7299 13.4104 51.6606C13.4104 51.5393 13.3409 51.4181 13.2365 51.3661C13.0626 51.2795 12.8538 51.3314 12.7669 51.4874C12.7147 51.5913 12.7147 51.7299 12.7669 51.8339L12.3668 52.5269L12.2451 51.7992C12.2451 51.7992 12.2799 51.7646 12.2799 51.7472L12.2625 51.7299Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5637 2.92467C65.6247 2.99397 66.4247 3.91221 66.3552 4.96906C66.2856 6.0259 65.3638 6.82286 64.3028 6.75356C63.2418 6.68426 62.4417 5.76602 62.5113 4.70918C62.5809 3.65233 63.5027 2.85537 64.5637 2.92467Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2231 5.02096L52.6839 5.81793L52.2838 4.95166C52.2491 4.86504 52.1273 4.81306 52.0403 4.86504C51.9534 4.89969 51.9186 5.02096 51.9534 5.10759L52.3708 5.99118L51.3968 5.92188C51.2924 5.92188 51.2055 5.99118 51.2055 6.09513C51.2055 6.19909 51.275 6.28571 51.3794 6.28571L52.3534 6.35501L51.8142 7.15198C51.8142 7.15198 51.7794 7.34256 51.8664 7.41186C51.9534 7.46383 52.0577 7.44651 52.1099 7.35988L52.6491 6.56292L53.0491 7.42918C53.0839 7.51581 53.2057 7.56779 53.2926 7.51581C53.3622 7.48116 53.397 7.42918 53.397 7.35988C53.397 7.32523 53.397 7.29058 53.397 7.27326L52.9796 6.38966L53.9536 6.45897C54.0579 6.45897 54.1449 6.38966 54.1449 6.28571C54.1449 6.18176 54.0753 6.09513 53.971 6.09513L52.997 6.02583L53.5361 5.22887C53.5361 5.22887 53.5709 5.17689 53.5709 5.14224C53.5709 5.07294 53.5535 5.02096 53.484 4.98631C53.397 4.93434 53.2926 4.95166 53.2405 5.03829L53.2231 5.02096Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5575 40.0007C93.5575 40.0007 93.6097 39.9141 93.6097 39.8621C93.6097 39.7582 93.5749 39.6542 93.488 39.6023C93.3488 39.5156 93.1749 39.5503 93.0705 39.6889C93.0357 39.7235 93.0183 39.7755 93.0183 39.8275C93.0183 39.9314 93.0705 40.0354 93.1575 40.0874C93.1749 40.0874 93.2097 40.122 93.2271 40.122L93.314 41.0576L92.6357 42.0625L92.0965 40.971L92.3226 40.0527C92.3226 40.0527 92.3748 40.0527 92.3922 40.0354C92.4791 39.9834 92.5487 39.8968 92.5661 39.7928C92.5661 39.7409 92.5661 39.6889 92.5313 39.6369C92.4618 39.4983 92.2878 39.429 92.1313 39.4983C92.0443 39.5503 91.9748 39.6369 91.9748 39.7409C91.9748 39.7928 91.9748 39.8448 92.0095 39.8968C92.0095 39.8968 92.0095 39.9315 92.0443 39.9488L91.9052 40.5552L91.6095 39.9488C91.6095 39.9488 91.6791 39.7582 91.6095 39.6542C91.5747 39.5849 91.5225 39.533 91.4356 39.4983C91.366 39.481 91.279 39.481 91.2095 39.4983C91.1225 39.5503 91.0529 39.6369 91.0529 39.7409C91.0529 39.7928 91.0529 39.8448 91.0877 39.8968C91.1399 39.9834 91.2269 40.0527 91.3312 40.0527L91.6269 40.6591L91.0529 40.3992C91.0529 40.3992 91.0529 40.3646 91.0355 40.3473C90.966 40.2087 90.792 40.1394 90.6355 40.2087C90.5485 40.2606 90.479 40.3473 90.4616 40.4512C90.4616 40.5032 90.4616 40.5552 90.4963 40.6071C90.5659 40.7457 90.7398 40.815 90.8964 40.7457C90.9138 40.7457 90.9486 40.7111 90.966 40.6938L91.8356 41.0749L92.3748 42.1664L91.1573 42.0798L90.4616 41.4214C90.4616 41.4214 90.4616 41.3695 90.4616 41.3348C90.4616 41.1789 90.3572 41.0403 90.1833 41.0229C90.0267 41.0229 89.8876 41.1269 89.8702 41.3001C89.8702 41.4561 89.9746 41.5947 90.1485 41.612C90.1659 41.612 90.1833 41.612 90.2007 41.612L90.6529 42.0451L89.9745 41.9932C89.9224 41.9065 89.8354 41.8372 89.731 41.8372C89.5745 41.8372 89.4354 41.9412 89.418 42.1144C89.418 42.2704 89.5223 42.409 89.6963 42.4263C89.8006 42.4263 89.905 42.3916 89.9572 42.305L90.6355 42.357L90.1311 42.7208C90.1311 42.7208 90.0963 42.7208 90.0789 42.7208C89.9224 42.7208 89.7832 42.8248 89.7658 42.998C89.7658 43.154 89.8702 43.2926 90.0441 43.3099C90.2007 43.3099 90.3398 43.2059 90.3572 43.0327C90.3572 42.998 90.3572 42.9807 90.3572 42.9461L91.1225 42.3916L92.34 42.4783L91.6617 43.4831L90.7572 43.7603C90.7572 43.7603 90.7224 43.7257 90.6877 43.7084C90.5485 43.6217 90.3746 43.6564 90.2702 43.795C90.2354 43.847 90.218 43.8816 90.218 43.9336C90.218 44.0375 90.2702 44.1415 90.3572 44.1935C90.4268 44.2455 90.4963 44.2628 90.5833 44.2455C90.6529 44.2455 90.7225 44.1935 90.7746 44.1242C90.7746 44.1242 90.792 44.0895 90.8094 44.0722L91.4008 43.8989L91.0181 44.4534C90.9138 44.4534 90.8094 44.5053 90.7572 44.592C90.7225 44.6439 90.7051 44.6786 90.7051 44.7306C90.7051 44.8345 90.7398 44.9385 90.8268 44.9904C90.966 45.0771 91.1399 45.0424 91.2442 44.9038C91.2964 44.8172 91.3138 44.7132 91.2616 44.6093L91.6443 44.0549L91.7139 44.6786C91.7139 44.6786 91.6965 44.7132 91.6791 44.7306C91.6443 44.7652 91.6269 44.8172 91.6269 44.8692C91.6269 44.9731 91.6617 45.0771 91.7486 45.129C91.8878 45.2157 92.0617 45.181 92.1661 45.0424C92.2009 44.9904 92.2183 44.9558 92.2183 44.9038C92.2183 44.7999 92.1835 44.6959 92.0791 44.6439C92.0617 44.6439 92.0269 44.6093 92.0095 44.6093L91.9226 43.6737L92.6009 42.6688L93.1401 43.7603L92.914 44.6786C92.914 44.6786 92.8618 44.6786 92.8444 44.6959C92.7574 44.7479 92.6879 44.8345 92.6879 44.9385C92.6879 44.9904 92.6879 45.0424 92.7227 45.0944C92.7574 45.1637 92.8096 45.2157 92.8966 45.2503C92.9662 45.285 93.0531 45.2676 93.1227 45.2503C93.2097 45.1983 93.2792 45.1117 93.2792 45.0078C93.2792 44.9558 93.2792 44.9038 93.2444 44.8518C93.2444 44.8518 93.2444 44.8172 93.2097 44.7999L93.3488 44.1935L93.6445 44.7999C93.6445 44.7999 93.5749 44.9904 93.6445 45.0944C93.7141 45.233 93.888 45.3023 94.0445 45.233C94.1315 45.181 94.2011 45.0944 94.2011 44.9904C94.2011 44.9385 94.2011 44.8865 94.1663 44.8345C94.1141 44.7479 94.0271 44.6786 93.9228 44.6786L93.6271 44.0722L94.2011 44.3321C94.2011 44.3321 94.2011 44.3667 94.2185 44.3841C94.288 44.5227 94.462 44.592 94.6185 44.5227C94.7055 44.4707 94.775 44.3841 94.775 44.2801C94.775 44.2281 94.775 44.1762 94.7403 44.1242C94.7055 44.0549 94.6533 44.0029 94.5663 43.9682C94.4967 43.9509 94.4098 43.9509 94.3402 43.9682C94.3228 43.9682 94.288 44.0029 94.2706 44.0202L93.401 43.6391L92.8618 42.5476L94.0793 42.6342L94.775 43.2926C94.775 43.2926 94.775 43.3445 94.775 43.3619C94.775 43.5178 94.8794 43.6737 95.0533 43.6737C95.2099 43.6737 95.349 43.5698 95.3664 43.3965C95.3664 43.2406 95.262 43.102 95.0881 43.0847C95.0707 43.0847 95.0533 43.0847 95.0359 43.0847L94.5837 42.6515L95.262 42.7035C95.3142 42.7901 95.4012 42.8594 95.5055 42.8594C95.6621 42.8594 95.8012 42.7555 95.8186 42.5822C95.8186 42.4263 95.6969 42.2877 95.5403 42.2704C95.436 42.2704 95.3316 42.305 95.2794 42.3916L94.6011 42.3397L95.1055 41.9758C95.1055 41.9758 95.1403 41.9758 95.1577 41.9758C95.3142 41.9758 95.4534 41.8546 95.4708 41.6986C95.4708 41.5427 95.3664 41.4041 95.1925 41.3868C95.0359 41.3868 94.8968 41.4907 94.8794 41.664C94.8794 41.6986 94.8794 41.716 94.8794 41.7506L94.1141 42.305L92.8966 42.2184L93.5749 41.2135L94.4794 40.9363C94.4794 40.9363 94.5141 40.971 94.5315 40.9883C94.6707 41.0749 94.8446 41.0403 94.949 40.9017C94.9838 40.8497 95.0011 40.815 95.0011 40.7631C95.0011 40.6591 94.9664 40.5552 94.862 40.5032C94.7229 40.4166 94.5489 40.4512 94.4446 40.5898C94.4446 40.5898 94.4272 40.6245 94.4098 40.6418L93.8184 40.815L94.2011 40.2606C94.3054 40.2606 94.4098 40.2087 94.462 40.122C94.4968 40.0874 94.5141 40.0354 94.5141 39.9834C94.5141 39.8795 94.4794 39.7755 94.3924 39.7235C94.2532 39.6369 94.0793 39.6716 93.975 39.8102C93.9228 39.8968 93.9054 40.0007 93.9576 40.1047L93.5749 40.6591L93.5053 40.0354C93.5053 40.0354 93.5401 40.0007 93.5401 39.9834L93.5575 40.0007Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2277 39.0479C10.993 39.0998 11.5843 39.7755 11.5147 40.5552C11.4452 41.3175 10.7842 41.9065 10.0015 41.8372C9.23625 41.7679 8.64489 41.1096 8.71446 40.3299C8.76664 39.5503 9.44497 38.9786 10.2277 39.0479Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5245 32.291L23.9506 33.1226L23.5331 32.1871C23.481 32.1004 23.3766 32.0485 23.2722 32.1004C23.1679 32.1524 23.1331 32.2564 23.1679 32.3603L23.6027 33.2959L22.5765 33.2093C22.4722 33.2093 22.3852 33.2786 22.3678 33.3825C22.3678 33.4865 22.4374 33.5731 22.5417 33.5904L23.5679 33.6771L22.9939 34.526C22.9939 34.526 22.9592 34.7339 23.0461 34.7859C23.1331 34.8552 23.2548 34.8205 23.307 34.7339L23.881 33.9023L24.2984 34.8205C24.3506 34.9245 24.455 34.9591 24.5593 34.9245C24.6289 34.8898 24.6637 34.8378 24.6637 34.7685C24.6637 34.7339 24.6637 34.6992 24.6637 34.6819L24.2289 33.7464L25.255 33.833C25.3594 33.833 25.4464 33.7637 25.4638 33.6597C25.4638 33.5558 25.3942 33.4692 25.2898 33.4518L24.2636 33.3825L24.8376 32.5336C24.8376 32.5336 24.8724 32.4643 24.8724 32.447C24.8724 32.3777 24.855 32.3084 24.7854 32.2737C24.6985 32.2217 24.5767 32.2391 24.5245 32.3257V32.291Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2913 37.9392L37.4131 39.3252L38.0218 38.4416C38.0218 38.4416 38.1957 38.3377 38.2827 38.3896C38.3697 38.4416 38.3871 38.5629 38.3349 38.6495L37.7261 39.5331L39.0654 39.152C39.1698 39.1173 39.2567 39.1866 39.2915 39.2732C39.3263 39.3772 39.2567 39.4638 39.1698 39.4985L37.3957 40.0009L37.1522 40.3647L38.4914 39.9836C38.5958 39.9489 38.6827 40.0182 38.7175 40.1048C38.7523 40.2088 38.6827 40.2954 38.5958 40.3301L36.8217 40.8325L36.5782 41.1963L37.9348 40.8152C38.0218 40.7805 38.1262 40.8498 38.161 40.9365C38.1957 41.0404 38.1262 41.127 38.0392 41.1617L36.2651 41.6641L35.7085 42.4784L36.1434 43.3967L37.1348 43.466L38.648 42.4091C38.648 42.4091 38.8393 42.3745 38.9089 42.4611C38.961 42.5477 38.9436 42.6517 38.8567 42.721L37.7087 43.5179L38.1436 43.5526L39.6568 42.4957C39.6568 42.4957 39.8481 42.4611 39.9177 42.5477C39.9698 42.6343 39.9524 42.7383 39.8655 42.8076L38.7175 43.6046L39.1524 43.6392L40.6656 42.5824C40.6656 42.5824 40.8569 42.5477 40.9265 42.6343C40.9786 42.721 40.9612 42.8249 40.8743 42.8942L39.7263 43.6912L40.7873 43.7778C40.8917 43.7778 40.9612 43.8644 40.9612 43.9684C40.9612 44.0723 40.8743 44.1416 40.7699 44.1416L39.7089 44.055L40.7177 45.0252C40.7177 45.0252 40.7873 45.2158 40.7177 45.2851C40.6482 45.3544 40.5264 45.3544 40.4568 45.2851L39.135 44.003L38.7001 43.9684L39.7089 44.9386C39.7089 44.9386 39.7785 45.1292 39.7089 45.1985C39.6394 45.2678 39.5176 45.2678 39.448 45.1985L38.1262 43.9164L37.6913 43.8818L38.7001 44.852C38.7001 44.852 38.7697 45.0426 38.7001 45.1119C38.6306 45.1812 38.5088 45.1812 38.4392 45.1119L37.1174 43.8298L36.126 43.7605L35.552 44.6094L35.9868 45.493L37.6566 46.2553C37.7435 46.29 37.7957 46.4113 37.7435 46.4979C37.7087 46.5845 37.587 46.6365 37.5 46.5845L36.2303 45.9955L36.4216 46.3939L38.0914 47.1562C38.1784 47.1909 38.2131 47.3122 38.1783 47.3988C38.1436 47.4854 38.0218 47.5374 37.9348 47.4854L36.6651 46.8964L36.8565 47.2948L38.5262 48.0572C38.6132 48.0918 38.6654 48.2131 38.6132 48.2997C38.5784 48.3863 38.4566 48.4383 38.3697 48.3863L37.1 47.7973L37.5522 48.7502C37.6044 48.8368 37.5522 48.9408 37.4652 48.9927C37.3783 49.0447 37.2739 48.9927 37.2217 48.9061L36.7521 47.9532L36.4043 49.3046C36.3869 49.4085 36.2825 49.4605 36.1781 49.4432C36.0738 49.4259 36.0216 49.3219 36.039 49.218L36.4912 47.4335L36.2999 47.035L35.952 48.3863C35.9346 48.4903 35.8303 48.5423 35.7259 48.5249C35.6216 48.5076 35.5694 48.4037 35.5868 48.2997L36.039 46.5152L35.8477 46.1167L35.4998 47.4681C35.4824 47.5721 35.3781 47.624 35.2737 47.6067C35.1693 47.5894 35.1172 47.4854 35.1346 47.3815L35.5868 45.597L35.1693 44.7307L34.1258 44.6441L33.5692 45.441L33.7431 47.2602C33.7431 47.3642 33.6735 47.4508 33.5866 47.4508C33.4822 47.4508 33.3953 47.3815 33.3953 47.2948L33.2735 45.9088L33.03 46.2727L33.1865 48.0918C33.1865 48.1958 33.117 48.2824 33.03 48.2824C32.9256 48.2824 32.8387 48.2131 32.8387 48.1265L32.7169 46.7404L32.4734 47.1043L32.63 48.9234C32.63 49.0274 32.5604 49.114 32.4734 49.114C32.3691 49.114 32.2821 49.0447 32.2821 48.9581L32.1603 47.5721L31.5516 48.4556C31.5516 48.4556 31.3777 48.5596 31.2907 48.5076C31.2037 48.4556 31.1863 48.3344 31.2385 48.2477L31.8473 47.3641L30.508 47.7453C30.4036 47.78 30.3167 47.7107 30.2819 47.624C30.2471 47.5201 30.3167 47.4335 30.4036 47.3988L32.1777 46.8964L32.4212 46.5325L31.082 46.9137C30.9776 46.9483 30.8906 46.879 30.8559 46.7924C30.8211 46.6885 30.8906 46.6018 30.9776 46.5672L32.7517 46.0648L32.9952 45.7009L31.6559 46.0821C31.5516 46.1167 31.4646 46.0474 31.4298 45.9608C31.395 45.8568 31.4646 45.7702 31.5516 45.7356L33.3257 45.2331L33.8649 44.4535L33.3953 43.5006L32.456 43.4313L30.9428 44.4881C30.9428 44.4881 30.7515 44.5228 30.6819 44.4535C30.6298 44.3669 30.6471 44.2629 30.7341 44.1936L31.8821 43.3967L31.4472 43.362L29.934 44.4188C29.934 44.4188 29.7427 44.4535 29.6731 44.3669C29.621 44.2802 29.6383 44.1763 29.7253 44.107L30.8733 43.31L30.4384 43.2754L28.9252 44.3322C28.9252 44.3322 28.7339 44.3669 28.6643 44.2802C28.6122 44.1936 28.6295 44.0897 28.7165 44.0204L29.8645 43.2234L28.8035 43.1368C28.6991 43.1368 28.6295 43.0501 28.6295 42.9462C28.6295 42.8422 28.7165 42.7729 28.8209 42.7729L29.8818 42.8596L28.873 41.8894C28.873 41.8894 28.8035 41.6988 28.873 41.6295C28.9426 41.5602 29.0644 41.5602 29.1339 41.6295L30.4558 42.9115L30.8906 42.9462L29.8818 41.976C29.8818 41.976 29.8123 41.7854 29.8818 41.7161C29.9514 41.6468 30.0732 41.6468 30.1427 41.7161L31.4646 42.9982L31.8994 43.0328L30.8906 42.0626C30.8906 42.0626 30.8211 41.872 30.8906 41.8027C30.9602 41.7334 31.082 41.7334 31.1515 41.8027L32.4734 43.0848L33.4126 43.1541L34.0214 42.2705L33.604 41.4216L31.9342 40.6419C31.8473 40.6073 31.7951 40.486 31.8473 40.3994C31.8821 40.3127 32.0038 40.2608 32.0908 40.3127L33.3605 40.9018L33.1691 40.5033L31.4994 39.7237C31.4124 39.689 31.3603 39.5678 31.4124 39.4811C31.4646 39.3945 31.569 39.3425 31.6559 39.3945L32.9256 39.9836L32.7343 39.5851L31.0646 38.8054C30.9776 38.7708 30.9254 38.6495 30.9776 38.5629C31.0124 38.4763 31.1342 38.4243 31.2211 38.4763L32.4908 39.0653L32.0386 38.1124C31.9864 38.0258 32.0386 37.9219 32.1256 37.8699C32.2125 37.8352 32.3169 37.8699 32.3691 37.9565L32.8213 38.9094L33.1691 37.558C33.1865 37.4541 33.2909 37.4021 33.3953 37.4194C33.4996 37.4367 33.5518 37.5407 33.5344 37.6447L33.0822 39.4292L33.2735 39.8276L33.604 38.4763C33.6214 38.3723 33.7257 38.3203 33.8301 38.3377C33.9344 38.355 33.9866 38.4589 33.9692 38.5629L33.517 40.3474L33.7083 40.7459L34.0562 39.3945C34.0736 39.2906 34.1779 39.2386 34.2823 39.2559C34.3867 39.2732 34.4388 39.3772 34.4214 39.4811L33.9692 41.2656L34.3867 42.1319L35.4302 42.2185L35.9868 41.4216L35.8129 39.6024C35.8129 39.4985 35.8825 39.4118 35.9694 39.4118C36.0738 39.4118 36.1608 39.4811 36.1608 39.5678L36.2825 40.9538L36.526 40.59L36.3521 38.7708C36.3521 38.6668 36.4216 38.5802 36.5086 38.5802C36.613 38.5802 36.6999 38.6495 36.6999 38.7361L36.8217 40.1222L37.0652 39.7583L36.8913 37.9392C36.8913 37.8352 36.9608 37.7486 37.0478 37.7486C37.1348 37.7486 37.2391 37.8179 37.2391 37.9045L37.2913 37.9392ZM34.3171 42.5304L33.7257 43.3967L34.1779 44.3322L35.2215 44.4188L35.8129 43.5526L35.3607 42.617L34.3171 42.5304Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4137 58.5735L45.0832 59.4571L44.4919 58.7294C44.4919 58.7294 44.3179 58.6428 44.2484 58.6948C44.1788 58.7641 44.1614 58.868 44.2136 58.9373L44.8223 59.6823L43.8657 59.8556C43.7613 59.8556 43.7092 59.9595 43.7266 60.0635C43.7266 60.1674 43.8309 60.2194 43.9353 60.2021L44.8745 60.0288L44.544 60.9297C44.5093 61.0163 44.544 61.1203 44.6484 61.155C44.7354 61.1896 44.8397 61.155 44.8745 61.051L45.205 60.1674L45.7963 60.8951C45.7963 60.8951 45.9703 60.9817 46.0398 60.9297C46.092 60.8777 46.1094 60.8258 46.1094 60.7565C46.1094 60.7218 46.092 60.7045 46.0746 60.6698L45.4659 59.9249L46.4225 59.7516C46.5268 59.7516 46.579 59.6477 46.5616 59.5437C46.5616 59.4397 46.4573 59.3878 46.3529 59.4051L45.4137 59.5784L45.7442 58.6774C45.7442 58.6774 45.7442 58.6081 45.7442 58.5908C45.7442 58.5215 45.692 58.4695 45.6224 58.4522C45.5354 58.4176 45.4311 58.4522 45.3963 58.5562L45.4137 58.5735Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5036 61.2244L73.0861 62.2465L72.4078 61.363C72.3382 61.2763 72.1991 61.259 72.1121 61.3283C72.0252 61.3976 72.0078 61.5362 72.0773 61.6228L72.7557 62.5238L71.6251 62.6797C71.5034 62.6797 71.4338 62.801 71.4512 62.9222C71.4512 63.0435 71.5729 63.1128 71.6947 63.0955L72.8079 62.9396L72.3904 63.9791C72.3382 64.083 72.3904 64.2043 72.5122 64.2563C72.6165 64.3083 72.7383 64.2563 72.7905 64.135L73.2079 63.1128L73.8862 63.9964C73.9558 64.083 74.0949 64.1004 74.1819 64.0311C74.2515 63.9791 74.2689 63.9098 74.2689 63.8405C74.2689 63.8058 74.2515 63.7712 74.2341 63.7538L73.5558 62.8529L74.6689 62.697C74.7907 62.697 74.8602 62.5757 74.8428 62.4545C74.8428 62.3332 74.7211 62.2639 74.5993 62.2812L73.4862 62.4371L73.9036 61.3976C73.9036 61.3976 73.921 61.3283 73.9036 61.2937C73.9036 61.2244 73.8514 61.1551 73.7819 61.1204C73.6775 61.0858 73.5558 61.1204 73.5036 61.2417V61.2244Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12_16505",
    x: 0.621155,
    y: 0.460682,
    width: 101.442,
    height: 105.203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.78429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.12204
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12_16505"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12_16505",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_16505",
    x1: 61.0504,
    y1: 55.1257,
    x2: 61.0852,
    y2: 55.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_16505",
    x1: 6.871,
    y1: 56.3732,
    x2: 64.2855,
    y2: 56.3732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_16505",
    x1: 6.87098,
    y1: 57.6206,
    x2: 67.4859,
    y2: 57.6206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12_16505",
    x1: 6.87096,
    y1: 58.868,
    x2: 70.6688,
    y2: 58.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12_16505",
    x1: 6.87096,
    y1: 60.1155,
    x2: 73.8691,
    y2: 60.1155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12_16505",
    x1: 6.87096,
    y1: 61.363,
    x2: 77.0694,
    y2: 61.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12_16505",
    x1: 6.87096,
    y1: 62.6104,
    x2: 80.2698,
    y2: 62.6104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12_16505",
    x1: 6.87096,
    y1: 63.8579,
    x2: 83.4701,
    y2: 63.8579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12_16505",
    x1: 6.87096,
    y1: 64.9667,
    x2: 86.6704,
    y2: 64.9667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12_16505",
    x1: 63.4854,
    y1: 63.6152,
    x2: 88.6531,
    y2: 63.6152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12_16505",
    x1: 66.8423,
    y1: 64.6892,
    x2: 88.6533,
    y2: 64.6892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12_16505",
    x1: 70.2164,
    y1: 65.7809,
    x2: 88.6531,
    y2: 65.7809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12_16505",
    x1: 73.5734,
    y1: 66.855,
    x2: 88.6532,
    y2: 66.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_12_16505",
    x1: 76.9304,
    y1: 67.9466,
    x2: 88.6533,
    y2: 67.9466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_12_16505",
    x1: 80.2874,
    y1: 69.0206,
    x2: 88.6535,
    y2: 69.0206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_12_16505",
    x1: 83.6439,
    y1: 70.1122,
    x2: 88.6531,
    y2: 70.1122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_12_16505",
    x1: 87.0184,
    y1: 71.1863,
    x2: 88.6534,
    y2: 71.1863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_12_16505",
    x1: 59.3283,
    y1: 54.8313,
    x2: 60.4415,
    y2: 54.8313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_12_16505",
    x1: 55.9713,
    y1: 55.9574,
    x2: 60.4413,
    y2: 55.9574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_12_16505",
    x1: 52.6148,
    y1: 57.0834,
    x2: 60.4417,
    y2: 57.0834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_12_16505",
    x1: 49.2578,
    y1: 58.2097,
    x2: 60.4416,
    y2: 58.2097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_12_16505",
    x1: 45.9008,
    y1: 59.3359,
    x2: 60.4414,
    y2: 59.3359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_12_16505",
    x1: 42.5438,
    y1: 60.4621,
    x2: 60.4413,
    y2: 60.4621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_12_16505",
    x1: 39.1873,
    y1: 61.5881,
    x2: 60.4416,
    y2: 61.5881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_12_16505",
    x1: 35.8303,
    y1: 62.7143,
    x2: 60.4415,
    y2: 62.7143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_12_16505",
    x1: 32.4733,
    y1: 63.8578,
    x2: 60.4414,
    y2: 63.8578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_12_16505",
    x1: 29.1163,
    y1: 64.9838,
    x2: 60.4413,
    y2: 64.9838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_12_16505",
    x1: 25.7769,
    y1: 66.11,
    x2: 60.4413,
    y2: 66.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_12_16505",
    x1: 22.4204,
    y1: 67.2362,
    x2: 60.4417,
    y2: 67.2362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_12_16505",
    x1: 19.0634,
    y1: 68.3622,
    x2: 60.4415,
    y2: 68.3622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_12_16505",
    x1: 15.7064,
    y1: 69.3498,
    x2: 60.4414,
    y2: 69.3498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_12_16505",
    x1: 13.6191,
    y1: 69.0207,
    x2: 57.8323,
    y2: 69.0207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_12_16505",
    x1: 13.6193,
    y1: 70.1296,
    x2: 54.4235,
    y2: 70.1296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_12_16505",
    x1: 13.6193,
    y1: 71.221,
    x2: 50.9971,
    y2: 71.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_12_16505",
    x1: 13.6193,
    y1: 72.3126,
    x2: 47.588,
    y2: 72.3126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_12_16505",
    x1: 13.6193,
    y1: 73.4213,
    x2: 44.179,
    y2: 73.4213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_12_16505",
    x1: 13.6193,
    y1: 74.5128,
    x2: 40.7525,
    y2: 74.5128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_12_16505",
    x1: 13.6193,
    y1: 75.6215,
    x2: 37.3435,
    y2: 75.6215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_12_16505",
    x1: 13.6193,
    y1: 76.7131,
    x2: 33.9171,
    y2: 76.7131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_12_16505",
    x1: 13.654,
    y1: 77.8218,
    x2: 30.5079,
    y2: 77.8218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_12_16505",
    x1: 13.6715,
    y1: 78.9307,
    x2: 27.099,
    y2: 78.9307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_12_16505",
    x1: 13.7061,
    y1: 80.0395,
    x2: 23.6724,
    y2: 80.0395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_12_16505",
    x1: 13.7413,
    y1: 81.1657,
    x2: 20.2637,
    y2: 81.1657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_12_16505",
    x1: 13.7759,
    y1: 82.2746,
    x2: 16.8371,
    y2: 82.2746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_12_16505",
    x1: 19.9156,
    y1: 84.5615,
    x2: 36.0107,
    y2: 63.1043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_12_16505",
    x1: 69.9554,
    y1: 34.474,
    x2: 80.222,
    y2: 46.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26F3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48E1E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_12_16505",
    x1: 21.6896,
    y1: 32.1004,
    x2: 99.1062,
    y2: 32.1004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD682"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_12_16505",
    x1: 65.9202,
    y1: 37.194,
    x2: 67.5625,
    y2: 40.2832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F6C926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F2C31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EBB503"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_12_16505",
    x1: 72.721,
    y1: 33.6597,
    x2: 74.9166,
    y2: 37.7556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_12_16505",
    x1: 39.6393,
    y1: 37.4714,
    x2: 38.9661,
    y2: 42.7216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFD682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_12_16505",
    x1: 57.3629,
    y1: 37.6272,
    x2: 64.364,
    y2: 51.0941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFD682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_12_16505",
    x1: 67.1297,
    y1: 36.8334,
    x2: 76.2838,
    y2: 37.3022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFD682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_12_16505",
    x1: 79.981,
    y1: 30.0616,
    x2: 89.1351,
    y2: 30.5304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFD682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_12_16505",
    x1: 21.4279,
    y1: 35.0077,
    x2: 28.6077,
    y2: 40.6838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFD682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_12_16505",
    x1: 58.4413,
    y1: 47.8318,
    x2: 63.4157,
    y2: 47.8318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFD682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_12_16505",
    x1: 42.6478,
    y1: 22.6235,
    x2: 53.3271,
    y2: 22.6235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_12_16505",
    x1: 33.8994,
    y1: 24.8759,
    x2: 58.2497,
    y2: 24.8759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_12_16505",
    x1: 28.2636,
    y1: 26.8509,
    x2: 63.2063,
    y2: 26.8509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_12_16505",
    x1: 20.3849,
    y1: 28.982,
    x2: 69.0333,
    y2: 28.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_12_16505",
    x1: 13.5667,
    y1: 30.8184,
    x2: 75.3817,
    y2: 30.8184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_12_16505",
    x1: 19.6889,
    y1: 31.5635,
    x2: 80.8777,
    y2: 31.5635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_12_16505",
    x1: 26.8029,
    y1: 32.4123,
    x2: 85.835,
    y2: 32.4123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_12_16505",
    x1: 33.3252,
    y1: 33.6597,
    x2: 85.3653,
    y2: 33.6597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_12_16505",
    x1: 39.2561,
    y1: 35.4617,
    x2: 80.8604,
    y2: 35.4617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_12_16505",
    x1: 44.6656,
    y1: 37.2981,
    x2: 76.2862,
    y2: 37.2981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_12_16505",
    x1: 50.127,
    y1: 39.1,
    x2: 71.6075,
    y2: 39.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_12_16505",
    x1: 58.1277,
    y1: 40.7458,
    x2: 66.8068,
    y2: 40.7458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_12_16505",
    x1: 57.9888,
    y1: 44.1067,
    x2: 60.7022,
    y2: 44.1067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_12_16505",
    x1: 54.7538,
    y1: 45.3023,
    x2: 60.7196,
    y2: 45.3023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_12_16505",
    x1: 51.5363,
    y1: 46.5151,
    x2: 60.7373,
    y2: 46.5151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_12_16505",
    x1: 48.3008,
    y1: 47.7106,
    x2: 60.7717,
    y2: 47.7106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_12_16505",
    x1: 45.0658,
    y1: 47.5199,
    x2: 58.9281,
    y2: 47.5199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_12_16505",
    x1: 41.8483,
    y1: 47.0521,
    x2: 55.5889,
    y2: 47.0521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_12_16505",
    x1: 38.6133,
    y1: 46.5844,
    x2: 52.2669,
    y2: 46.5844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_12_16505",
    x1: 35.3778,
    y1: 46.1167,
    x2: 48.9444,
    y2: 46.1167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_12_16505",
    x1: 32.1603,
    y1: 45.6487,
    x2: 45.6226,
    y2: 45.6487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_12_16505",
    x1: 28.9253,
    y1: 45.181,
    x2: 42.2831,
    y2: 45.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_12_16505",
    x1: 25.6902,
    y1: 44.7132,
    x2: 38.9612,
    y2: 44.7132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_12_16505",
    x1: 22.4723,
    y1: 44.2455,
    x2: 35.6215,
    y2: 44.2455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_12_16505",
    x1: 19.2373,
    y1: 43.7776,
    x2: 32.2995,
    y2: 43.7776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_12_16505",
    x1: 16.0022,
    y1: 43.3271,
    x2: 28.9775,
    y2: 43.3271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_12_16505",
    x1: 12.7843,
    y1: 42.8594,
    x2: 25.6378,
    y2: 42.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_12_16505",
    x1: 12.193,
    y1: 43.2406,
    x2: 22.3158,
    y2: 43.2406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_12_16505",
    x1: 12.2276,
    y1: 44.4013,
    x2: 18.9935,
    y2: 44.4013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_12_16505",
    x1: 12.2798,
    y1: 45.5622,
    x2: 15.6541,
    y2: 45.5622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_12_16505",
    x1: 58.0064,
    y1: 72.4163,
    x2: 62.9808,
    y2: 72.4163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFD682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_12_16505",
    x1: 61.4847,
    y1: 44.5053,
    x2: 64.7199,
    y2: 44.5053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_12_16505",
    x1: 6.87048,
    y1: 45.9953,
    x2: 67.9202,
    y2: 45.9953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_12_16505",
    x1: 61.4847,
    y1: 46.4113,
    x2: 71.1205,
    y2: 46.4113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_12_16505",
    x1: 61.485,
    y1: 44.6094,
    x2: 74.3211,
    y2: 44.6094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_12_16505",
    x1: 61.4847,
    y1: 42.8595,
    x2: 77.5211,
    y2: 42.8595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_12_16505",
    x1: 61.4849,
    y1: 41.023,
    x2: 80.7217,
    y2: 41.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_12_16505",
    x1: 61.485,
    y1: 39.1345,
    x2: 83.9046,
    y2: 39.1345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_12_16505",
    x1: 61.4845,
    y1: 37.2288,
    x2: 87.1046,
    y2: 37.2288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_12_16505",
    x1: 63.9199,
    y1: 35.0631,
    x2: 89.0877,
    y2: 35.0631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_12_16505",
    x1: 67.2941,
    y1: 34.3529,
    x2: 89.0876,
    y2: 34.3529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_12_16505",
    x1: 70.6681,
    y1: 35.7041,
    x2: 89.0874,
    y2: 35.7041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFCC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E37A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EB8359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_12_16505",
    x1: 57.8846,
    y1: 43.9336,
    x2: 58.9738,
    y2: 45.9123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A0033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_12_16505",
    x1: 59.2409,
    y1: 43.2751,
    x2: 60.3475,
    y2: 45.2539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FF6363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF7676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E85B67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C63450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#AE1740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#9F0636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A0033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_12_16505",
    x1: 73.4686,
    y1: 40.4164,
    x2: 71.621,
    y2: 33.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_12_16505",
    x1: 76.1122,
    y1: 61.8303,
    x2: 76.1122,
    y2: 84.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_12_16505",
    x1: 76.947,
    y1: 30.7661,
    x2: 80.9592,
    y2: 37.4502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_12_16505",
    x1: 78.6693,
    y1: 49.824,
    x2: 81.293,
    y2: 67.3083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFFF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_12_16505",
    x1: 73.051,
    y1: 79.0691,
    x2: 70.4274,
    y2: 61.5849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFFF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_12_16505",
    x1: 35.2385,
    y1: 26.0884,
    x2: 70.7795,
    y2: 37.9875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A0033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_12_16505",
    x1: 46.1966,
    y1: 39.2732,
    x2: 45.886,
    y2: 42.8424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF7676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FF6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FF5353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FF2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2323"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_12_16505",
    x1: 39.0134,
    y1: 37.5578,
    x2: 37.0963,
    y2: 43.2797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_12_16505",
    x1: 34.1431,
    y1: 36.9342,
    x2: 29.6092,
    y2: 43.1016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_12_16505",
    x1: 50.9621,
    y1: 28.8779,
    x2: 61.9469,
    y2: 21.8222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A0033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_12_16505",
    x1: 33.8475,
    y1: 52.4058,
    x2: 33.0881,
    y2: 86.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A0033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_12_16505",
    x1: 34.0969,
    y1: 45.7821,
    x2: 23.2711,
    y2: 64.5232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFFF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_12_16505",
    x1: 32.829,
    y1: 85.3962,
    x2: 43.8023,
    y2: 66.3999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFFF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.5058 32.1259) scale(23.0462 6.98158)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000035",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_12_16505",
    x1: 52.6144,
    y1: 39.8101,
    x2: 51.786,
    y2: 28.7908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#000035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_12_16505",
    x1: 50.9969,
    y1: 29.1031,
    x2: 51.1004,
    y2: 30.9223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_12_16505",
    x1: 32.7672,
    y1: 24.9908,
    x2: 48.8338,
    y2: 31.8788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FF2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FF7676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DF5161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A40331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#C00D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#ED1C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2323"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_12_16505",
    x1: 46.3849,
    y1: 20.5704,
    x2: 39.1416,
    y2: 29.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A0033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_12_16505",
    x1: 44.9575,
    y1: 21.8561,
    x2: 40.1835,
    y2: 28.8674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_12_16505",
    x1: 39.7784,
    y1: 25.3435,
    x2: 32.7382,
    y2: 27.3155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#850033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#620034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#490034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3A0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_12_16505",
    x1: 34.9855,
    y1: 24.892,
    x2: 40.8103,
    y2: 28.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_12_16505",
    x1: 32.8238,
    y1: 30.9703,
    x2: 36.9417,
    y2: 33.6021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_12_16505",
    x1: 38.3172,
    y1: 20.1637,
    x2: 42.1747,
    y2: 22.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFFF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_12_16505",
    x1: 37.4225,
    y1: 17.7041,
    x2: 46.105,
    y2: 18.6695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF7676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DF5161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8F0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#730033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#680034"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_12_16505",
    x1: 38.7867,
    y1: 14.3428,
    x2: 44.2962,
    y2: 13.5148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C9A100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#826800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4A3B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#221B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#090700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_12_16505",
    x1: 39.0022,
    y1: 24.5645,
    x2: 43.964,
    y2: 18.2371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_12_16505",
    x1: 41.3612,
    y1: 21.8437,
    x2: 36.7532,
    y2: 22.6816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#850033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#620034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#490034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3A0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_12_16505",
    x1: 38.2171,
    y1: 18.572,
    x2: 43.3492,
    y2: 18.6504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C9A100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#826800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4A3B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#221B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#090700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_12_16505",
    x1: 45.1009,
    y1: 13.9078,
    x2: 51.283,
    y2: 30.3593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FF2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FF7676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DF5161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8F0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#730033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#680034"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_12_16505",
    x1: 44.3879,
    y1: 22.6927,
    x2: 48.4136,
    y2: 32.3367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#8F0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#710033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#420034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_12_16505",
    x1: 57.0366,
    y1: 22.8361,
    x2: 45.3559,
    y2: 21.4971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A0033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_12_16505",
    x1: 55.415,
    y1: 19.7656,
    x2: 47.6177,
    y2: 23.1526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_12_16505",
    x1: 50.0408,
    y1: 22.3115,
    x2: 46.7535,
    y2: 22.3115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#850033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#620034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#490034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3A0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_12_16505",
    x1: 47.3341,
    y1: 15.4489,
    x2: 47.2217,
    y2: 22.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_12_16505",
    x1: 41.0244,
    y1: 16.8163,
    x2: 40.9436,
    y2: 21.6876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_12_16505",
    x1: 53.1409,
    y1: 15.7871,
    x2: 53.5433,
    y2: 20.0496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFFF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_12_16505",
    x1: 51.3771,
    y1: 12.4525,
    x2: 57.3216,
    y2: 19.4094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF7676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DF5161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8F0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#730033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#680034"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_12_16505",
    x1: 54.8216,
    y1: 10.8539,
    x2: 59.6432,
    y2: 14.1582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C9A100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#826800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4A3B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#221B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#090700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_12_16505",
    x1: 52.9797,
    y1: 19.2967,
    x2: 50.2653,
    y2: 14.3501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#850033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#620034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#490034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3A0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_12_16505",
    x1: 53.1017,
    y1: 13.77,
    x2: 49.7312,
    y2: 20.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#850033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#620034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#490034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3A0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_12_16505",
    x1: 51.354,
    y1: 13.6998,
    x2: 55.2145,
    y2: 17.4303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C9A100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#826800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4A3B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#221B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#090700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_12_16505",
    x1: 57.6596,
    y1: 13.7381,
    x2: 49.6902,
    y2: 28.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FF2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FF7676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DF5161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8F0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#730033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#680034"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_12_16505",
    x1: 49.5135,
    y1: 31.9743,
    x2: 52.8834,
    y2: 20.0096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_12_16505",
    x1: 50.1907,
    y1: 30.1532,
    x2: 42.2384,
    y2: 20.5785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_12_16505",
    x1: 53.1534,
    y1: 11.3194,
    x2: 45.1534,
    y2: 26.2499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_12_16505",
    x1: 57.7964,
    y1: 25.6175,
    x2: 51.908,
    y2: 19.0612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A0033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_12_16505",
    x1: 58.4619,
    y1: 22.5066,
    x2: 52.3336,
    y2: 19.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_12_16505",
    x1: 57.9367,
    y1: 21.9998,
    x2: 56.0517,
    y2: 18.8747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_12_16505",
    x1: 57.2022,
    y1: 15.6079,
    x2: 52.7164,
    y2: 20.8459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_12_16505",
    x1: 52.5965,
    y1: 13.5952,
    x2: 49.4311,
    y2: 17.2881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_12_16505",
    x1: 60.3408,
    y1: 18.614,
    x2: 58.106,
    y2: 22.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#23FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#1BC9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#118282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#042222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#010909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_12_16505",
    x1: 59.8188,
    y1: 18.4018,
    x2: 57.571,
    y2: 21.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#23FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#1BC9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#118282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#042222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#010909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_12_16505",
    x1: 59.3049,
    y1: 18.147,
    x2: 57.0571,
    y2: 21.7392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#23FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#1BC9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#118282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#042222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#010909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_12_16505",
    x1: 58.7695,
    y1: 17.9465,
    x2: 56.5347,
    y2: 21.5265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#23FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#1BC9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#118282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#042222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#010909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_12_16505",
    x1: 70.9622,
    y1: 26.2983,
    x2: 53.7281,
    y2: 29.9639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#B21940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FF6868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FF4343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FF2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E01B26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AC0F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#870730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#700133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#680034"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_12_16505",
    x1: 72.1123,
    y1: 27.2317,
    x2: 64.5038,
    y2: 30.5974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#890033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#6B0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#530034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#420034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#380034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_12_16505",
    x1: 55.8172,
    y1: 21.3753,
    x2: 63.2295,
    y2: 30.4671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A0033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_12_16505",
    x1: 67.9204,
    y1: 21.6703,
    x2: 60.3726,
    y2: 26.7218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_12_16505",
    x1: 63.259,
    y1: 29.4495,
    x2: 59.8476,
    y2: 25.5554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#850033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#620034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#490034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3A0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_12_16505",
    x1: 67.2887,
    y1: 25.504,
    x2: 61.5286,
    y2: 29.3511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_12_16505",
    x1: 69.5531,
    y1: 31.5451,
    x2: 65.5052,
    y2: 34.2488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_12_16505",
    x1: 63.8768,
    y1: 20.8328,
    x2: 60.0523,
    y2: 22.7942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFFF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_12_16505",
    x1: 39.9475,
    y1: 27.9326,
    x2: 45.324,
    y2: 35.3552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF7676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DF5161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8F0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#730033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#680034"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_12_16505",
    x1: 37.5877,
    y1: 30.9258,
    x2: 39.6669,
    y2: 36.3753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C9A100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#826800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4A3B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#221B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#090700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_12_16505",
    x1: 49.9186,
    y1: 28.4099,
    x2: 38.792,
    y2: 31.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_12_16505",
    x1: 48.8225,
    y1: 28.8085,
    x2: 37.0874,
    y2: 31.7232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#850033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#620034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#490034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3A0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_12_16505",
    x1: 41.169,
    y1: 28.2226,
    x2: 43.8869,
    y2: 32.8459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C9A100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#826800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4A3B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#221B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#090700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_12_16505",
    x1: 40.0215,
    y1: 36.7261,
    x2: 45.4482,
    y2: 36.7261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFFF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_12_16505",
    x1: 57.4365,
    y1: 21.1971,
    x2: 58.1659,
    y2: 29.3277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF7676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DF5161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8F0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#730033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#680034"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_12_16505",
    x1: 60.9281,
    y1: 21.8046,
    x2: 62.7174,
    y2: 26.6951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C9A100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#826800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4A3B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#221B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#090700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_12_16505",
    x1: 57.346,
    y1: 28.3234,
    x2: 52.9608,
    y2: 24.3909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_12_16505",
    x1: 55.4845,
    y1: 24.7544,
    x2: 52.6658,
    y2: 29.5285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#850033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#620034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#490034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3A0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_12_16505",
    x1: 56.9325,
    y1: 22.0909,
    x2: 57.8018,
    y2: 26.7883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C9A100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#826800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4A3B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#221B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#090700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_12_16505",
    x1: 60.6287,
    y1: 28.0138,
    x2: 55.9484,
    y2: 35.2991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF7676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DF5161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8F0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#730033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#680034"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_12_16505",
    x1: 63.1661,
    y1: 30.7952,
    x2: 61.5177,
    y2: 35.9246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C9A100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#826800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4A3B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#221B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#090700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_12_16505",
    x1: 53.5349,
    y1: 26.3786,
    x2: 57.0298,
    y2: 33.7333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#850033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#620034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#490034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3A0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_12_16505",
    x1: 59.7977,
    y1: 31.546,
    x2: 55.3492,
    y2: 29.8888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#850033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#620034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#490034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3A0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_12_16505",
    x1: 59.3833,
    y1: 28.5133,
    x2: 57.0935,
    y2: 32.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C9A100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#826800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4A3B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#221B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#090700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_12_16505",
    x1: 55.7454,
    y1: 36.3625,
    x2: 62.3548,
    y2: 36.3625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFFF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_12_16505",
    x1: 50.2139,
    y1: 28.3581,
    x2: 50.2139,
    y2: 38.3894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FF2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FF7676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#DF5161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#8F0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#730033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#680034"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_12_16505",
    x1: 47.4661,
    y1: 29.6574,
    x2: 45.1682,
    y2: 35.2252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C9A100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#826800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4A3B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#221B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#090700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_12_16505",
    x1: 53.0143,
    y1: 29.848,
    x2: 54.6213,
    y2: 33.5082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C9A100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#826800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4A3B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#221B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#090700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_12_16505",
    x1: 50.1098,
    y1: 30.2985,
    x2: 50.1098,
    y2: 27.9942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#850033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#620034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#490034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3A0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_12_16505",
    x1: 46.1443,
    y1: 36.6395,
    x2: 54.7017,
    y2: 36.6395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFFF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_12_16505",
    x1: 37.8478,
    y1: 31.4419,
    x2: 39.9758,
    y2: 34.5336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_12_16505",
    x1: 54.2095,
    y1: 11.3091,
    x2: 56.6469,
    y2: 12.9435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_12_16505",
    x1: 32.9432,
    y1: 27.3705,
    x2: 35.9807,
    y2: 29.2001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_12_16505",
    x1: 69.2769,
    y1: 28.4967,
    x2: 66.2568,
    y2: 30.3263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_12_16505",
    x1: 61.0122,
    y1: 22.2181,
    x2: 61.2926,
    y2: 25.0717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_12_16505",
    x1: 54.1285,
    y1: 18.6596,
    x2: 56.4241,
    y2: 16.9296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_12_16505",
    x1: 43.8484,
    y1: 16.6289,
    x2: 44.3835,
    y2: 20.0946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_12_16505",
    x1: 50.11,
    y1: 30.5409,
    x2: 50.2136,
    y2: 33.7981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_12_16505",
    x1: 38.2999,
    y1: 14.5324,
    x2: 40.5958,
    y2: 14.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_12_16505",
    x1: 70.0988,
    y1: 32.315,
    x2: 68.8508,
    y2: 34.4959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_12_16505",
    x1: 35.4826,
    y1: 22.0864,
    x2: 38.4568,
    y2: 22.0864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3328 19.3316) scale(1.60016 1.59393)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.0901 17.7377) scale(3.46122 3.44774)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint196_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.654 25.6901) scale(4.73092 4.71248)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.3016 36.4318) scale(1.56538 1.55928)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.3631 14.8443) scale(3.40905 3.39576)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.6279 63.7711) scale(2.27849 2.26962)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.1988 10.0625) scale(1.63495 1.62858)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.6084 22.0344) scale(5.65275 5.63073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.076 6.49353) scale(1.93063 1.92311)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9338 10.877) scale(1.32187 1.31672)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.892 7.2733) scale(1.40884 1.40335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.9573 50.9331) scale(5.73972 5.71735)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.5902 15.3295) scale(3.04379 3.03193)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.848 8.50345) scale(4.17434 4.15807)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.3234 33.9714) scale(1.40884 1.40335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint209_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.7067 30.9569) scale(1.4958 1.48998)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint210_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2464 27.3706) scale(3.23511 3.22251)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint211_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.463 38.528) scale(4.41784 4.40063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint212_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.125 64.0277) rotate(-29.8134) scale(1.30322 0.624315)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint213_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.9437 57.2742) scale(1.39145 1.38603)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint214_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.9925 52.5083) rotate(-0.328714) scale(3.04379 3.03193)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint215_radial_12_16505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.9463 60.1153) scale(1.63495 1.62858)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftSuper);
export default __webpack_public_path__ + "static/media/gift-super.55a28014f9f84b389b2be16bc45fe04b.svg";
export { ForwardRef as ReactComponent };